var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorldMapOutlinemin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1326,
    height: 644,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M372.555 169.45l135.154 38.035-158.293 83.478 77.437-157.952 160.497-7.257-43.696-40.656 135.458 21.924",
    stroke: "url(#prefix__paint0_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M534.99 238.186l116.498 94.801",
    stroke: "url(#prefix__paint1_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M711.865 331.126l53.917-11.817",
    stroke: "url(#prefix__paint2_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.85 307.264l-62.43-32.905-17.25 50.383-19.57-31.537-188.845-97.195-67.444 99.171 177.862-59.389-223.876 21.582",
    stroke: "url(#prefix__paint3_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M636.978 273.674l-218.404 21.734",
    stroke: "url(#prefix__paint4_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.656 300.691l362.64-141.082",
    stroke: "url(#prefix__paint5_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M780.411 218.656l277.449 120.791",
    stroke: "url(#prefix__paint6_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.945 268.24c-7.219 2.166-14.439 4.484-21.658 6.878",
    stroke: "url(#prefix__paint7_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.122 268.66a997.694 997.694 0 00-24.128 16.376c2.622 1.976 5.206 3.952 7.827 5.928 5.282-7.486 10.753-14.933 16.301-22.304zm0 0c-6.536 2.165-13.033 4.445-19.568 6.763a852.493 852.493 0 015.433-7.181 877.668 877.668 0 00-20.708 11.969l-.912-5.13a1000.948 1000.948 0 00-30.891 28.725 918.604 918.604 0 00-26.902 16.643 952.652 952.652 0 005.016 6.535 1089.79 1089.79 0 0116.528-27.775 998.924 998.924 0 0133.893-32.107 1001.13 1001.13 0 0150.726-36.895c-.304 2.052-.57 4.104-.874 6.193a957.059 957.059 0 00-34.007 13.945 941.344 941.344 0 00-15.845 16.795c-7.751 5.053-15.502 10.221-23.14 15.502",
    stroke: "url(#prefix__paint8_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M122.809 316.914a977.656 977.656 0 00-20.822 30.891 825.115 825.115 0 0119.151-8.132 984.932 984.932 0 00-15.579-7.295 930.804 930.804 0 0117.25-15.464zm0 0c-.19-4.066-.38-8.17-.532-12.273",
    stroke: "url(#prefix__paint9_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M135.58 346.438a1882.413 1882.413 0 008.701 24.66 921.842 921.842 0 0125.496-29.03c-13.907 5.358-27.776 11.171-41.683 17.403 2.47-4.332 4.94-8.701 7.486-13.033zm0 0a724.93 724.93 0 00-12.387 2.85c-.684-3.23-1.368-6.422-2.014-9.651a1109.104 1109.104 0 00-10.487 19.91c3.154.532 6.269 1.064 9.385 1.634a783.729 783.729 0 00-5.091 9.879",
    stroke: "url(#prefix__paint10_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.484 323.867c-10.601 15.503-20.709 31.233-30.246 47.23",
    stroke: "url(#prefix__paint11_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.714 352.746c-2.659-3.534-5.281-7.106-7.941-10.639a907.304 907.304 0 00-13.299 25.495c14.363-11.703 29.068-22.912 44-33.627-1.025-3.229-2.051-6.421-3.039-9.651-6.802 9.347-13.337 18.847-19.721 28.422z",
    stroke: "url(#prefix__paint12_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M194.512 302.438a919.157 919.157 0 0134.729-31.88 1041.103 1041.103 0 0117.365-5.775 1116.082 1116.082 0 01-3.344-19.644c-3.876 11.855-7.523 23.71-10.867 35.602 3.382-.114 6.725-.19 10.107-.266",
    stroke: "url(#prefix__paint13_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M267.124 231.043a940.736 940.736 0 0165.962-44.57 930.793 930.793 0 00-42.404 12.007 1119.1 1119.1 0 0113.337 13.526c-12.387 6.042-24.698 12.425-36.895 19.037zm0 0a811.33 811.33 0 00-8.967 23.634 790.523 790.523 0 0112.881-15.123 950.472 950.472 0 00-41.797 31.005",
    stroke: "url(#prefix__paint14_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M333.091 186.51a1532.198 1532.198 0 00-5.395 11.133c-12.235.038-24.584.304-37.009.874 26.864-13.641 54.297-25.914 82.149-36.857a1016.993 1016.993 0 00-8.587 9.499 910.47 910.47 0 00-46.926 5.472 1028.198 1028.198 0 0127.585-19.569 936.075 936.075 0 00-11.817 29.448z",
    stroke: "url(#prefix__paint15_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M381.298 173.098a1523.3 1523.3 0 00-12.995-.379 17158.92 17158.92 0 00-5.357 6.611c6.193-3.268 12.424-6.497 18.732-9.613",
    stroke: "url(#prefix__paint16_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M162.823 236.438a987.98 987.98 0 0174.74-43.772 858.988 858.988 0 00-19.075 14.287 947.598 947.598 0 00-35.793 12.311",
    stroke: "url(#prefix__paint17_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M218.532 206.952a943.61 943.61 0 0163.036-25.23c.836-3.609 1.71-7.257 2.622-10.867a967.488 967.488 0 00-20.062 23.52c-4.446-2.355-8.891-4.711-13.375-7.029",
    stroke: "url(#prefix__paint18_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M281.523 181.723a1007.915 1007.915 0 0130.967-25.382c-4.179 1.14-8.397 2.28-12.576 3.457l10.259 4.788a1004.84 1004.84 0 0125.761-16.984",
    stroke: "url(#prefix__paint19_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M336.348 144.981a879.59 879.59 0 0121.24-11.475c-.342 1.824-.646 3.686-.95 5.509-6.649.304-13.298.722-19.948 1.178",
    stroke: "url(#prefix__paint20_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M356.384 138.179a1028.071 1028.071 0 0125.647-5.471c-1.519 1.748-3.001 3.495-4.521 5.243-2.508-2.508-5.054-4.977-7.599-7.447",
    stroke: "url(#prefix__paint21_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M343.23 151.515a906.042 906.042 0 0131.081-9.119c-5.167 2.887-10.297 5.775-15.388 8.739a919.623 919.623 0 017.143-9.879",
    stroke: "url(#prefix__paint22_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M367.558 122.524c7.637-2.47 15.275-4.863 22.912-7.143-6.535 2.926-13.071 5.889-19.53 8.929 6.573-3.724 13.185-7.333 19.834-10.905a932.006 932.006 0 0128.459-11.741c-.152 1.026-.303 2.014-.455 3.04a958.71 958.71 0 00-17.897 2.242",
    stroke: "url(#prefix__paint23_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M402.692 112.493a962.333 962.333 0 0122.95-3.8 1010.325 1010.325 0 0135.375-15.122 980.586 980.586 0 0183.82-8.664 941.205 941.205 0 00-21.582-4.901c1.102 4.028 2.204 8.017 3.268 12.045",
    stroke: "url(#prefix__paint24_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M425.651 108.656c9.917-.836 19.834-1.558 29.676-2.09a1242.953 1242.953 0 00-17.099 9.69c4.446 2.241 8.815 4.559 13.185 6.877a1022.826 1022.826 0 00-28.08 7.713",
    stroke: "url(#prefix__paint25_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M423.819 123.741a959.93 959.93 0 0127.624-.608 813.828 813.828 0 012.887-16.301c-7.105 1.71-14.172 3.458-21.278 5.32",
    stroke: "url(#prefix__paint26_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M486.023 98.89c4.293 1.711 8.587 3.458 12.805 5.206a938.449 938.449 0 0115.388-6.383c-9.385.266-18.77.684-28.193 1.178z",
    stroke: "url(#prefix__paint27_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M217.879 340.131a668.147 668.147 0 00-2.622 11.133 733.58 733.58 0 0112.539-7.713 687.672 687.672 0 00-20.367 5.015",
    stroke: "url(#prefix__paint28_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M247.442 328.808c2.622 3.875 5.281 7.751 7.903 11.626a721.584 721.584 0 00-15.427 11.057 820.98 820.98 0 0124.28-36.438",
    stroke: "url(#prefix__paint29_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M255.345 340.435a697.594 697.594 0 0139.402-2.165 821.205 821.205 0 00-65.012 40.808 790.924 790.924 0 0125.61-38.643z",
    stroke: "url(#prefix__paint30_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M239.918 351.492a985.352 985.352 0 00-.266 46.166 892.703 892.703 0 0110.715-21.81 826.912 826.912 0 00-20.632 3.23",
    stroke: "url(#prefix__paint31_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M227.304 391.921c7.6-5.509 15.275-10.905 23.064-16.11.38 10.829.912 21.582 1.634 32.297a772.851 772.851 0 0115.769-15.807c2.393 4.788 4.825 9.575 7.257 14.363a846.599 846.599 0 0111.437-14.705 1056.103 1056.103 0 0131.119 25.116 659.291 659.291 0 00-37.427-3.99c2.014-7.029 4.104-14.097 6.346-21.126-6.194.038-12.425.152-18.694.342a1415.987 1415.987 0 00-17.365-16.49",
    stroke: "url(#prefix__paint32_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M281.377 437.44a747.088 747.088 0 0119.15-34.311",
    stroke: "url(#prefix__paint33_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M306.682 415.705a730.69 730.69 0 00-17.896 37.997 704.294 704.294 0 0123.329-14.097 648.184 648.184 0 00-29.371-4.864 1088.655 1088.655 0 0126.978 22.19 648.593 648.593 0 00-16.529 23.292",
    stroke: "url(#prefix__paint34_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M306.027 495.918c9.157.874 18.2 1.975 27.091 3.267-3.496 4.37-6.915 8.816-10.297 13.261a666.645 666.645 0 017.561-29.979c-5.623 8.321-11.057 16.718-16.224 25.192 8.055.797 16.034 1.709 23.9 2.811a601.87 601.87 0 0120.86-3.723",
    stroke: "url(#prefix__paint35_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M345.972 516.055a560.152 560.152 0 013.192-10.563",
    stroke: "url(#prefix__paint36_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M328.031 462.707l-14.021-23.368c9.385-3.99 18.809-7.79 28.27-11.323-2.698 7.257-5.244 14.552-7.676 21.81-.19-9.119-.266-18.277-.19-27.434a725.935 725.935 0 0132.715-20.062",
    stroke: "url(#prefix__paint37_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M345.736 424.787a698.89 698.89 0 0122.152-29.371",
    stroke: "url(#prefix__paint38_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M268.417 318.701a820.019 820.019 0 0159.692-20.48c-16.034 8.511-31.841 17.592-47.381 27.167a845.28 845.28 0 0129.143-30.511",
    stroke: "url(#prefix__paint39_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M295.845 309.126a730.905 730.905 0 0148.522 1.292 1059.646 1059.646 0 00-16.263-12.197",
    stroke: "url(#prefix__paint40_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M358.399 307.719a701.618 701.618 0 0124.355 7.942 630.99 630.99 0 014.56-15.997c9.917 3.116 19.644 6.459 29.257 9.917a660.3 660.3 0 011.862-14.515",
    stroke: "url(#prefix__paint41_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M382.75 315.661c7.751 2.545 15.427 5.167 22.988 7.941a760.634 760.634 0 00-40.884 31.689c12.957-5.661 26.065-10.905 39.212-15.807-5.547-13.298-11.171-26.559-16.794-39.82",
    stroke: "url(#prefix__paint42_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M365.077 355.936c2.774 7.258 5.547 14.477 8.321 21.734a724.019 724.019 0 0130.245-37.996 752.428 752.428 0 00-84.542 76.449",
    stroke: "url(#prefix__paint43_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M635.464 273.18a1598.468 1598.468 0 0117.82 59.655c2.736-14.857 5.7-29.676 8.815-44.494a794.468 794.468 0 00-31.537 4.407 767.114 767.114 0 0132.031-24.128c-9.955-2.431-19.986-4.711-30.131-6.763a1269.47 1269.47 0 017.979-28.421 951.962 951.962 0 00-22.076 8.891 741.443 741.443 0 0139.175 16.946",
    stroke: "url(#prefix__paint44_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M662.105 288.304c-7.295 6.611-14.438 13.299-21.392 20.1 16.529 11.475 32.297 23.444 47.268 35.907a722.533 722.533 0 00-31.575-5.928 725.416 725.416 0 0163.492-18.58 2028.78 2028.78 0 00-5.889-39.592 788.389 788.389 0 0144.456.228 761.218 761.218 0 00-27.662-27.738c3.762 13.641 7.334 27.32 10.639 41.036a1003.919 1003.919 0 0113.641-22.759",
    stroke: "url(#prefix__paint45_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M688.008 344.348a670.304 670.304 0 0115.959-20.404c8.131-7.638 16.528-15.123 25.154-22.494a653.749 653.749 0 00-13.907-20.595c8.891 4.18 17.63 8.474 26.217 12.957",
    stroke: "url(#prefix__paint46_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M794.851 234.501a798.873 798.873 0 00-21.24-1.672 826.389 826.389 0 0130.473-13.983 1298.976 1298.976 0 00-9.233 15.655zm0 0a799.414 799.414 0 00-14.439-15.845 1256.801 1256.801 0 00-15.996 28.802c-11.323 1.558-22.532 3.305-33.665 5.319",
    stroke: "url(#prefix__paint47_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M758.572 204.559a921.117 921.117 0 0115.047 28.269c2.584 2.66 5.167 5.32 7.713 8.017-31.879-.988-63.606-.19-95.067 2.432",
    stroke: "url(#prefix__paint48_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M640.483 233.361c-7.903-6.079-15.997-12.007-24.242-17.858a848.576 848.576 0 00-66.076 19.568 773.61 773.61 0 00-40.238-28.802 2451.275 2451.275 0 018.853 23.254c1.33-15.54 2.85-31.043 4.598-46.583a867.296 867.296 0 0160.528.759 872.88 872.88 0 00-77.703 15.503 871.105 871.105 0 0181.769-44.874 909.517 909.517 0 00-47.116 18.2 915.324 915.324 0 0185.682-16.832 926.728 926.728 0 00-38.566-1.368c40.96 8.055 80.477 18.846 118.359 32.069",
    stroke: "url(#prefix__paint49_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M550.12 235.108c-10.221-1.596-20.556-3.04-30.967-4.256a853.616 853.616 0 0169.343-4.331 828.878 828.878 0 00-85.986-6.498",
    stroke: "url(#prefix__paint50_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M616.246 215.539c-9.347 3.496-18.58 7.181-27.7 10.981",
    stroke: "url(#prefix__paint51_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M507.723 207.445a842.646 842.646 0 0151.865-46.849c-14.704 23.102-28.193 46.546-40.428 70.255",
    stroke: "url(#prefix__paint52_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M760.666 194.604c22.988 2.812 45.862 6.497 68.546 11.095.684-4.864 1.368-9.689 2.052-14.553a822.66 822.66 0 00-55.779 19.112 1039.417 1039.417 0 0123.026-27.547 1449.378 1449.378 0 015.775 27.927",
    stroke: "url(#prefix__paint53_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M546.664 155.391a938.693 938.693 0 0125.951-14.021c2.508 2.432 5.016 4.902 7.486 7.333-9.842-2.127-19.759-4.065-29.752-5.889 5.206 3.951 10.373 7.903 15.465 11.931a876.823 876.823 0 0152.169-38.529c1.672 5.814 3.306 11.665 4.94 17.479-7.258-3.724-14.629-7.334-22.076-10.905 13.678-3.116 27.471-5.966 41.34-8.474",
    stroke: "url(#prefix__paint54_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M623.952 106.109a1013.52 1013.52 0 0128.764-5.852c-12.881.152-25.762.57-38.643 1.216 13.337 1.33 26.598 2.888 39.783 4.75a1013.567 1013.567 0 00-11.323-14.667c19.948-1.824 39.972-3.078 60.072-3.685-9.271 1.71-18.466 3.571-27.623 5.509a492.168 492.168 0 00-7.296-8.245 950.464 950.464 0 0134.805 6.117",
    stroke: "url(#prefix__paint55_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M761.994 108.808a842.474 842.474 0 0113.792-14.933 990.172 990.172 0 0155.057 10.563 978.418 978.418 0 00-110.988-7.333 978.59 978.59 0 0142.139 11.703zm0 0a905.81 905.81 0 0151.675-10.107 979.077 979.077 0 00-118.245 4.103",
    stroke: "url(#prefix__paint56_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M839.464 103.336a951.165 951.165 0 0142.1-3.762 1100.735 1100.735 0 00-23.444 24.888c46.09 1.406 92.636 6.155 139.219 14.401a991.874 991.874 0 00-157.875-35.527z",
    stroke: "url(#prefix__paint57_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.09 181.494a987.778 987.778 0 0141.72 34.159c-4.03-6.573-8.13-13.147-12.35-19.682",
    stroke: "url(#prefix__paint58_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M947.792 131.415A985.99 985.99 0 00827.647 95.66a988.683 988.683 0 0197.233 18.353 1014.773 1014.773 0 00-41.34-14.06c21.924 9.728 43.354 20.253 64.252 31.462zm0 0a885.33 885.33 0 0111.627-7.903c45.221 21.43 88.421 46.127 129.191 73.751 2.81-5.244 5.66-10.487 8.51-15.731-25-9.651-50.23-18.2-75.65-25.685a921.904 921.904 0 00-22.572-17.251c60.412 24.736 118.242 55.437 172.622 91.762a710.013 710.013 0 00-10.22-12.767c-5.59 1.178-11.18 2.394-16.69 3.648 6.43 3.572 12.81 7.219 19.19 10.943-4.86-7.713-9.84-15.427-14.97-23.064",
    stroke: "url(#prefix__paint59_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.61 221.164c2.21 6.307 4.3 12.577 6.35 18.884 3.87.266 7.79.532 11.7.836a791.624 791.624 0 00-20.06-12.957 937.322 937.322 0 0124.62 27.624",
    stroke: "url(#prefix__paint60_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.63 240.883c-.95 3.154-1.94 6.269-2.89 9.423",
    stroke: "url(#prefix__paint61_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.81 232.107c2.58-.608 5.13-1.216 7.71-1.824-10.83-5.092-21.73-9.993-32.72-14.629",
    stroke: "url(#prefix__paint62_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.92 218.086c-13.94 3.99-27.66 8.284-41.15 12.919a939.843 939.843 0 00-41.42-21.164 897.517 897.517 0 0187.4 16.377c-2.02 4.369-3.99 8.739-6.01 13.109a907.447 907.447 0 00-23.25-35.983c1.48 12.007 2.7 23.976 3.76 35.907 4.1 2.317 8.21 4.673 12.31 7.067a823.602 823.602 0 0113.95 16.946c-4.11-3.533-8.21-7.067-12.39-10.563 3.72 1.596 7.41 3.23 11.13 4.902",
    stroke: "url(#prefix__paint63_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.84 240.922a880.94 880.94 0 00-34.39-37.578",
    stroke: "url(#prefix__paint64_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.18 238.49c-26.29-10.563-52.89-19.872-79.68-27.851a850.845 850.845 0 0124.51 55.741c8.89-7.372 17.93-14.667 27.09-21.81a807.163 807.163 0 00-69.49 19.492c13.75 4.483 27.47 9.309 41.07 14.515-2.74 5.091-5.47 10.183-8.17 15.274 4.86-.342 9.77-.646 14.67-.874",
    stroke: "url(#prefix__paint65_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.77 278.424a945.818 945.818 0 00-5.13-31.955 826.172 826.172 0 0115.57 26.711",
    stroke: "url(#prefix__paint66_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M929.284 255.512c-8.777-13.869-18.086-27.586-27.889-41.151 10.829 8.245 21.43 16.643 31.689 25.268a895.293 895.293 0 00-20.176-.114 967.484 967.484 0 0118.086 11.361 865.871 865.871 0 00-23.558-18.466 849.342 849.342 0 0154.791-.076 890.99 890.99 0 00-94.231-36.705c70.18 8.397 140.324 25.23 208.644 50.801",
    stroke: "url(#prefix__paint67_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.22 272.611a900.664 900.664 0 0120.18 11.931c-2.81-3.837-5.7-7.637-8.59-11.437-2.05 2.698-4.06 5.396-6.12 8.094 4.26-1.026 8.55-1.976 12.89-2.926",
    stroke: "url(#prefix__paint68_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M950.263 237.464a884.209 884.209 0 00-48.864-23.102 813.594 813.594 0 0149.623-4.597 906.13 906.13 0 00-124.476-26.142 861.814 861.814 0 0180.818-13.527c-37.73-1.519-75.081-.721-111.748 2.356",
    stroke: "url(#prefix__paint69_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.32 277.055c9.08.342 18.16.836 27.32 1.482a879.634 879.634 0 00-73.028-43.24 892.252 892.252 0 0174.358 31.043c13.76-2.204 27.66-4.104 41.76-5.623",
    stroke: "url(#prefix__paint70_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.42 292.445a678.18 678.18 0 018.36 13.299c1.26-1.672 2.47-3.344 3.73-4.977a1227.37 1227.37 0 00-12.24-4.37 859.76 859.76 0 0130.36 26.826c-.95 3.837-1.9 7.675-2.85 11.475 3.31-.76 6.65-1.444 9.99-2.166a824.223 824.223 0 00-15.08-10.905c1.82-.912 3.68-1.824 5.51-2.698",
    stroke: "url(#prefix__paint71_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.46 429.688a821.844 821.844 0 00-25.99-28.194c12.81 9.993 25.38 20.366 37.62 31.157-.53 4.712-1.14 9.423-1.75 14.135 3.76.152 7.52.342 11.32.57a801.55 801.55 0 00-29.48-13.109 856.706 856.706 0 00-3.19-27.281",
    stroke: "url(#prefix__paint72_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1200.37 466.924c.34-3.343.64-6.725.91-10.107a968.52 968.52 0 00-11.93-10.069",
    stroke: "url(#prefix__paint73_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M615.817 106.566a908.56 908.56 0 0151.827-21.392",
    stroke: "url(#prefix__paint74_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.06 412.781a705.948 705.948 0 0124.28 54.373c-8.66-11.513-17.74-22.798-27.2-33.893a732.935 732.935 0 0153.88 43.658 722.709 722.709 0 0156.57 64.025c-13.45-7.638-26.98-14.743-40.58-21.278 22.23 3.115 44.72 7.523 67.48 13.298-6.53-22.874-14.28-45.709-23.25-68.431a761.94 761.94 0 0120.59 32.867c-27.32-29.068-56.76-55.817-88-80.173a1110.357 1110.357 0 00-48.21 37.275c7.14-13.489 14.21-27.054 21.24-40.619a761.166 761.166 0 0120.06 31.727c22.99 32.867 42.9 66.988 59.62 101.983",
    stroke: "url(#prefix__paint75_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.76 417.227c17.32 9.727 34.39 20.176 51.1 31.385a754.218 754.218 0 00-9.27-22.646c-.23 13.755-.83 27.395-1.71 40.96a676.765 676.765 0 0144.23 9.005 793.811 793.811 0 00-10.9-19.074 746.398 746.398 0 017.41 85.72",
    stroke: "url(#prefix__paint76_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.06 610.135c3.39 3.951 6.73 7.941 10 12.007-1.52-3.458-3.08-6.916-4.64-10.373-1.02 2.355-2.09 4.711-3.15 7.067 7.33-.038 14.7.076 22.15.304.19 3.002.34 5.965.46 8.967 2.16-1.254 4.29-2.508 6.45-3.762-3.76.038-7.48.114-11.2.19a514.89 514.89 0 00-2.51-9.043",
    stroke: "url(#prefix__paint77_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1223.88 625.219c2.7 4.635 5.36 9.271 7.94 13.982.99-2.963 1.94-5.927 2.89-8.891-5.32.342-10.6.76-15.84 1.216",
    stroke: "url(#prefix__paint78_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.99 332.036a659.147 659.147 0 00-6.91 7.828 881.822 881.822 0 0122.68 13.906 906.602 906.602 0 00-25.19-21.012c12.01.684 24.09 1.634 36.25 2.926-3.5-1.9-6.99-3.8-10.49-5.623 3.15 7.827 6.12 15.692 9.01 23.519-6.2-.266-12.32-.456-18.47-.57",
    stroke: "url(#prefix__paint79_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M998.903 138.559a988.088 988.088 0 00-24.926 14.172c41.113 6.764 82.263 16.339 123.143 28.764a927.46 927.46 0 0123.37 31.195",
    stroke: "url(#prefix__paint80_linear_6821_29592)",
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M106.588 355.217c-.114-.152-.228-.304-.342-.494a955.118 955.118 0 0155.703-53.234 891.675 891.675 0 00-28.915-9.689 971.218 971.218 0 0168.849-54.487c-6.459-5.661-12.957-11.285-19.53-16.832a992.28 992.28 0 00-66 59.806c-8.663 1.292-17.326 2.698-26.066 4.294.266-.342.532-.722.836-1.064a891.93 891.93 0 0125.534-4.18c21.24-21.012 43.392-41.074 66.418-60.034 6.839 5.813 13.641 11.665 20.366 17.592-.228.152-.456.304-.646.494a965.309 965.309 0 00-68.014 53.689 958.015 958.015 0 0128.916 9.727c-19.72 17.213-38.757 35.375-57.109 54.412z",
    fill: "url(#prefix__paint81_linear_6821_29592)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M194.545 302.097a765.39 765.39 0 00-32.411-.455 932.8 932.8 0 0140.39-64.937 943.946 943.946 0 0140.885-7.219 901.434 901.434 0 0126.293-31.955c.342-.038.646-.114.988-.152-9.309 10.791-18.314 21.772-27.053 32.867a887.134 887.134 0 00-40.847 7.181c-14.058 20.708-27.167 41.759-39.288 63.151a839.486 839.486 0 0131.043.456 921.023 921.023 0 0146.698-55.931c10.145-2.356 20.29-4.484 30.397-6.46-.228.304-.418.608-.646.874a857.18 857.18 0 00-29.599 6.27c-16.415 18.276-32.069 37.046-46.85 56.31z",
    fill: "url(#prefix__paint82_linear_6821_29592)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M203.098 237.047c-.266.038-.57.038-.836.076 15.313-17.098 31.347-33.703 48.028-49.814.266 0 .57-.038.836-.038a940.537 940.537 0 00-48.028 49.776z",
    fill: "url(#prefix__paint83_linear_6821_29592)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M305.881 211.246a42.12 42.12 0 00-1.216.456 966.035 966.035 0 0111.703-35.413 938.002 938.002 0 0156.805-15.312l-.342.683a923.544 923.544 0 00-55.513 14.933 1057.41 1057.41 0 00-11.437 34.653z",
    fill: "url(#prefix__paint84_linear_6821_29592)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M426.862 133.012c-.266-.076-.532-.114-.798-.19a937.524 937.524 0 0157.793-33.4 948.161 948.161 0 00-44.228-1.025c.228-.19.494-.38.722-.608 15.351 0 30.587.38 45.672 1.102-20.252 10.753-40.01 22.114-59.161 34.121z",
    fill: "url(#prefix__paint85_linear_6821_29592)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M485.036 99.385c-.038-.152-.114-.304-.152-.456 19.834-5.282 39.82-9.993 59.959-14.02.076.151.114.303.19.455-20.177 4.028-40.163 8.74-59.997 14.02z",
    fill: "url(#prefix__paint86_linear_6821_29592)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M144.289 371.098c-.38.228-.76.456-1.102.684 5.358-23.444 11.741-46.925 19.113-70.369.38-.19.759-.418 1.139-.608-7.409 23.444-13.792 46.887-19.15 70.293z",
    fill: "url(#prefix__paint87_linear_6821_29592)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M239.658 397.621l-.684-.342a821.71 821.71 0 0154.601-58.933 1083.539 1083.539 0 00-27.091-19.264c.342-.342.722-.646 1.064-.988 9.385 6.421 18.58 12.995 27.661 19.644a5.844 5.844 0 01-.494.456 843.817 843.817 0 00-55.057 59.427z",
    fill: "url(#prefix__paint88_linear_6821_29592)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M318.723 361.068c-.152-.228-.304-.418-.456-.646a797.115 797.115 0 0199.893-65.658c.152.19.304.418.418.608a804 804 0 00-99.855 65.696z",
    fill: "url(#prefix__paint89_linear_6821_29592)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M402.39 352.214a733.657 733.657 0 00-37.997 4.104l.456-1.026a692.797 692.797 0 0137.997-4.065c-.19.304-.342.645-.456.987z",
    fill: "url(#prefix__paint90_linear_6821_29592)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M305.386 495.992c-.38.114-.76.266-1.14.38 2.926-26.255 7.334-52.739 13.261-79.298-12.577-1.368-25.344-2.356-38.3-3.002a769.615 769.615 0 0138.528-53.043 1239.043 1239.043 0 00-24.166-22.722c.152-.152.342-.304.494-.456a831.897 831.897 0 0155.323-46.888c-11.285 22.912-21.316 45.976-30.131 69.192a731.563 731.563 0 0146.394-4.94c-.19.228-.418.494-.608.722-16.567 19.492-31.917 39.592-46.014 60.187a727.936 727.936 0 0126.674 8.663l-.798 1.14c-8.664-3.002-17.441-5.89-26.332-8.549a737.989 737.989 0 00-13.185 78.614zm-24.356-83.06a650.765 650.765 0 0137.085 2.964 733.517 733.517 0 0145.444-59.503 710.447 710.447 0 00-44.912 4.864 757.02 757.02 0 00-37.617 51.675zm14.173-75.119a1144.985 1144.985 0 0123.178 21.848c8.397-22.076 17.934-44.038 28.573-65.848a822.594 822.594 0 00-51.751 44z",
    fill: "url(#prefix__paint91_linear_6821_29592)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M507.941 207.524c-.114-.19-.265-.38-.379-.57a886.854 886.854 0 0175.461-23.558 910.887 910.887 0 00-25.724-23.824c.418-.152.798-.266 1.216-.418a853.904 853.904 0 0126.332 24.432 888.794 888.794 0 00-76.906 23.938z",
    fill: "url(#prefix__paint92_linear_6821_29592)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M584.161 183.775c-.152-.19-.342-.38-.494-.532a892.578 892.578 0 0180.363-20.708c.152.19.342.38.494.57a905.37 905.37 0 00-80.363 20.67z",
    fill: "url(#prefix__paint93_linear_6821_29592)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M686.146 243.544a824.59 824.59 0 00-69.002-14.324c0-.076 0-.152-.038-.228-1.215-10.715-2.469-21.392-3.723-32.107a781.984 781.984 0 00-29.296-12.843 825.719 825.719 0 00-47.951 53.461c-.38-.038-.798-.076-1.178-.152 15.198-18.58 31.499-36.743 48.825-54.373 10.221 4.217 20.291 8.663 30.208 13.223a834.731 834.731 0 0150.269-33.855 850.52 850.52 0 0142.518 24.242 827.33 827.33 0 0174.36 32.221c-32.601 6.345-64.329 14.552-94.916 24.469 0 .076-.038.19-.076.266zm-67.71-14.894a822.582 822.582 0 0166.722 13.831c6.384-18.505 13.147-36.933 20.366-55.286-30.511 1.71-60.794 4.94-90.773 9.766 1.215 10.563 2.469 21.126 3.685 31.689zm88.342-41.265a1402.73 1402.73 0 00-20.214 54.906 813.555 813.555 0 0192.142-23.824c-23.14-11.361-47.154-21.734-71.928-31.082zm-42.48-24.051a831.357 831.357 0 00-48.711 32.791 875.793 875.793 0 0189.481-9.575 797.68 797.68 0 00-40.77-23.216z",
    fill: "url(#prefix__paint94_linear_6821_29592)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M706.896 187.005c-.38-.114-.76-.266-1.102-.38 6.726-4.94 13.527-9.841 20.48-14.629.38.114.76.266 1.102.418a823.09 823.09 0 00-20.48 14.591z",
    fill: "url(#prefix__paint95_linear_6821_29592)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M652.599 333.444c-.38-.152-.76-.304-1.102-.456a708.362 708.362 0 0130.131-32.525 718.08 718.08 0 00-45.786-27.092c.152-.114.304-.228.456-.304 15.541-10.487 31.727-20.518 48.446-30.055-22.418-16.301-46.204-31.689-71.244-46.014.342-.152.684-.342 1.064-.494 25.306 14.477 49.32 30.055 71.966 46.584-.152.076-.266.152-.418.228a755.748 755.748 0 00-48.37 29.941 723.861 723.861 0 0145.596 27.092c-10.715 10.791-20.936 21.848-30.739 33.095z",
    fill: "url(#prefix__paint96_linear_6821_29592)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M636.982 273.675c-.114-.266-.228-.494-.342-.76a804.935 804.935 0 01113.837-16.072c-21.354-5.32-43.012-9.841-65.012-13.451.114-.228.228-.494.38-.722 23.596 3.914 46.85 8.777 69.686 14.667-.798.038-1.558.114-2.356.152-39.478 2.583-78.349 8.017-116.193 16.186z",
    fill: "url(#prefix__paint97_linear_6821_29592)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M710.741 331.583a720.96 720.96 0 00-29.106-31.233l.342-.228c22.228-15.465 45.748-29.942 70.522-43.354.304.19.646.418.95.608-24.66 13.298-48.066 27.699-70.18 43.05 9.917 10.031 19.416 20.29 28.536 30.701-.304.152-.684.304-1.064.456z",
    fill: "url(#prefix__paint98_linear_6821_29592)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M665.206 139.169c-.418-.076-.798-.152-1.216-.19 4.028-4.37 8.132-8.74 12.311-13.071a943.707 943.707 0 00-87.354.608 690.71 690.71 0 0112.843 10.373c-.38.114-.798.228-1.178.342a800.247 800.247 0 00-13.869-11.171c30.55-1.672 61.061-1.9 91.458-.646a884.024 884.024 0 00-12.995 13.755z",
    fill: "url(#prefix__paint99_linear_6821_29592)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M737.104 129.213c-.152 0-.304-.038-.456-.038a960.193 960.193 0 00-60.111-3.268c.836-6.307 1.672-12.577 2.546-18.884 27.814-.608 55.665 0 83.479 1.824a4.025 4.025 0 00-.456.38 926.746 926.746 0 00-25.002 19.986zm-59.161-3.838a934.954 934.954 0 0158.363 3.192 944.039 944.039 0 0124.166-19.34 971.926 971.926 0 00-80.135-1.71c-.798 5.965-1.596 11.931-2.394 17.858z",
    fill: "url(#prefix__paint100_linear_6821_29592)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M795.876 137.116a884.503 884.503 0 00-34.881-28.004 950.685 950.685 0 00-12.919-15.35c.418-.038.798-.038 1.216-.076 4.294 5.015 8.55 10.069 12.729 15.122a974.228 974.228 0 0196.587 15.237 934.015 934.015 0 00-62.732 13.071zm-33.171-27.7c11.475 8.777 22.646 17.707 33.475 26.864 19.34-4.75 39.061-8.853 59.085-12.387-30.587-6.27-61.479-11.133-92.56-14.477z",
    fill: "url(#prefix__paint101_linear_6821_29592)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M806.03 159.382c-.076-.228-.19-.418-.266-.646a922.708 922.708 0 0198.602 9.993 938.203 938.203 0 00-108.481-31.765c.114-.19.19-.342.304-.532a947.126 947.126 0 01114.218 33.855 934.486 934.486 0 00-104.377-10.905z",
    fill: "url(#prefix__paint102_linear_6821_29592)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M867.964 195.63a880.71 880.71 0 00-62.163-36.249c-24.09 2.242-47.876 5.396-71.319 9.499-.19-.19-.38-.38-.57-.608 23.671-4.141 47.723-7.333 72.079-9.575a887.359 887.359 0 0161.593 35.831 889.081 889.081 0 0138.718-25.002c-.114-.038-.19-.038-.304-.076.19-.038.38-.114.57-.152a886.052 886.052 0 00-50.155-45.254c-14.021-8.891-28.422-17.478-43.127-25.761l.912-.228a947.364 947.364 0 0142.747 25.533c22.228-4.293 44.873-7.789 67.937-10.487a942.462 942.462 0 0149.358 39.441c.38.114.722.228 1.102.342-.19.038-.418.076-.608.114a883.967 883.967 0 0150.726 57.565 932.65 932.65 0 00-117.714-40.695c-13.603 8.359-26.864 16.909-39.782 25.762zm40.77-26.028a936.323 936.323 0 01114.486 39.441 876.532 876.532 0 00-49.322-55.817 854.788 854.788 0 00-65.164 16.376zm-50.65-45.14a884.843 884.843 0 0149.358 44.57 854.86 854.86 0 0165.164-16.414 964.552 964.552 0 00-114.522-28.156zm66.684-10.639a923.866 923.866 0 00-66.152 10.183 973.626 973.626 0 01114.066 28.042 959.342 959.342 0 00-47.914-38.225z",
    fill: "url(#prefix__paint103_linear_6821_29592)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M976.368 235.602c-.19-.19-.38-.418-.57-.608a855.715 855.715 0 00-68.926-65.392c.342-.038.684-.076.988-.114 24.356 20.708 47.154 42.366 68.356 64.86 15.54-8.739 31.494-17.06 47.834-25.001a907.352 907.352 0 0153.05 36.78c-.16.114-.35.228-.5.38-16.83-12.577-34.19-24.621-52.01-36.134-16.5 7.979-32.568 16.376-48.222 25.229z",
    fill: "url(#prefix__paint104_linear_6821_29592)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.81 210.22c-.3-.266-.61-.532-.91-.798a856.717 856.717 0 0156.92-6.839c-35.07-18.96-71.36-35.717-108.597-50.231a944.206 944.206 0 0181.347 6.421c.12.114.23.228.35.342 12.23 12.653 24.01 25.496 35.33 38.604a914.527 914.527 0 0159.2 10.83c.23.265.46.569.69.835a921.01 921.01 0 00-60.15-10.981c-.12-.114-.23-.266-.35-.38a909.235 909.235 0 00-35.33-38.604 934.944 934.944 0 00-77.629-6.232 958.97 958.97 0 01107.489 50.118c-.26.038-.49.038-.76.076-19.49 1.634-38.72 3.952-57.6 6.839z",
    fill: "url(#prefix__paint105_linear_6821_29592)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.14 292.939c-25.5-20.974-52.44-40.619-80.706-58.857a885.268 885.268 0 01117.786 39.061c.08.265.16.531.23.797a879.18 879.18 0 00-114.178-38.186c27.088 17.63 52.968 36.591 77.508 56.767-.26.152-.45.304-.64.418z",
    fill: "url(#prefix__paint106_linear_6821_29592)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.28 340.282c-.19-.341-.35-.683-.54-1.025 7.15.949 14.29 2.051 21.43 3.191-1.52-4.977-3.07-9.955-4.71-14.932.38.114.76.266 1.14.38a791.482 791.482 0 014.94 15.73 920.775 920.775 0 00-22.26-3.344z",
    fill: "url(#prefix__paint107_linear_6821_29592)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.93 352.785c-3.42-3.192-6.84-6.383-10.34-9.499l.57-.456c3.46 3.154 6.92 6.308 10.34 9.499-.23.152-.38.304-.57.456z",
    fill: "url(#prefix__paint108_linear_6821_29592)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.39 460.733c-.26-.38-.57-.759-.83-1.177 8.66-4.826 17.4-9.5 26.29-14.059a759.269 759.269 0 00-37.24-33.437c.16-.228.31-.494.46-.722a734.765 734.765 0 0137.54 33.703 998.706 998.706 0 0133.13-20.176 756.52 756.52 0 0114.9 42.936c-15.77-7.751-31.62-14.895-47.57-21.354-.04.038-.08.038-.16.076l-.03-.038c-8.89 4.673-17.75 9.385-26.49 14.248zm59.13-34.006a991.311 991.311 0 00-31.39 19.112 738.99 738.99 0 0145.03 20.138 780.928 780.928 0 00-13.64-39.25z",
    fill: "url(#prefix__paint109_linear_6821_29592)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.26 533.991c-.23-.456-.5-.874-.73-1.33 9.43-5.054 19-9.955 28.65-14.743a750.446 750.446 0 00-22.34-50.269 767.58 767.58 0 00-33.47 11.057c-4.37-11.019-9.05-22-14.06-32.905h.99c4.75 10.373 9.19 20.822 13.37 31.271a778.607 778.607 0 0133.32-10.981 722.642 722.642 0 0123.52 52.815c-9.88 4.94-19.64 9.955-29.25 15.085z",
    fill: "url(#prefix__paint110_linear_6821_29592)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.45 478.477c.04-.342.07-.722.11-1.064a734.984 734.984 0 0156.12 40.315 825.129 825.129 0 0125.99-7.904c-16.15-15.274-32.83-29.751-50.04-43.392 7.75-1.292 15.62-2.47 23.52-3.534.23.418.46.874.69 1.292-7.26.95-14.44 2.014-21.59 3.192a760.697 760.697 0 0149.7 43.316 748.13 748.13 0 00-27.89 8.473 730.278 730.278 0 00-56.61-40.694z",
    fill: "url(#prefix__paint111_linear_6821_29592)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.03 544.325a750.557 750.557 0 00-18.46-25.534c.19-.228.34-.456.53-.684a714.76 714.76 0 0118.47 25.534c-.16.228-.35.456-.54.684z",
    fill: "url(#prefix__paint112_linear_6821_29592)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M766.89 319.88c-.379-.19-.721-.38-1.101-.608 5.813-5.472 11.741-10.905 17.82-16.225a599.592 599.592 0 00-11.513-10.221c.342-.152.684-.304 1.026-.418 4.104 3.572 8.131 7.182 12.121 10.791a862.547 862.547 0 00-18.353 16.681z",
    fill: "url(#prefix__paint113_linear_6821_29592)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M784.866 303.503c-.304-.228-.608-.494-.912-.722a690.115 690.115 0 0115.921-7.941c.304.228.608.494.912.722-5.358 2.584-10.639 5.243-15.921 7.941z",
    fill: "url(#prefix__paint114_linear_6821_29592)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.05 435.388c-.31-.38-.61-.798-.91-1.178 2.54-1.672 5.09-3.343 7.63-5.015-3.72-7.865-7.56-15.693-11.59-23.482l.92.114a784.278 784.278 0 0111.96 24.318c-2.66 1.748-5.32 3.495-8.01 5.243z",
    fill: "url(#prefix__paint115_linear_6821_29592)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.42 430.144c.04-.304.07-.608.11-.912a859.35 859.35 0 0122.31 18.087l-.12.912c-7.33-6.194-14.78-12.197-22.3-18.087z",
    fill: "url(#prefix__paint116_linear_6821_29592)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M167.153 298.22c-.114 1.558-2.165 4.066-4.559 5.662-2.394 1.595-4.218 1.633-4.066.114.114-1.558 2.166-4.104 4.522-5.7 2.394-1.558 4.255-1.596 4.103-.076z",
    fill: "url(#prefix__paint117_linear_6821_29592)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M246.68 242.708c-.152 1.406-2.28 3.61-4.75 4.94-2.47 1.329-4.369 1.215-4.217-.19.152-1.406 2.279-3.648 4.749-4.94 2.47-1.33 4.37-1.216 4.218.19z",
    fill: "url(#prefix__paint118_linear_6821_29592)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M199.335 298.601c-.114 1.558-2.166 4.065-4.56 5.585-2.432 1.52-4.294 1.52-4.218-.076.114-1.558 2.128-4.065 4.56-5.585 2.432-1.52 4.332-1.482 4.218.076z",
    fill: "url(#prefix__paint119_linear_6821_29592)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M147.929 368.249c-.038 1.748-1.938 4.598-4.256 6.346-2.317 1.785-4.179 1.823-4.141.076.038-1.748 1.938-4.598 4.255-6.384 2.318-1.748 4.18-1.786 4.142-.038z",
    fill: "url(#prefix__paint120_linear_6821_29592)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M298.96 335.686c0 1.748-2.014 4.218-4.521 5.548-2.508 1.33-4.56.988-4.598-.76-.038-1.748 2.014-4.256 4.522-5.548 2.545-1.33 4.597-.988 4.597.76z",
    fill: "url(#prefix__paint121_linear_6821_29592)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M423.165 293.511c0 1.671-2.166 3.723-4.825 4.597-2.66.874-4.788.228-4.788-1.444s2.166-3.761 4.826-4.635c2.659-.836 4.787-.19 4.787 1.482z",
    fill: "url(#prefix__paint122_linear_6821_29592)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M323.399 358.332c.076 1.824-1.938 4.37-4.445 5.624-2.508 1.291-4.636.835-4.712-1.026-.076-1.824 1.938-4.37 4.446-5.624 2.545-1.292 4.635-.798 4.711 1.026z",
    fill: "url(#prefix__paint123_linear_6821_29592)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M284.526 410.464c.152 1.976-1.71 4.788-4.142 6.27-2.431 1.482-4.559 1.064-4.711-.912-.152-1.976 1.672-4.788 4.142-6.27 2.431-1.481 4.559-1.064 4.711.912z",
    fill: "url(#prefix__paint124_linear_6821_29592)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M367.919 354.076c.076 1.862-1.976 4.255-4.522 5.395-2.546 1.14-4.712.532-4.787-1.33-.076-1.861 1.937-4.293 4.521-5.395 2.584-1.14 4.712-.532 4.788 1.33z",
    fill: "url(#prefix__paint125_linear_6821_29592)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M322.675 414.112c.19 2.014-1.671 4.749-4.141 6.117-2.47 1.368-4.598.836-4.788-1.216-.19-2.013 1.672-4.787 4.142-6.117 2.47-1.368 4.635-.798 4.787 1.216z",
    fill: "url(#prefix__paint126_linear_6821_29592)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M348.857 423.459c.19 2.09-1.634 4.788-4.103 6.079-2.47 1.292-4.636.646-4.864-1.443-.228-2.09 1.634-4.826 4.104-6.08 2.507-1.292 4.673-.646 4.863 1.444z",
    fill: "url(#prefix__paint127_linear_6821_29592)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M308.164 493.979c.38 2.279-1.216 5.357-3.534 6.877-2.317 1.52-4.559.912-4.939-1.368-.38-2.28 1.216-5.357 3.533-6.877 2.356-1.558 4.56-.912 4.94 1.368z",
    fill: "url(#prefix__paint128_linear_6821_29592)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M406.38 350.277c.076 1.862-1.976 4.18-4.598 5.168-2.584.988-4.749.304-4.825-1.596-.076-1.862 1.975-4.18 4.597-5.168 2.584-.988 4.75-.266 4.826 1.596z",
    fill: "url(#prefix__paint129_linear_6821_29592)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M352.877 290.432c-.038 1.634-2.166 3.838-4.75 4.902-2.584 1.102-4.674.684-4.636-.95.038-1.634 2.166-3.838 4.75-4.94 2.584-1.102 4.674-.646 4.636.988z",
    fill: "url(#prefix__paint130_linear_6821_29592)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M588.844 183.244c-.076 1.329-2.317 2.621-5.053 2.925-2.736.266-4.864-.57-4.826-1.9.076-1.329 2.318-2.659 5.054-2.925 2.736-.304 4.901.57 4.825 1.9z",
    fill: "url(#prefix__paint131_linear_6821_29592)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M540.471 236.628c-.038 1.52-2.279 3.116-5.015 3.572-2.736.456-4.864-.38-4.826-1.9.038-1.52 2.28-3.116 5.016-3.572 2.698-.494 4.863.38 4.825 1.9z",
    fill: "url(#prefix__paint132_linear_6821_29592)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M619.838 196.277c-.038 1.368-2.318 2.66-5.053 2.85-2.736.19-4.902-.76-4.864-2.166.038-1.368 2.318-2.66 5.054-2.85 2.735-.19 4.901.798 4.863 2.166z",
    fill: "url(#prefix__paint133_linear_6821_29592)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M690.596 243.355c-.038 1.557-2.317 2.773-5.053 2.735-2.736-.038-4.902-1.33-4.864-2.849.038-1.558 2.318-2.774 5.054-2.736 2.736 0 4.901 1.292 4.863 2.85z",
    fill: "url(#prefix__paint134_linear_6821_29592)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M687.403 300.463c-.038 1.748-2.28 3.154-5.015 3.154-2.736-.038-4.902-1.482-4.826-3.23.038-1.748 2.28-3.192 5.016-3.154 2.697 0 4.863 1.444 4.825 3.23z",
    fill: "url(#prefix__paint135_linear_6821_29592)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M789.315 303.845c-.076 1.748-2.318 2.85-5.016 2.47-2.697-.38-4.825-2.09-4.711-3.876.076-1.748 2.318-2.849 5.015-2.47 2.66.38 4.788 2.128 4.712 3.876z",
    fill: "url(#prefix__paint136_linear_6821_29592)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M777.492 293.244c-.076 1.71-2.318 2.812-5.015 2.47-2.698-.342-4.826-1.976-4.75-3.724.076-1.71 2.318-2.849 5.016-2.507 2.697.38 4.825 2.051 4.749 3.761z",
    fill: "url(#prefix__paint137_linear_6821_29592)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M771.371 320.22c-.076 1.824-2.356 3.04-5.016 2.698-2.698-.342-4.787-2.052-4.711-3.876.076-1.823 2.317-3.039 5.015-2.697 2.698.304 4.788 2.052 4.712 3.875z",
    fill: "url(#prefix__paint138_linear_6821_29592)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M805.233 295.979c-.076 1.71-2.318 2.736-5.015 2.318-2.698-.418-4.788-2.166-4.712-3.875.076-1.71 2.318-2.774 5.016-2.318 2.659.418 4.787 2.166 4.711 3.875z",
    fill: "url(#prefix__paint139_linear_6821_29592)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M716.197 331.62c-.076 1.899-2.318 3.305-5.016 3.153-2.698-.152-4.826-1.748-4.75-3.647.076-1.862 2.318-3.306 5.016-3.154 2.66.114 4.788 1.748 4.75 3.648z",
    fill: "url(#prefix__paint140_linear_6821_29592)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M757.919 257.564c-.038 1.596-2.318 2.66-5.015 2.394-2.736-.266-4.902-1.748-4.826-3.344.038-1.596 2.318-2.66 5.016-2.394 2.697.228 4.863 1.748 4.825 3.344z",
    fill: "url(#prefix__paint141_linear_6821_29592)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M656.927 333.063c-.038 1.9-2.242 3.496-4.94 3.572-2.697.076-4.863-1.368-4.825-3.268.038-1.899 2.242-3.495 4.939-3.571 2.736-.076 4.864 1.406 4.826 3.267z",
    fill: "url(#prefix__paint142_linear_6821_29592)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M641.466 273.068c-.038 1.672-2.28 3.116-5.016 3.23-2.735.114-4.901-1.102-4.863-2.774.038-1.672 2.279-3.116 5.015-3.23 2.736-.114 4.902 1.14 4.864 2.774z",
    fill: "url(#prefix__paint143_linear_6821_29592)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M623.61 228.574c-.038 1.482-2.318 2.85-5.053 3.04-2.736.19-4.902-.874-4.864-2.356.038-1.482 2.318-2.85 5.054-3.04 2.735-.228 4.939.836 4.863 2.356z",
    fill: "url(#prefix__paint144_linear_6821_29592)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M711.26 186.625c-.038 1.33-2.279 2.355-5.015 2.241-2.736-.114-4.902-1.253-4.864-2.621.038-1.33 2.28-2.356 5.016-2.28 2.736.152 4.939 1.33 4.863 2.66z",
    fill: "url(#prefix__paint145_linear_6821_29592)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M740.103 169.527c-.038 1.292-2.242 2.166-4.978 1.976-2.697-.19-4.901-1.368-4.863-2.66.038-1.291 2.242-2.165 4.977-2.013 2.698.228 4.864 1.406 4.864 2.697z",
    fill: "url(#prefix__paint146_linear_6821_29592)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M811.731 159.837c0 1.254-2.204 1.9-4.864 1.52-2.698-.38-4.863-1.71-4.825-2.926 0-1.216 2.203-1.938 4.863-1.558 2.66.418 4.826 1.748 4.826 2.964z",
    fill: "url(#prefix__paint147_linear_6821_29592)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M742.077 128.794c-.038 1.14-2.204 1.938-4.901 1.748-2.698-.19-4.864-1.254-4.826-2.394.038-1.14 2.204-1.938 4.902-1.786 2.659.19 4.825 1.292 4.825 2.432z",
    fill: "url(#prefix__paint148_linear_6821_29592)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M682.115 125.603c-.038 1.14-2.28 2.051-4.978 2.051s-4.825-.949-4.787-2.089c.038-1.14 2.279-2.09 4.977-2.052 2.698 0 4.864.95 4.788 2.09z",
    fill: "url(#prefix__paint149_linear_6821_29592)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M606.316 136.204c-.076 1.178-2.318 2.318-5.016 2.508-2.697.228-4.825-.57-4.749-1.748.076-1.178 2.318-2.317 5.015-2.545 2.698-.19 4.826.608 4.75 1.785z",
    fill: "url(#prefix__paint150_linear_6821_29592)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M685.315 107.478c-.038 1.102-2.242 1.938-4.939 1.938-2.66 0-4.826-.912-4.75-2.014.038-1.102 2.242-1.976 4.94-1.938 2.659 0 4.787.912 4.749 2.014z",
    fill: "url(#prefix__paint151_linear_6821_29592)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M592.707 125.831c-.076 1.14-2.318 2.28-5.015 2.508-2.698.228-4.788-.494-4.712-1.634.076-1.14 2.318-2.28 5.016-2.546 2.659-.19 4.787.532 4.711 1.672z",
    fill: "url(#prefix__paint152_linear_6821_29592)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M800.868 137.684c0 1.178-2.165 1.824-4.825 1.482-2.66-.342-4.826-1.558-4.826-2.735 0-1.178 2.166-1.824 4.864-1.482 2.622.304 4.787 1.558 4.787 2.735z",
    fill: "url(#prefix__paint153_linear_6821_29592)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M766.353 109.491c0 1.102-2.166 1.786-4.825 1.52-2.66-.228-4.826-1.292-4.788-2.394 0-1.102 2.166-1.786 4.826-1.558 2.659.266 4.787 1.33 4.787 2.432z",
    fill: "url(#prefix__paint154_linear_6821_29592)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M861.694 125.338c.038 1.102-2.09 1.596-4.712 1.102-2.621-.494-4.787-1.824-4.787-2.926-.038-1.102 2.09-1.596 4.711-1.102 2.622.494 4.75 1.824 4.788 2.926z",
    fill: "url(#prefix__paint155_linear_6821_29592)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M912.147 171.312c.038 1.254-2.09 1.71-4.711 1.026-2.622-.684-4.75-2.203-4.788-3.457-.038-1.254 2.09-1.71 4.712-1.026 2.621.646 4.749 2.204 4.787 3.457z",
    fill: "url(#prefix__paint156_linear_6821_29592)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M978.572 154.252c.076 1.178-1.938 1.444-4.484.608-2.545-.836-4.673-2.432-4.749-3.61-.076-1.14 1.938-1.444 4.521-.608 2.546.836 4.674 2.432 4.712 3.61z",
    fill: "url(#prefix__paint157_linear_6821_29592)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.44 204.978c.07 1.254-1.83 1.368-4.3.19-2.43-1.14-4.52-3.078-4.59-4.331-.08-1.254 1.82-1.368 4.29-.228 2.47 1.177 4.52 3.115 4.6 4.369z",
    fill: "url(#prefix__paint158_linear_6821_29592)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.08 211.399c.12 1.254-1.7 1.178-4.06-.114-2.36-1.291-4.37-3.343-4.48-4.597-.12-1.216 1.71-1.216 4.06.076 2.36 1.33 4.37 3.419 4.48 4.635z",
    fill: "url(#prefix__paint159_linear_6821_29592)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.92 211.704c.03 1.33-1.98 1.558-4.49.532-2.5-1.026-4.59-2.888-4.63-4.218-.04-1.292 1.97-1.558 4.48-.532 2.51.988 4.6 2.888 4.64 4.218z",
    fill: "url(#prefix__paint160_linear_6821_29592)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.32 248.37c.04 1.406-1.94 1.558-4.41.342-2.47-1.215-4.48-3.305-4.52-4.673-.04-1.368 1.94-1.558 4.41-.342 2.47 1.178 4.48 3.268 4.52 4.673z",
    fill: "url(#prefix__paint161_linear_6821_29592)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.9 160.939c.12 1.14-1.82 1.254-4.29.228-2.47-1.026-4.56-2.774-4.64-3.914-.11-1.139 1.83-1.253 4.3-.227 2.47 1.025 4.56 2.773 4.63 3.913z",
    fill: "url(#prefix__paint162_linear_6821_29592)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.82 200.152c.07 1.254-1.83 1.292-4.26.152-2.43-1.14-4.48-3.078-4.6-4.331-.07-1.216 1.83-1.33 4.26-.152 2.47 1.139 4.52 3.115 4.6 4.331z",
    fill: "url(#prefix__paint163_linear_6821_29592)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M818.641 98.32c0 1.064-2.09 1.596-4.712 1.216-2.621-.38-4.787-1.52-4.787-2.546 0-1.025 2.09-1.595 4.711-1.215 2.66.341 4.788 1.481 4.788 2.545z",
    fill: "url(#prefix__paint164_linear_6821_29592)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M930.009 114.85c.076 1.063-1.976 1.367-4.522.721-2.545-.683-4.711-2.051-4.749-3.115-.076-1.064 1.976-1.368 4.521-.722 2.584.646 4.712 2.052 4.75 3.116z",
    fill: "url(#prefix__paint165_linear_6821_29592)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M753.482 94.104c0 1.064-2.166 1.71-4.825 1.52-2.66-.19-4.788-1.216-4.788-2.242s2.166-1.747 4.826-1.52c2.659.19 4.787 1.216 4.787 2.242z",
    fill: "url(#prefix__paint166_linear_6821_29592)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M669.506 139.015c-.038 1.178-2.28 2.166-4.977 2.204-2.698.038-4.864-.912-4.826-2.09.038-1.178 2.28-2.204 4.978-2.204 2.735-.038 4.901.912 4.825 2.09z",
    fill: "url(#prefix__paint167_linear_6821_29592)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M785.321 219.264c-.038 1.444-2.28 2.318-4.978 2.014-2.698-.342-4.864-1.786-4.864-3.229.038-1.444 2.28-2.356 4.978-2.014 2.736.342 4.902 1.786 4.864 3.229z",
    fill: "url(#prefix__paint168_linear_6821_29592)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M872.6 196.162c0 1.33-2.166 1.938-4.826 1.368-2.66-.57-4.825-2.128-4.787-3.458 0-1.33 2.165-1.938 4.825-1.368 2.66.57 4.788 2.128 4.788 3.458z",
    fill: "url(#prefix__paint169_linear_6821_29592)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M981.728 237.654c0 1.406-2.09 1.824-4.674.874-2.583-.95-4.673-2.812-4.673-4.255 0-1.406 2.09-1.824 4.673-.874 2.622.912 4.674 2.849 4.674 4.255z",
    fill: "url(#prefix__paint170_linear_6821_29592)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.7 275.994c0 1.481-1.97 1.633-4.41.342-2.43-1.292-4.4-3.496-4.44-4.94 0-1.444 1.97-1.634 4.41-.342 2.47 1.216 4.44 3.458 4.44 4.94z",
    fill: "url(#prefix__paint171_linear_6821_29592)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.22 294.687c-.03 1.558-2.09 1.824-4.56.608-2.47-1.216-4.44-3.458-4.4-4.978.03-1.558 2.09-1.824 4.56-.608 2.47 1.178 4.44 3.42 4.4 4.978z",
    fill: "url(#prefix__paint172_linear_6821_29592)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.42 342.372c-.12 1.71-2.21 2.014-4.64.76-2.43-1.292-4.33-3.685-4.25-5.395.11-1.71 2.2-2.052 4.63-.76 2.47 1.254 4.37 3.685 4.26 5.395z",
    fill: "url(#prefix__paint173_linear_6821_29592)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.89 355.901c-.11 1.71-2.17 1.976-4.56.57-2.39-1.406-4.26-3.914-4.14-5.624.11-1.709 2.16-1.975 4.56-.57 2.39 1.368 4.25 3.914 4.14 5.624z",
    fill: "url(#prefix__paint174_linear_6821_29592)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.44 330.101c-.08 1.634-2.13 1.9-4.56.608-2.43-1.33-4.33-3.724-4.26-5.358.08-1.634 2.13-1.9 4.56-.608 2.43 1.33 4.33 3.724 4.26 5.358z",
    fill: "url(#prefix__paint175_linear_6821_29592)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.31 344.653c-.11 1.71-2.16 1.976-4.6.608-2.43-1.368-4.29-3.799-4.21-5.471.11-1.672 2.16-1.976 4.59-.608 2.44 1.292 4.34 3.761 4.22 5.471z",
    fill: "url(#prefix__paint176_linear_6821_29592)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.58 438.808c-.23 1.9-2.24 2.014-4.45.266-2.2-1.748-3.83-4.673-3.61-6.573.23-1.862 2.21-2.014 4.45-.266 2.28 1.71 3.88 4.673 3.61 6.573z",
    fill: "url(#prefix__paint177_linear_6821_29592)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.98 428.169c-.27 1.9-2.32 2.128-4.6.532-2.28-1.595-3.95-4.445-3.69-6.345.23-1.9 2.28-2.128 4.6-.532 2.28 1.596 3.95 4.446 3.69 6.345z",
    fill: "url(#prefix__paint178_linear_6821_29592)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.98 448.459c-.3 2.014-2.43 2.356-4.75.836-2.28-1.558-3.91-4.407-3.57-6.421.3-1.976 2.43-2.356 4.75-.836 2.28 1.52 3.91 4.407 3.57 6.421z",
    fill: "url(#prefix__paint179_linear_6821_29592)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.59 480.681c-.42 2.09-2.51 2.432-4.75.798s-3.73-4.635-3.35-6.725c.38-2.052 2.51-2.432 4.75-.798 2.25 1.634 3.77 4.673 3.35 6.725z",
    fill: "url(#prefix__paint180_linear_6821_29592)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.27 462.938c-.38 2.089-2.54 2.545-4.82 1.063-2.28-1.481-3.88-4.369-3.5-6.459.34-2.052 2.51-2.546 4.83-1.064 2.28 1.52 3.87 4.408 3.49 6.46z",
    fill: "url(#prefix__paint181_linear_6821_29592)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.26 413.692c-.27 1.938-2.4 2.394-4.79.988-2.39-1.368-4.1-4.065-3.88-6.003.23-1.938 2.4-2.394 4.79-.988 2.4 1.368 4.14 4.066 3.88 6.003z",
    fill: "url(#prefix__paint182_linear_6821_29592)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.67 451.12c-.22 1.9-2.16 1.938-4.33.114-2.16-1.824-3.72-4.864-3.49-6.726.23-1.861 2.16-1.937 4.33-.114 2.16 1.786 3.72 4.826 3.49 6.726z",
    fill: "url(#prefix__paint183_linear_6821_29592)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.19 466.811c-.3 1.976-2.36 2.128-4.52.38-2.17-1.786-3.73-4.788-3.42-6.764.3-1.975 2.32-2.127 4.52-.38 2.2 1.748 3.72 4.788 3.42 6.764z",
    fill: "url(#prefix__paint184_linear_6821_29592)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.91 470.042c-.35 2.014-2.4 2.242-4.6.532-2.2-1.71-3.72-4.711-3.38-6.725.34-2.014 2.39-2.242 4.59-.532 2.21 1.71 3.73 4.711 3.39 6.725z",
    fill: "url(#prefix__paint185_linear_6821_29592)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.74 521.337c-.46 2.128-2.55 2.318-4.64.456s-3.42-5.091-2.96-7.219c.46-2.128 2.51-2.318 4.64-.456 2.09 1.862 3.42 5.091 2.96 7.219z",
    fill: "url(#prefix__paint186_linear_6821_29592)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.82 536.079c-.53 2.204-2.69 2.508-4.78.722-2.09-1.824-3.35-5.053-2.85-7.257.53-2.204 2.66-2.508 4.75-.722 2.12 1.824 3.42 5.053 2.88 7.257z",
    fill: "url(#prefix__paint187_linear_6821_29592)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.95 547.556c-.54 2.165-2.59 2.317-4.6.38-2.02-1.976-3.23-5.32-2.74-7.486.5-2.166 2.59-2.318 4.6-.38 2.05 1.976 3.27 5.32 2.74 7.486z",
    fill: "url(#prefix__paint188_linear_6821_29592)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.05 514.081c-.42 2.09-2.43 2.166-4.48.266-2.05-1.938-3.42-5.168-3.04-7.22.38-2.051 2.39-2.203 4.48-.266 2.09 1.9 3.46 5.13 3.04 7.22z",
    fill: "url(#prefix__paint189_linear_6821_29592)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.78 408.829c-.19 1.824-2.13 1.9-4.41.228-2.24-1.672-3.95-4.483-3.76-6.307.15-1.786 2.13-1.9 4.41-.228 2.24 1.672 3.91 4.483 3.76 6.307z",
    fill: "url(#prefix__paint190_linear_6821_29592)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.45 432.842c-.23 1.862-2.21 1.938-4.41.19s-3.84-4.673-3.61-6.535c.19-1.862 2.17-1.938 4.41-.228 2.24 1.786 3.84 4.711 3.61 6.573z",
    fill: "url(#prefix__paint191_linear_6821_29592)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M669.201 162.801c-.038 1.254-2.28 2.318-5.016 2.356-2.736.038-4.901-.95-4.825-2.242.038-1.253 2.279-2.317 5.015-2.355 2.736-.038 4.902.95 4.826 2.241z",
    fill: "url(#prefix__paint192_linear_6821_29592)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M512.624 206.535c-.076 1.406-2.318 2.963-5.016 3.495s-4.826-.19-4.75-1.596c.076-1.405 2.318-2.963 5.016-3.495s4.826.19 4.75 1.596z",
    fill: "url(#prefix__paint193_linear_6821_29592)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M562.619 159.267c-.076 1.254-2.318 2.546-5.054 2.888-2.698.342-4.826-.38-4.75-1.634.076-1.254 2.318-2.545 5.054-2.887 2.698-.342 4.826.38 4.75 1.633z",
    fill: "url(#prefix__paint194_linear_6821_29592)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M269.248 319.993c-2.165 2.014-4.939 3.04-6.155 2.28-1.216-.76-.456-3.002 1.748-5.016 2.166-2.014 4.939-3.04 6.155-2.28 1.216.76.418 3.002-1.748 5.016z",
    fill: "url(#prefix__paint195_linear_6821_29592)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M241.663 399.025c-2.052 2.318-4.749 3.496-6.041 2.66-1.292-.836-.684-3.42 1.368-5.737 2.052-2.318 4.749-3.496 6.041-2.622 1.292.836.684 3.381-1.368 5.699z",
    fill: "url(#prefix__paint196_linear_6821_29592)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M112.211 350.39c-.076 1.671-2.014 4.483-4.294 6.307-2.28 1.824-4.065 1.976-3.989.304.076-1.672 2.013-4.484 4.293-6.307 2.318-1.824 4.104-1.938 3.99-.304z",
    fill: "url(#prefix__paint197_linear_6821_29592)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M137.819 288.114c-.152 1.482-2.203 4.028-4.521 5.661-2.356 1.634-4.104 1.748-3.952.266.152-1.481 2.204-4.065 4.522-5.661 2.355-1.634 4.141-1.748 3.951-.266z",
    fill: "url(#prefix__paint198_linear_6821_29592)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M207.087 234.577c-.19 1.368-2.28 3.609-4.711 4.977-2.432 1.406-4.256 1.406-4.066.038.19-1.368 2.28-3.609 4.712-5.015 2.431-1.368 4.255-1.368 4.065 0z",
    fill: "url(#prefix__paint199_linear_6821_29592)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M255.189 185.181c-.19 1.254-2.356 3.229-4.826 4.407-2.47 1.216-4.332 1.178-4.142-.076.19-1.254 2.356-3.229 4.826-4.445 2.508-1.178 4.332-1.102 4.142.114z",
    fill: "url(#prefix__paint200_linear_6821_29592)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M274.678 195.63c-.19 1.291-2.356 3.267-4.864 4.445-2.508 1.178-4.407 1.064-4.217-.228.19-1.292 2.355-3.306 4.863-4.445 2.508-1.14 4.37-1.026 4.218.228z",
    fill: "url(#prefix__paint201_linear_6821_29592)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M377.733 159.723c-.152 1.216-2.394 2.888-4.977 3.762-2.584.874-4.56.57-4.408-.646.152-1.216 2.356-2.926 4.978-3.762 2.583-.836 4.559-.532 4.407.646z",
    fill: "url(#prefix__paint202_linear_6821_29592)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M444.985 96.877c-.152 1.026-2.355 2.394-4.977 3.002-2.584.608-4.56.304-4.408-.76.152-1.064 2.356-2.394 4.978-3.04 2.584-.57 4.559-.228 4.407.798z",
    fill: "url(#prefix__paint203_linear_6821_29592)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M249.489 226.939c-.152 1.367-2.318 3.495-4.788 4.787-2.47 1.292-4.369 1.216-4.217-.152.152-1.368 2.317-3.534 4.787-4.787 2.47-1.292 4.37-1.216 4.218.152z",
    fill: "url(#prefix__paint204_linear_6821_29592)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M275.212 236.819c-.152 1.406-2.28 3.534-4.788 4.788-2.508 1.216-4.446 1.102-4.332-.342.114-1.406 2.28-3.572 4.788-4.788 2.546-1.216 4.484-1.064 4.332.342z",
    fill: "url(#prefix__paint205_linear_6821_29592)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M309.83 209.462c-.152 1.33-2.318 3.306-4.864 4.407-2.545 1.102-4.483.912-4.369-.455.152-1.33 2.318-3.344 4.863-4.446 2.546-1.064 4.522-.836 4.37.494z",
    fill: "url(#prefix__paint206_linear_6821_29592)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M321.567 174.809c-.152 1.253-2.356 3.077-4.902 4.103-2.545 1.026-4.483.836-4.293-.38.152-1.254 2.356-3.077 4.901-4.103 2.508-1.064 4.446-.874 4.294.38z",
    fill: "url(#prefix__paint207_linear_6821_29592)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M431.232 131.341c-.152 1.14-2.394 2.621-4.978 3.305-2.621.684-4.597.342-4.483-.798.152-1.14 2.394-2.659 4.977-3.343 2.622-.684 4.636-.304 4.484.836z",
    fill: "url(#prefix__paint208_linear_6821_29592)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M548.262 84.605c-.114 1.025-2.317 2.127-4.939 2.47-2.622.341-4.674-.19-4.56-1.217.114-1.026 2.318-2.127 4.94-2.47 2.584-.341 4.635.19 4.559 1.216z",
    fill: "url(#prefix__paint209_linear_6821_29592)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M489.704 97.942c-.114 1.064-2.356 2.318-4.977 2.812-2.622.494-4.636.076-4.522-.988.114-1.064 2.356-2.318 4.978-2.85 2.621-.494 4.673-.038 4.521 1.026z",
    fill: "url(#prefix__paint210_linear_6821_29592)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M120.453 277.246c-.19 1.444-2.242 3.952-4.522 5.624-2.318 1.634-4.027 1.824-3.837.342.189-1.444 2.203-3.99 4.521-5.624 2.28-1.633 4.028-1.785 3.838-.342z",
    fill: "url(#prefix__paint211_linear_6821_29592)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M187.1 217.328c-.228 1.329-2.318 3.495-4.712 4.901-2.393 1.406-4.179 1.482-3.951.152.19-1.33 2.318-3.534 4.711-4.901 2.356-1.406 4.142-1.444 3.952-.152z",
    fill: "url(#prefix__paint212_linear_6821_29592)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M94.808 281.275c-.076 1.368-2.014 3.876-4.294 5.661-2.28 1.786-4.066 2.128-3.99.76.076-1.368 1.976-3.913 4.294-5.699 2.28-1.748 4.066-2.09 3.99-.722z",
    fill: "url(#prefix__paint213_linear_6821_29592)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M261.605 291.723a756.112 756.112 0 00-12.121 6.611c-1.634.76-3.268 1.558-4.939 2.318-.912.532-1.862 1.064-2.774 1.596l.114-2.166c-2.09-.266-5.434-.228-7.068.722l-1.595.912-5.13 2.85c-.684.418-1.368.798-2.052 1.216-.57.684-1.102 1.33-1.672 2.014-1.786 1.025-3.571 2.089-5.357 3.153-.152.038-1.52.456-1.634-.342-.076-.532.418-1.444 1.52-2.622 1.634-1.747 3.306-3.533 4.939-5.281a873.648 873.648 0 0117.251-9.879c2.66-.836 5.281-1.71 7.941-2.508 1.33.114 2.622.228 3.952.342 2.242-.988 4.521-1.976 6.763-2.964l1.976 1.862c-.038.76-.076 1.444-.114 2.166zm-17.326 7.599c.19-.114.342-.19.531-.304a192.912 192.912 0 014.94-2.317 763.222 763.222 0 019.537-5.206c0-.152 0-.304.038-.418-.418-.38-.836-.722-1.254-1.064-2.09.912-4.179 1.824-6.269 2.774-1.444-.114-2.85-.228-4.294-.38-2.356.76-4.711 1.52-7.067 2.318a732.657 732.657 0 00-15.807 9.119c-1.444 1.52-2.849 3.04-4.293 4.559-.38.418-.494.608-.532.646l.038-.038 3.647-2.165c.57-.684 1.102-1.33 1.672-2.014l3.078-1.824a458.007 458.007 0 015.851-3.268c-.038.266-.038.532-.076.836.304-.418.608-.874.874-1.292 3.42-1.938 8.208-1.33 9.158-1.178.114 0 .19.038.304.038-.076.38-.076.798-.076 1.178z",
    fill: "url(#prefix__paint214_linear_6821_29592)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M250.624 285.377c-2.166 1.178-4.293 2.356-6.459 3.534-.266-1.178-.532-2.356-.76-3.496.722-.835 1.482-1.671 2.204-2.507-.19-.266-.38-.494-.57-.76.038-.798.114-1.558.152-2.356 3.267-1.938 6.573-3.876 9.841-5.813.418 1.101.798 2.203 1.216 3.267-1.216.836-2.432 1.634-3.61 2.47-.304.456-.608.912-.912 1.406-.38 1.444-.722 2.85-1.102 4.255zm-4.293.874l2.279-1.253c.304-1.102.608-2.166.912-3.268.532-.798 1.026-1.596 1.558-2.394.798-.532 1.558-1.064 2.356-1.596-.152-.38-.266-.76-.418-1.14a411.276 411.276 0 00-5.472 3.23c0 .266-.038.57-.038.836.342.342.646.684.988.988-.836.95-1.672 1.9-2.507 2.812.114.608.228 1.177.342 1.785z",
    fill: "url(#prefix__paint215_linear_6821_29592)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M261.224 280.742a290.008 290.008 0 00-5.852 3.115c.114-1.329.266-2.697.418-4.027 1.9-1.026 3.8-2.014 5.7-3.002-.114 1.292-.19 2.622-.266 3.914zm-3.268.266c.304-.152.608-.304.912-.494 0-.304.038-.608.038-.912-.304.152-.57.304-.874.456 0 .342-.038.646-.076.95z",
    fill: "url(#prefix__paint216_linear_6821_29592)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M262.282 282.946c-2.279 1.216-4.559 2.394-6.801 3.648.038-.988.114-2.014.152-3.002 2.28-1.216 4.56-2.432 6.839-3.61a72.87 72.87 0 00-.19 2.964z",
    fill: "url(#prefix__paint217_linear_6821_29592)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M265.555 285.226a356.651 356.651 0 00-6.688 3.002c-.646-.076-1.33-.114-1.976-.19a152.764 152.764 0 012.204-3.04c2.242-1.14 4.446-2.28 6.688-3.42l-.228 3.648zm-5.472.95c1.026-.456 2.09-.95 3.116-1.406 0-.152 0-.304.038-.418-.988.494-1.976 1.026-2.964 1.52a.827.827 0 00-.19.304c-.038 0 0 0 0 0z",
    fill: "url(#prefix__paint218_linear_6821_29592)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M250.883 303.503c-3.99 2.242-7.98 4.484-11.969 6.764.038-1.482.114-2.964.19-4.446a941.28 941.28 0 0111.969-6.725 163.78 163.78 0 00-.19 4.407zm-9.499 3.8c2.355-1.368 4.749-2.698 7.143-4.028 0-.418.038-.874.038-1.292-2.394 1.33-4.75 2.66-7.143 4.028 0 .418-.038.874-.038 1.292z",
    fill: "url(#prefix__paint219_linear_6821_29592)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M267.64 294.383c-.607.114-1.215.266-1.861.38-3.496 1.862-6.992 3.723-10.449 5.623.038-1.102.076-2.204.152-3.305 2.393-1.292 4.749-2.584 7.143-3.838.38-1.064.722-2.128 1.102-3.192a917.906 917.906 0 0113.489-7.295l6.269-1.254c-.228.988-.456 1.976-.646 2.964-2.584 1.71-5.129 3.457-7.713 5.167-1.254.76-2.546 1.558-3.8 2.318-1.254.836-2.47 1.634-3.686 2.432zm-9.803 3.154c2.85-1.558 5.738-3.078 8.588-4.598.532-.114 1.063-.228 1.633-.342.95-.608 1.938-1.254 2.888-1.862 1.254-.76 2.47-1.52 3.724-2.28 1.976-1.33 3.952-2.697 5.965-4.027.038-.228.114-.456.152-.646-1.406.266-2.773.57-4.179.836a607.762 607.762 0 00-10.981 5.927c-.38 1.064-.76 2.166-1.102 3.23-2.204 1.178-4.446 2.356-6.65 3.572-.038.038-.038.114-.038.19z",
    fill: "url(#prefix__paint220_linear_6821_29592)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M296.641 280.514c-1.671.798-3.343 1.596-4.977 2.394-2.166.684-4.332 1.406-6.498 2.09-.19-1.14-.341-2.28-.531-3.382a955.254 955.254 0 019.005-4.294c-.038.57-.038 1.14-.076 1.71 1.102-.532 2.166-1.064 3.267-1.558-.076 1.026-.152 2.014-.19 3.04zm-4.407.646c.684-.342 1.33-.646 2.014-.988-.722.342-1.444.684-2.128 1.026.038 0 .076 0 .114-.038zm-4.75 1.52c1.178-.38 2.356-.76 3.496-1.14.038-.532.038-1.026.076-1.558-1.254.608-2.47 1.178-3.724 1.786.038.342.076.646.152.912z",
    fill: "url(#prefix__paint221_linear_6821_29592)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M350.099 311.102c-.228.076-.418.152-.646.19-.114.038-3.116.988-5.319.532-.266-.076-.57-.114-.836-.19 2.013-2.318 4.027-4.598 6.041-6.916.304 0 .57-.037.874-.037.152 0 3.344-.114 3.306 2.355v.342c-1.14 1.254-2.28 2.47-3.42 3.724zm-3.23-1.14c.874 0 1.824-.19 2.432-.304l1.71-1.824c-.152-.684-.76-.988-1.292-1.102a246.01 246.01 0 00-2.85 3.23z",
    fill: "url(#prefix__paint222_linear_6821_29592)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M358.119 309.467c-1.406.57-2.926.684-4.522.342-.266-.076-.532-.114-.798-.19.228-.304.456-.57.684-.874.228-.304 2.356-2.926 4.94-3.8 1.406-.494 2.546-.304 3.344.532.076.076.152.152.19.228-.038.114-.114.266-.152.38-.076.19-.836 1.862-2.888 3.002-.228.114-.494.266-.798.38zm-1.786-1.444c.798.076 1.52-.038 2.014-.304.38-.228.684-.57.874-.836a1.25 1.25 0 00-1.064-.19c-.532.19-1.254.76-1.824 1.33z",
    fill: "url(#prefix__paint223_linear_6821_29592)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M64.966 326.756c-.57.076-1.14.152-1.672.228.342-1.064.646-2.128.988-3.192.304-.266.608-.494.912-.76.152-.114.532-.417 2.47-1.557.228-.152.456-.266.684-.418a311.62 311.62 0 01-.228 2.013c-.646.684-1.33 1.33-1.976 2.014-.38.608-.76 1.14-1.178 1.672z",
    fill: "url(#prefix__paint224_linear_6821_29592)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M71.042 320.563c-1.33 1.026-2.66 2.09-3.952 3.154l-.114-1.862c.874-1.064 1.748-2.09 2.66-3.154.798-.379 1.596-.721 2.356-1.101-.304.722-.57 1.443-.874 2.165a5.67 5.67 0 00-.076.798z",
    fill: "url(#prefix__paint225_linear_6821_29592)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M128.344 280.058c-2.736 1.9-5.51 3.838-8.245 5.776.152-1.292.304-2.584.494-3.876 1.785-1.254 3.533-2.508 5.319-3.724.836.608 1.634 1.216 2.432 1.824zm-5.776 2.736c.798-.57 1.558-1.102 2.356-1.672-.228-.152-.418-.304-.646-.456l-1.596 1.14c-.038.342-.076.684-.114.988z",
    fill: "url(#prefix__paint226_linear_6821_29592)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M126.982 285.036c-2.014 1.406-4.028 2.85-6.042 4.256-.38-.646-.76-1.292-1.102-1.938l2.85-3.534c1.558-.722 3.154-1.444 4.712-2.166-.152 1.14-.304 2.242-.418 3.382zm-4.218 1.634c.684-.494 1.406-.988 2.09-1.482.038-.342.076-.646.114-.988-.646.304-1.33.608-1.976.912-.228.266-.418.532-.646.798.114.266.266.532.418.76z",
    fill: "url(#prefix__paint227_linear_6821_29592)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M314.61 290.013c-2.621 1.216-5.243 2.432-7.865 3.686 0-.456.038-.912.038-1.368-.494-.076-1.026-.152-1.52-.228l.114-2.964 1.596-1.709c0-.532.038-1.026.038-1.558l2.204-2.204c.076-.456.152-.912.228-1.406.456-.494.912-.988 1.406-1.444 0-.456.038-.95.038-1.406-.266-.152-.532-.342-.798-.494-1.254.304-2.47.608-3.724.912l.114-3.001c2.888-1.33 5.738-2.66 8.625-3.952.342.456.646.912.988 1.368.152.608.304 1.254.456 1.862.494.076 1.026.152 1.52.228l-.456 3.077c-.95.532-1.9 1.102-2.85 1.634-.038.57-.038 1.178-.076 1.748-.494.494-.95 1.026-1.444 1.52-.455.266-.949.57-1.405.836 0 .418-.038.874-.038 1.292-.38.418-.76.836-1.178 1.216l.342 1.14c1.216-.57 2.431-1.14 3.685-1.71 0 1.026 0 1.975-.038 2.925zm-6.839.266c.266.038.57.076.836.114-.19-.646-.38-1.329-.57-1.975l1.368-1.482-1.558 1.672a25.707 25.707 0 00-.076 1.671zm4.028-8.435c-.076.494-.152.95-.228 1.444-.418.418-.874.836-1.292 1.292l1.938-1.254c.038-.684.038-1.368.076-2.014-.114.19-.304.342-.494.532zm-2.888-4.217a82.07 82.07 0 002.926-.722c.532.304 1.025.646 1.557.949l-.114 2.432-.228.228c.76-.418 1.52-.874 2.28-1.292.038-.38.114-.722.152-1.102a13.998 13.998 0 00-1.33-.19c-.19-.721-.342-1.481-.532-2.203-.114-.19-.266-.342-.38-.532-1.443.646-2.925 1.33-4.369 2.014.038.114.038.266.038.418z",
    fill: "url(#prefix__paint228_linear_6821_29592)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M324.525 281.084a390.186 390.186 0 00-6.992 3.154c.038-1.444.114-2.926.152-4.369 2.318-1.064 4.674-2.09 6.992-3.154-.038 1.444-.114 2.926-.152 4.369zm-4.446.456c.646-.304 1.33-.608 1.976-.911 0-.418.038-.836.038-1.292-.646.304-1.33.608-1.976.874 0 .493-.038.911-.038 1.329z",
    fill: "url(#prefix__paint229_linear_6821_29592)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M305.678 278.88c-1.178.532-2.318 1.102-3.496 1.634-.76-.114-1.519-.228-2.279-.304a51.502 51.502 0 01-.304-2.394c1.292-.608 2.621-1.254 3.913-1.862.19-.531.418-1.025.608-1.557 2.052-.95 4.142-1.938 6.194-2.85-.228 1.216-.494 2.47-.722 3.686-.798.418-1.596.835-2.356 1.253-.532.798-1.026 1.596-1.558 2.394zm-2.394-.38c.304-.152.646-.304.95-.456.038-.038.038-.076.076-.114-.494-.076-.988-.114-1.482-.19-.19.076-.38.19-.57.266 0 .114.038.266.038.38.342.038.646.076.988.114zm2.698-3.495c-.114.304-.228.608-.38.911.038-.038.076-.076.076-.152.57-.303 1.102-.607 1.672-.873.038-.19.076-.418.114-.608-.456.266-.95.494-1.482.722z",
    fill: "url(#prefix__paint230_linear_6821_29592)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M316.47 272.459a367.283 367.283 0 00-6.801 3.116c.076-1.368.114-2.774.19-4.142 2.279-1.026 4.559-2.09 6.801-3.078-.038 1.33-.114 2.698-.19 4.104zm-4.256.456c.608-.266 1.216-.57 1.824-.836 0-.38.038-.76.038-1.14-.608.266-1.216.532-1.824.836 0 .38 0 .76-.038 1.14z",
    fill: "url(#prefix__paint231_linear_6821_29592)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M303.889 275.841c-1.14.532-2.242 1.064-3.381 1.596-.988.152-1.938.342-2.926.532.038-1.14.114-2.318.152-3.458 2.128-.987 4.217-2.013 6.345-3.001-.038 1.444-.114 2.887-.19 4.331zm-2.736-.19c.114-.038.19-.114.304-.152.038-.456.038-.874.076-1.329-.456.228-.911.417-1.367.645 0 .342-.038.684-.038 1.026.342-.076.684-.114 1.025-.19z",
    fill: "url(#prefix__paint232_linear_6821_29592)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M357.014 181.989c.076-.76.152-1.482.266-2.242 4.75-3.762 9.576-7.485 14.401-11.171 1.748-.57 3.458-1.178 5.206-1.748-.076.76-.19 1.52-.266 2.28-.456.342-.912.684-1.368 1.064.266.038.494.076.76.114.95-.228 1.862-.494 2.811-.722.95-.19 1.938-.38 2.888-.532.836.456 1.672.95 2.508 1.406-.418.874-.836 1.71-1.254 2.584-1.672.532-3.344 1.101-5.015 1.633-7.03 2.356-13.983 4.826-20.937 7.334zm2.698-2.584c0 .152-.038.304-.038.456a883.168 883.168 0 0121.354-7.371 22.5 22.5 0 00.456-.95c-.532-.304-1.064-.608-1.634-.912-.57.114-1.178.228-1.747.342-1.14.304-2.318.608-3.458.912-.988-.152-2.014-.304-3.002-.456.836-.646 1.634-1.292 2.47-1.9.038-.19.038-.38.076-.57-.532.19-1.064.342-1.596.532-.456.38-.95.722-1.406 1.102a510.572 510.572 0 00-11.475 8.815z",
    fill: "url(#prefix__paint233_linear_6821_29592)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M353.059 512.711c-3.001 1.748-6.003 3.496-8.967 5.319-.19-.912-.342-1.861-.532-2.773-1.824 1.102-3.61 2.203-5.433 3.305-.418-2.127-.798-4.255-1.216-6.383-1.824 1.102-3.648 2.242-5.434 3.344-.076-.38-.152-.722-.19-1.102a336.329 336.329 0 00-4.749 3.001c-.95-.341-1.9-.721-2.85-1.063-.494-.684-.95-1.368-1.444-2.09-.798.494-1.596 1.026-2.394 1.52-1.862-.57-3.723-1.178-5.623-1.748-.342-1.824-.684-3.648-.988-5.472-1.292-.38-2.546-.76-3.838-1.14-.19-1.064-.38-2.165-.57-3.229-2.66-.76-5.357-1.52-8.017-2.242a370.162 370.162 0 012.774-5.472l-.798-4.901c-.646-.19-1.254-.342-1.9-.532l-.684-4.218c-2.242-.608-4.522-1.178-6.763-1.786-.114-.646-.19-1.291-.304-1.937-.722-.19-1.406-.342-2.128-.532-.304-1.9-.57-3.838-.836-5.738-.874-.228-1.748-.418-2.622-.646-.456-3.04-.874-6.117-1.292-9.157.684-1.178 1.33-2.394 2.014-3.572-.38-2.773-.722-5.509-1.064-8.283-.912-.19-1.824-.418-2.736-.608a369.294 369.294 0 01-.76-6.421c-.797-1.064-1.595-2.09-2.393-3.116a1345.854 1345.854 0 01-1.824-17.82c-.57-.114-1.102-.228-1.672-.342-.19-1.862-.342-3.762-.494-5.624.798-1.216 1.596-2.47 2.394-3.686a385.808 385.808 0 01-1.52-6.383c-.798-.836-1.596-1.71-2.394-2.546a90.727 90.727 0 00-3.116-.646c-.038 0-3.951-3.875-20.29.874-.152 0-.266.038-.418.038-.152-.038-3.381-.798-5.813-5.927-1.71.152-7.713.418-8.017-4.826-.038.038-3.116-8.093-11.057-5.167-.266.076-.532.19-.76.266l-.114-3.154c-.722.076-1.786.038-2.09-.912-.228-.684-.038-1.634.57-2.888 1.064-2.166 2.166-4.293 3.268-6.459-.988-.114-1.976-.19-2.964-.304 0-1.672-.038-3.344-.038-5.016.152-.38 3.685-9.499 13.641-22.874v-8.397c-.418-.038-.874-.076-1.292-.114 0-1.596 0-3.192.038-4.825-1.026.19-3.61.874-5.776 3.419v2.888l-5.585 3.42c-1.596.608-3.23 1.216-4.826 1.824-2.318 1.215-4.635 2.431-6.991 3.647-2.774-.19-5.548-.38-8.36-.532 0-1.026 0-2.09.038-3.115l-3.837-.228c0-.874.038-1.748.038-2.66l-2.356-.114c-2.508 1.634-5.016 3.268-7.485 4.939-2.166.798-4.332 1.596-6.498 2.432l-8.169-.228c-1.14.798-2.318 1.634-3.458 2.432-.874 1.254-1.785 2.508-2.659 3.762-2.394 1.671-4.788 3.381-7.182 5.091-6.725 2.394-28.535 10.981-28.459 7.333 0-.873.038-1.709.038-2.583l2.28-3.42c-.076-.874-.19-1.786-.266-2.66-1.786-.95-6.726-2.887-9.88-1.444-.227.114-.455.19-.683.304.038-.874.076-1.785.076-2.659-1.71-.494-3.42-1.026-5.13-1.52a394.957 394.957 0 01-1.216-7.106c-.798.038-1.596.076-2.432.152-.152.152-.342.304-.494.532-.266.38-.342.798-.38 1.064-.038.76-.076 1.52-.114 2.242.836.722 3.876 3.382 3.8 5.168l-.228 6.003c.798 0 1.596 0 2.394-.038.912.988 1.862 1.976 2.774 2.964l-6.156 4.901c-1.748.076-3.496.152-5.205.266l.114-3.305c-1.33.076-2.66.152-3.952.228l.228-6.232.912-1.368c-1.064-.494-2.128-.95-3.154-1.444.114-2.165.19-4.331.304-6.497-.038.038-.722-1.558-6.801.798-.152.038-.266.114-.418.152-1.026-3.724-2.052-7.409-3.078-11.133.038-.95.114-1.862.19-2.812.38-1.672.798-3.344 1.178-5.015l5.129-7.182c.532-1.444 1.064-2.925 1.634-4.369a647.914 647.914 0 017.22-9.803c1.368-2.356 2.735-4.674 4.103-6.992 1.026-1.9 2.052-3.838 3.078-5.737 2.052-1.52 4.142-3.002 6.231-4.484.912-1.14 1.786-2.28 2.698-3.42.76-.912 1.558-1.785 2.318-2.697 0-.266-.038-.532-.038-.76-.608.418-1.178.836-1.786 1.254a98.937 98.937 0 00-1.862 3.457 619.315 619.315 0 01-5.281 3.762l-4.484.342c.38-1.33.76-2.698 1.14-4.028 1.292-.95 2.622-1.862 3.914-2.811.304-2.85.646-5.738.988-8.588 1.368-1.71 2.735-3.419 4.141-5.091-.836-.57-1.672-1.102-2.545-1.672.759-.912 1.481-1.824 2.241-2.736-.836.076-1.709.114-2.545.19-2.014 1.178-3.99 2.318-6.004 3.496-1.596.152-3.192.266-4.749.418-2.356 1.672-4.674 3.343-7.03 5.015a623.59 623.59 0 00-6.991 3.724c-1.672 1.482-3.344 2.926-4.978 4.408-1.634 1.709-3.23 3.419-4.863 5.129-3.116 2.356-6.194 4.75-9.31 7.143-3.001 3.154-5.965 6.308-8.929 9.462.342-.038.722-.076 1.064-.152-.114.988-.228 2.013-.342 3.001l-3.875 3.534c-.494.684-.988 1.368-1.482 2.09a561.426 561.426 0 00-7.258 6.003c.076-.684.152-1.33.228-2.013-.076.075-.152.151-.228.189-5.51 6.004-10.98 12.083-16.338 18.239-2.812 2.66-5.624 5.319-8.397 8.017.114-1.064.19-2.09.304-3.154.266-.266.532-.57.797-.836 7.676-8.321 16.719-17.896 18.2-19.91 0-.152.039-.304.039-.494-1.368.95-3.61 2.508-4.522 3.306l-.798.684c-.38-.836-.722-1.634-1.102-2.47a648.037 648.037 0 014.788-5.205c.228-1.824.418-3.686.646-5.51a959.851 959.851 0 0118.542-16.794c.646-.874 1.33-1.748 1.976-2.66-1.938 1.102-5.281 3.078-7.41 4.787-.38.304-.76.608-1.177.95.304-1.406.608-2.849.912-4.255.266-.266.532-.494.798-.76 3.078-2.888 12.805-11.513 16.11-13.071 1.216-1.33 2.47-2.66 3.686-3.99-.532.076-1.026.114-1.558.19.114-.76.228-1.482.304-2.241 3.458-2.964 6.915-5.89 10.373-8.816 4.446-4.141 8.967-8.245 13.489-12.311a596.345 596.345 0 018.549-6.041 440.496 440.496 0 016.536-5.282c3.419-2.507 6.839-4.977 10.297-7.447 3.191-1.52 6.421-3.04 9.613-4.521 2.698-1.71 5.357-3.42 8.055-5.092 3.23-1.71 6.498-3.344 9.727-5.016 2.812-1.329 5.662-2.659 8.473-3.989 3.268-1.824 6.574-3.61 9.842-5.396 4.521-3.229 9.081-6.421 13.64-9.575 2.014-1.102 3.99-2.242 6.004-3.344 1.71-1.215 3.381-2.431 5.091-3.609 2.812-1.178 5.586-2.356 8.398-3.496 3.381-1.672 6.763-3.344 10.183-5.015a735.81 735.81 0 018.777-2.204c.912 0 1.824 0 2.698.038 3.875-1.938 7.751-3.838 11.665-5.738.57 0 1.14.038 1.747.038 1.368-1.216 2.698-2.47 4.066-3.685a813.844 813.844 0 0113.071-6.042c2.508-.722 5.053-1.444 7.561-2.166 3.154-1.786 6.346-3.533 9.537-5.319.152 0 .266 0 .418.038.114-.646.228-1.33.304-1.976.19-.152.38-.266.532-.38 2.47-1.824 8.17-5.168 11.817-4.94.266 0 .532.038.798.038-.57.494-1.14.95-1.748 1.444.19 0 .38.038.57.038.836-.684 1.634-1.368 2.47-2.052.076-.379.114-.759.19-1.101l-2.09-.114a716.174 716.174 0 019.575-6.498c2.09-.836 4.18-1.672 6.308-2.508-.19 1.216-.38 2.394-.57 3.61.19.152 1.064.532 4.787-.912.418-.152.836-.304 1.254-.494a50.61 50.61 0 01-.38 2.356l.912-.342 7.524-5.927c4.331-1.406 8.663-2.812 12.994-4.142-.114.798-.228 1.558-.342 2.356-2.811 2.166-5.623 4.331-8.397 6.535a1270.86 1270.86 0 00-12.729 4.864c-.456.342-.874.722-1.33 1.064 2.204-.76 5.13-1.52 7.562-1.292.114 0 .228.038.342.038l-.57 3.761c-1.672.646-3.306 1.292-4.978 1.938-.836-.038-1.672-.038-2.508-.076-.987.38-2.013.798-3.001 1.178-.684.456-1.368.874-2.052 1.33a590.245 590.245 0 00-5.054 2.432c.152-1.064.304-2.128.494-3.192l1.938-1.596c-.152-.266-.646-.57-2.052-.038-.608.266-1.254.494-1.862.76-.114.722-.228 1.444-.341 2.204-2.09 1.102-4.218 2.242-6.308 3.344-.418.342-.836.684-1.216 1.026-2.128.911-4.217 1.823-6.345 2.735-1.368 1.178-2.774 2.356-4.142 3.572a522.203 522.203 0 00-6.383 3.496l-.228 1.596a359.381 359.381 0 00-3.838 1.709c-6.573 4.522-12.387 9.12-12.539 9.841h.228v.114c0 .038.95 2.774 5.662 1.672.988-.304 9.993-2.773 12.691-2.887 2.963-1.33 5.927-2.622 8.853-3.914-.076.266-.19.532-.266.76-.19.532-1.672 4.825-4.218 7.675.95.076 1.862.152 2.812.228.456-.19.874-.38 1.33-.608a172.648 172.648 0 013.951-3.495l2.166-3.876c.076-.646 1.292-3.154 12.539-9.081 1.9-1.33 4.826-3.61 4.94-4.522.19-1.292.342-2.622.532-3.914.19-.114.38-.266.57-.38.038 0 3.001-2.203 8.321-7.561.076-.038.114-.114.19-.152 1.444-1.178 2.888-2.318 4.369-3.496a982.085 982.085 0 0111.095-4.141c.494-.19 9.196-2.926 10.601-.722 0 .038 0 .114.038.152-.152 1.14-.304 2.28-.456 3.382.722.076 1.444.19 2.204.266 3.61-2.356 7.22-4.674 10.867-6.992l6.156-2.052c-.152 1.026-.266 2.052-.418 3.116l1.786 1.786c-.076.722-.19 1.406-.266 2.128.95.722 1.899 1.482 2.849 2.204 2.546-.57 5.054-1.102 7.6-1.634.494.95.988 1.938 1.444 2.887-2.546 1.938-5.13 3.838-7.638 5.776a444.672 444.672 0 00-6.573 2.204c-1.368.798-2.698 1.558-4.066 2.356-.532.189-1.064.379-1.596.531-1.633.836-3.267 1.71-4.863 2.546-.912.304-1.824.646-2.698.95-1.9.722-3.8 1.444-5.661 2.204a713.24 713.24 0 00-11.589 4.332 52.93 52.93 0 00-2.584 1.405c-.038.342-.076.646-.114.988 2.736-1.064 5.509-2.089 8.245-3.115-.836 1.368-1.672 2.735-2.508 4.141a250.232 250.232 0 00-4.863 4.066c.076.304.494.646 2.052.038 4.065-1.558 8.169-3.078 12.234-4.598-.114.874-.19 1.748-.304 2.584-.113.114-.227.19-.341.304-.152.152-3.648 3.078-12.311 6.459-3.686 2.128-7.144 4.56-7.334 5.054-.038.228-.038.418-.076.646a691.108 691.108 0 00-7.903 3.154c.076-.798.152-1.596.266-2.394 1.71-1.254 3.458-2.508 5.168-3.762-.114 0-.19-.038-.304-.038-9.462 5.434-19.797 12.045-21.203 13.413-.114.95-.19 1.9-.304 2.85a650.534 650.534 0 00-10.905 6.725 688.647 688.647 0 00-9.461 8.397c-1.862.874-3.761 1.748-5.623 2.622-.988 1.368-2.014 2.698-3.002 4.066-.114 1.064-.19 2.09-.304 3.154l-4.104-.342-.265.266c-.19 1.975-.38 3.913-.532 5.889-2.812 2.85-5.586 5.699-8.36 8.549-1.52.76-3.077 1.558-4.597 2.356-1.9 2.014-3.838 4.028-5.7 6.041a285.284 285.284 0 00-5.547 3.8c-.988 1.064-1.976 2.128-2.926 3.192-1.178 1.976-2.356 3.951-3.496 5.927.646 1.102 1.292 2.204 1.9 3.306l-.456 6.459c-.418.95-.836 1.9-1.254 2.888-.19.266-2.09 2.584-4.407 3.572-1.824.798-3.116.456-3.914-1.102 0-.076-.038-.114-.038-.19l.456-7.219c-1.254-.076-2.508-.152-3.762-.19-2.469 1.292-4.977 2.583-7.447 3.875-1.406.38-2.812.798-4.256 1.178-1.254.76-2.545 1.482-3.799 2.242a343.91 343.91 0 00-5.928 7.029c-2.242 1.368-4.521 2.736-6.763 4.142l-7.182 1.938c-2.887 2.774-5.775 5.547-8.625 8.321-2.394 2.204-4.749 4.446-7.105 6.687a407.775 407.775 0 00-3.002 5.662c-.608 2.204-1.178 4.446-1.748 6.649-.95 1.672-1.862 3.382-2.773 5.054-.076 2.204-.19 4.446-.266 6.649l1.14 2.508 6.117-.114c.874-.38 4.446-2.09 7.903-5.357a830.318 830.318 0 017.41-9.804c.76-1.671 1.557-3.343 2.317-5.015 3.8-2.47 7.638-4.864 11.475-7.257 1.14.038 2.28.076 3.458.152a287.424 287.424 0 00-1.9 5.243c-1.216 2.356-2.394 4.75-3.609 7.105a484.095 484.095 0 00-3.534 4.598c.304.57.608 1.102.912 1.672 0 .494-.038.988-.038 1.482.798-.38 1.596-.798 2.394-1.178.873-1.178 1.785-2.318 2.659-3.496 2.926-1.672 5.852-3.344 8.778-4.977 1.177.076 2.355.152 3.495.228-.342 1.633-.722 3.267-1.064 4.863-.076 2.85-.114 5.662-.152 8.511 1.102.684 2.166 1.33 3.268 2.014 1.786-.76 3.572-1.52 5.358-2.242a859.654 859.654 0 0112.614-7.561c1.178-.342 2.318-.684 3.496-1.026.95-.912 1.9-1.786 2.85-2.698.798-1.937 1.596-3.913 2.394-5.851.152-.152.304-.266.456-.418.152-.114 3.457-3.116 6.991-5.206 1.9-2.317 3.838-4.597 5.775-6.877 2.09-1.14 4.18-2.28 6.232-3.382l-.114 3.876c-.836.988-1.71 1.976-2.546 3.002-.076.988-.114 1.976-.19 2.963.57.076 1.102.114 1.672.19.152-.19.304-.38.494-.569-.152-1.102-.342-2.242-.494-3.344 1.254-1.482 2.508-2.926 3.762-4.408l7.751-4.103c1.33.152 2.622.342 3.952.532a829.973 829.973 0 0117.098-7.41c1.292-.57 2.546-1.14 3.838-1.71.532-.608 1.102-1.178 1.634-1.785 2.013-.988 4.065-1.938 6.079-2.888-.038.798-.038 1.634-.076 2.432a688.95 688.95 0 0118.124 3.191c4.028-1.824 8.056-3.571 12.121-5.319 2.622-.228 5.282-.456 7.904-.684 1.178 1.672 2.393 3.381 3.571 5.053l4.674 1.026c-.57 1.482-1.178 3.002-1.748 4.484 1.406-.57 2.812-1.178 4.218-1.748.988.722 1.975 1.482 2.925 2.204a922.023 922.023 0 018.74-4.256c1.975.114 3.951.228 5.889.342.532.836 1.102 1.71 1.634 2.546 5.281-2.014 10.601-3.99 15.921-5.928 2.887-.569 5.737-1.101 8.625-1.671 2.318.646 4.597 1.329 6.877 1.975 2.926-.494 5.852-.987 8.777-1.443 1.026 1.443 2.052 2.925 3.078 4.369v7.258c-1.33 1.443-2.66 2.925-3.99 4.369l-3.229 3.23c-.418.95-.798 1.9-1.216 2.85a872.232 872.232 0 00-5.966 6.117c-.57 1.178-1.178 2.356-1.747 3.534.076 3.989.151 7.979.265 11.931-.721.798-1.443 1.596-2.165 2.355.304 1.52.608 3.04.912 4.522-.798.874-1.596 1.748-2.356 2.622l1.026 4.103c-1.71 2.774-3.42 5.586-5.13 8.36a692.181 692.181 0 00-11.589 6.535c-1.71 1.14-3.381 2.28-5.091 3.42-1.596 1.406-3.154 2.774-4.712 4.179l-4.104 5.13c.19 3.192.38 6.421.608 9.613l-4.901 6.383c.228 2.242.418 4.484.646 6.726-3.306 6.193-6.536 12.425-9.613 18.656-4.028 2.356-8.056 4.712-12.083 7.144-.988-.304-1.976-.608-3.002-.912l-.076.076c-.076.114-.342.532-.304 1.368 1.52.911 3.04 1.861 4.522 2.811.266 2.47.532 4.94.798 7.448-.874 1.329-1.71 2.659-2.584 3.951a1002.689 1002.689 0 00-11.019 5.89c-.532.912-1.368 2.469-1.254 3.419.038.418.228.646.646.76.114.038.266.076.38.114.228 1.71.418 3.458.646 5.168-.076.152-.19.304-.266.456-.152.228-1.368 2.356-3.42 3.572-1.178.645-2.356.949-3.534.721-.304.19-.608.418-.684.57.038 0 .266.608 2.356 1.254.114.076.228.152.304.228.798 1.178 1.596 2.318 2.394 3.496.152 1.292.304 2.546.456 3.8-.266 1.063-.494 2.165-.722 3.229l-2.28 6.384c1.52.456 3.002.95 4.522 1.444.874 2.355 1.748 4.673 2.622 7.029-.988 2.85-1.938 5.737-2.888 8.587l.456 2.736c1.026.342 2.052.684 3.04 1.026.151.798.265 1.634.417 2.432l5.662.228c2.166-.418 4.37-.798 6.535-1.178 2.508.038 5.054.038 7.562.114 1.102.76 2.242 1.52 3.343 2.28a384.914 384.914 0 00-8.625 4.901c-.418.912-.722 1.482-1.026 2.052zm-7.105 1.596c1.9-1.14 3.838-2.28 5.775-3.382.304-.57.608-1.14.912-1.748l5.016-2.85h-6.536c-2.203.38-4.369.798-6.573 1.178l-7.067-.228c-.152-.912-.342-1.823-.494-2.773-1.026-.342-2.052-.684-3.04-1.026-.266-1.444-.494-2.888-.76-4.294.912-2.774 1.824-5.585 2.774-8.359-.722-1.9-1.406-3.762-2.128-5.662-1.786-.57-3.572-1.14-5.395-1.709.949-2.736 1.937-5.472 2.925-8.246.19-.95.418-1.862.608-2.811-.152-.988-.266-1.976-.418-2.964l-2.052-2.85c-1.595-.494-3.495-1.406-2.925-3.382.532-1.861 2.773-3.077 3.229-3.267l.456-.228.342.114c.722.228 1.406.152 2.052-.228 0 0 .038 0 .038-.038.684-.418 1.254-1.102 1.558-1.52-.152-1.14-.304-2.28-.456-3.458-.684-.342-1.064-.95-1.14-1.786-.228-2.28 1.9-5.471 2.128-5.813.114-.152.19-.304.304-.456a609.397 609.397 0 0110.981-5.89c.418-.684.874-1.33 1.292-2.013-.228-1.976-.418-3.952-.646-5.928-1.52-.95-3.04-1.862-4.56-2.812 0-.114-.038-.228-.038-.342-.152-1.405.19-2.659 1.026-3.723.95-1.216 2.128-1.634 2.242-1.672.114-.038.228-.076.38-.114.95.266 1.862.57 2.812.836 3.267-1.976 6.535-3.876 9.803-5.776a711.26 711.26 0 018.701-16.87l-.684-6.954c1.634-2.127 3.268-4.293 4.902-6.421a766.973 766.973 0 01-.608-9.613c1.71-2.128 3.419-4.256 5.167-6.384 1.71-1.519 3.458-3.077 5.206-4.597a437.087 437.087 0 015.357-3.572 594.611 594.611 0 0110.677-6.041c1.368-2.242 2.736-4.522 4.104-6.764-.38-1.444-.722-2.887-1.102-4.331.798-.874 1.596-1.786 2.394-2.66-.304-1.52-.608-3.002-.912-4.522l2.28-2.507c-.076-3.914-.114-7.828-.152-11.741.722-1.444 1.482-2.85 2.204-4.294a804.107 804.107 0 015.699-5.889c.418-.95.798-1.9 1.216-2.85 1.178-1.216 2.394-2.394 3.572-3.61a5716.47 5716.47 0 013.305-3.647v-6.498c-.798-1.14-1.634-2.242-2.431-3.382a305.17 305.17 0 00-8.17 1.368c-2.28-.684-4.559-1.33-6.877-1.976-2.584.494-5.168.988-7.789 1.52a727.829 727.829 0 00-17.251 6.498c-.646-1.026-1.292-2.052-1.976-3.04-1.482-.076-2.925-.19-4.407-.266-3.154 1.52-6.308 3.078-9.461 4.636-1.026-.76-2.052-1.558-3.078-2.318-2.014.836-4.066 1.672-6.08 2.546.76-1.976 1.52-3.914 2.28-5.89l-4.103-1.026c-1.102-1.596-2.242-3.154-3.382-4.749l-6.498.57c-4.179 1.823-8.359 3.647-12.538 5.547a776.772 776.772 0 00-19.569-3.42c0-.494.038-1.026.038-1.519-.836.417-1.71.797-2.545 1.215-.57.608-1.14 1.254-1.71 1.862-1.672.722-3.344 1.482-5.016 2.204-6.003 2.546-12.045 5.13-18.01 7.827-1.292-.152-2.546-.342-3.838-.494-1.9.988-3.838 2.014-5.737 3.04-.722.836-1.444 1.71-2.166 2.546.152 1.102.342 2.242.494 3.344l-3.078 3.647c-1.368-.152-2.736-.342-4.104-.494.076-1.444.152-2.887.266-4.331l2.508-2.964c0-.532.038-1.102.038-1.634-.95.494-1.862 1.026-2.774 1.52a970.745 970.745 0 00-5.775 6.877c-.152.076-.342.19-.494.266-2.47 1.368-5.016 3.458-6.004 4.332a821.624 821.624 0 01-2.393 5.775l-4.674 4.446c-1.444.418-2.888.874-4.331 1.292-4.142 2.47-8.284 4.939-12.387 7.485-2.128.912-4.294 1.824-6.422 2.736-1.33-.836-2.698-1.672-4.027-2.508.038-3.04.076-6.041.152-9.081.304-1.368.569-2.736.873-4.104a686.4 686.4 0 00-2.089-.114c-2.28 1.292-4.56 2.584-6.802 3.876-.95 1.216-1.862 2.432-2.811 3.648a708.973 708.973 0 01-5.51 2.735c.038-.911.038-1.785.076-2.697-.418-.684-.798-1.368-1.216-2.052 1.444-1.9 2.926-3.838 4.408-5.738l3.191-6.383c.456-1.33.95-2.622 1.444-3.952-.608-.038-1.216-.038-1.824-.076a1175.18 1175.18 0 00-8.891 5.662c-.684 1.406-1.368 2.85-2.052 4.255a1139.178 1139.178 0 00-8.131 10.64c-4.939 4.749-9.917 6.801-10.107 6.877-.114.038-.228.038-.342.076l-6.763.114a252.697 252.697 0 01-1.368-3.116c.076-2.394.19-4.787.266-7.181l2.964-5.472c.57-2.204 1.139-4.407 1.747-6.573 1.14-2.204 2.318-4.37 3.496-6.574 2.584-2.469 5.168-4.939 7.789-7.371a1133.5 1133.5 0 019.728-9.385 581.389 581.389 0 017.751-2.09c1.71-1.064 3.42-2.128 5.167-3.154 1.976-2.355 3.952-4.673 5.966-7.029 1.786-1.064 3.572-2.09 5.357-3.154 1.52-.418 3.04-.836 4.522-1.254a496.658 496.658 0 017.675-4.027c1.672.076 3.382.19 5.054.266-.19 2.584-.342 5.167-.494 7.713.76 1.368 1.748 1.14 2.128.988.646-.304 1.444-1.102 1.823-1.558.266-.722.57-1.406.836-2.128.114-2.013.266-4.027.38-6.041-.684-1.14-1.368-2.28-2.051-3.458a436.797 436.797 0 014.293-7.143c1.178-1.292 2.394-2.584 3.572-3.876 1.862-1.254 3.686-2.546 5.547-3.799 1.976-2.128 3.99-4.218 5.966-6.308 1.52-.798 3.078-1.558 4.597-2.356 2.28-2.355 4.56-4.673 6.878-7.029.19-1.976.342-3.952.532-5.89.95-.949 1.9-1.899 2.849-2.811.57.038 1.178.076 1.748.152v-.152c1.368-1.862 2.736-3.724 4.104-5.548 2.052-.988 4.104-1.938 6.155-2.888a484.328 484.328 0 019.348-8.207c3.115-1.976 6.269-3.913 9.423-5.851l.228-2.052c.114-.38.038-1.9 23.71-15.693.266-.152.494-.304.759-.456 1.14.152 2.242.266 3.382.418-2.204 1.596-4.445 3.192-6.649 4.788 0 .152-.038.266-.038.418 1.064-.418 2.166-.874 3.23-1.292 1.481-1.824 6.497-4.864 8.853-6.193.152-.076.304-.152.494-.228 6.155-2.394 9.309-4.446 10.335-5.168a5.67 5.67 0 00.076-.798c-3.23 1.216-6.498 2.432-9.727 3.686-3.458 1.33-4.56.418-4.446-.57 0-.076.038-.19.038-.266 1.748-1.482 3.496-2.926 5.244-4.37.342-.608.721-1.178 1.063-1.786a585.385 585.385 0 00-7.333 2.812 5.67 5.67 0 00.076-.798c-.494.152-1.102.304-1.672.228-.418-.038-.532-.266-.38-.608.152-.266.57-1.14 6.878-4.445.114-.038.228-.114.38-.152 3.913-1.482 7.789-2.926 11.703-4.37 1.899-.722 3.761-1.482 5.661-2.204.836-.304 1.71-.608 2.546-.912 1.634-.836 3.23-1.709 4.863-2.545.38-.152.798-.266 1.178-.418 1.33-.798 2.698-1.596 4.066-2.356l6.155-2.052c1.938-1.482 3.838-2.926 5.776-4.408-.304-.608-.608-1.177-.912-1.785l-7.295 1.595c-1.14-.949-2.318-1.899-3.458-2.849.076-.722.19-1.406.266-2.128l-1.786-1.786c.076-.684.19-1.368.266-2.052-.95.304-1.9.646-2.85.95a819.507 819.507 0 00-12.007 7.751c-1.406-.19-2.849-.342-4.255-.532.19-1.253.342-2.545.532-3.799-1.14-1.482-8.322.76-8.398.798-3.305 1.216-6.611 2.47-9.917 3.723-1.178.912-2.317 1.862-3.495 2.812-4.332 4.37-7.22 6.764-8.398 7.637l-.456 3.306c-.266 1.862-5.813 5.7-6.421 6.118l-.342.228c-10.411 5.509-10.677 7.219-10.715 7.219 0 .038 0 .076.038.114-.038.038-.076.076-.076.114-.836 1.444-1.634 2.926-2.47 4.37-1.748 1.519-3.457 3.077-5.167 4.597-1.14.494-2.242.988-3.382 1.482-1.672-.114-3.344-.266-5.016-.38.304-.266.608-.57.912-.836 1.596-1.444 3.154-4.597 3.952-6.687-2.356 1.026-4.674 2.09-7.029 3.115-.114 0-.228 0-.342-.038-1.254-.076-8.246 1.672-12.311 2.812-5.32 1.216-6.688-1.178-6.954-1.786-.304-.076-.38-.304-.228-.684.798-2.089 11.057-9.385 14.249-11.513.076-.076.19-.114.266-.19.684-.304 1.33-.607 2.014-.911.076-.456.114-.874.19-1.33 2.546-1.406 5.053-2.812 7.599-4.18 1.444-1.254 2.888-2.508 4.37-3.724 2.09-.912 4.217-1.861 6.307-2.773.342-.266.646-.57.988-.836 1.71-.912 3.382-1.824 5.092-2.698.114-.836.266-1.634.38-2.47a206.345 206.345 0 014.331-1.748c2.432-.988 3.61-.76 4.142-.266 2.014-1.634 3.99-3.267 6.003-4.863a736.412 736.412 0 0112.729-4.902c2.28-1.786 4.56-3.571 6.84-5.319.038-.304.076-.608.152-.874-3.23 1.026-6.422 2.052-9.651 3.077-2.47 1.938-4.94 3.876-7.372 5.852-1.482.57-2.926 1.14-4.407 1.71.114-.798.228-1.596.38-2.356-5.054 1.786-5.814.57-5.852.532 0-.038 0-.076-.038-.152.152-.874.266-1.71.418-2.584-1.026.418-2.052.836-3.116 1.254a608.73 608.73 0 00-6.269 4.256c.266 0 .494.038.76.038-.114.684-.228 1.368-.342 2.09a582.639 582.639 0 00-5.092 4.217l-3.761-.228c.532-.456 1.102-.912 1.633-1.368-2.583.342-5.927 2.432-7.219 3.344-.038.304-.114.608-.152.912 1.862-.798 3.686-1.596 5.548-2.356-.114.646-.19 1.254-.304 1.9l-5.472 3.762c-1.216-.076-2.47-.152-3.686-.19a675.51 675.51 0 00-8.891 4.977c-2.697.76-5.357 1.52-8.055 2.318a625.978 625.978 0 00-11.437 5.358l-5.13 4.673c-.873-.038-1.747-.038-2.659-.076-3.876 1.9-7.79 3.8-11.627 5.738-1.064 0-2.166-.038-3.23-.038-2.698.684-5.395 1.367-8.093 2.089-3.23 1.596-6.46 3.192-9.651 4.788a706.774 706.774 0 00-7.942 3.344l-5.015 3.533c-2.014 1.102-4.028 2.242-6.042 3.344a1225.247 1225.247 0 00-13.564 9.537c-3.496 1.9-6.992 3.8-10.449 5.738-2.888 1.33-5.738 2.697-8.626 4.065a738.78 738.78 0 00-9.423 4.864c-2.736 1.71-5.471 3.458-8.207 5.205-3.154 1.482-6.346 2.964-9.499 4.446-3.23 2.318-6.46 4.636-9.651 6.953-2.242 1.824-4.484 3.61-6.726 5.472a1190.52 1190.52 0 00-8.473 6.003c-4.408 3.952-8.777 7.98-13.109 12.007-2.926 2.47-5.851 4.94-8.74 7.41-.037.152-.037.304-.075.494.95-.114 1.862-.228 2.812-.342-2.584 2.735-5.13 5.509-7.676 8.245-.19.038-.38.038-.57.076-.95.114-7.903 5.813-14.02 11.437-.114.494-.19.95-.304 1.444 3.571-2.584 8.359-5.168 8.587-5.282l1.482-.798c-1.71 2.242-3.42 4.522-5.13 6.802a969.828 969.828 0 00-17.402 15.73 245.464 245.464 0 00-.608 5.244c-1.444 1.558-2.888 3.115-4.332 4.711.152.304.266.608.418.912 1.824-1.406 4.674-3.343 5.054-3.571.266-.19.532-.342.798-.532a30.946 30.946 0 00-.19 1.861c0 .646-.342 1.634-19.113 21.658 0 .076 0 .152-.038.228a809.072 809.072 0 015.852-5.547 949.442 949.442 0 0116.528-18.39c.874-.722 1.748-1.444 2.66-2.166-.076.646-.152 1.33-.228 1.976a403.99 403.99 0 004.18-3.42c.456-.608.874-1.254 1.33-1.862.912-.836 1.823-1.634 2.736-2.47.038-.38.076-.722.113-1.102-.835.114-1.71.228-2.545.342 4.141-4.483 8.359-8.929 12.577-13.336 3.001-2.318 6.003-4.636 9.005-6.916 1.558-1.672 3.153-3.305 4.711-4.939 1.938-1.71 3.838-3.42 5.776-5.092 2.47-1.33 4.939-2.622 7.447-3.914 2.47-1.785 4.94-3.571 7.409-5.319 1.634-.152 3.268-.304 4.94-.418 2.014-1.178 3.99-2.356 6.003-3.496l4.484-.342a258.597 258.597 0 00-2.736 3.344c.836.57 1.71 1.102 2.546 1.672-1.558 1.9-3.116 3.838-4.673 5.737-.38 3.154-.722 6.308-1.064 9.462-1.406.987-2.812 2.013-4.218 3.001-.152.57-.304 1.14-.494 1.71l3.116-.228c.95-.684 1.9-1.368 2.888-2.052.607-1.14 1.253-2.279 1.861-3.457 1.786-1.254 3.534-2.508 5.32-3.724l.114 2.698a282.126 282.126 0 00-3.23 3.723l-3.306 4.218a730.924 730.924 0 01-5.737 4.104c-.798 1.519-1.634 3.001-2.432 4.521l-4.445 7.524a1447.11 1447.11 0 00-6.916 9.347c-.532 1.444-1.064 2.925-1.634 4.369-1.672 2.318-3.343 4.674-5.015 7.03-.342 1.444-.684 2.849-1.026 4.293a53.946 53.946 0 00-.152 2.546c.95 3.496 1.938 6.953 2.888 10.411 6.763-2.47 7.333-.456 7.409-.228-.114 2.052-.19 4.104-.304 6.156 1.254.57 2.47 1.101 3.724 1.671a77.76 77.76 0 01-1.52 2.242c-.076 1.596-.114 3.23-.19 4.826 1.33-.076 2.66-.152 3.951-.228l-.114 3.306c1.33-.076 2.622-.114 3.952-.19.608-.494 1.254-.988 1.862-1.482-.494-.532-.988-1.064-1.482-1.558l-2.66.114.228-6.726c.038-1.177-2.242-3.533-3.723-4.749a.704.704 0 01-.076-.266l.114-2.432c.038-1.14.684-2.204 1.216-2.926 1.101-1.52 2.469-2.431 2.621-2.507l.342-.228c1.178-.076 2.318-.114 3.496-.19.418 2.393.798 4.787 1.216 7.219 1.748.494 3.458 1.026 5.205 1.558-.038.722-.038 1.406-.076 2.128 4.37-1.482 9.727 1.33 10.373 1.671a.795.795 0 00.152.228l.342 3.534-2.393 3.534c0 .608-.038 1.254-.038 1.862-.038 1.709 13.83-2.888 26.977-7.752 1.824-1.33 3.648-2.621 5.472-3.913.874-1.254 1.786-2.508 2.659-3.762 1.786-1.254 3.61-2.546 5.396-3.762l8.701.228c1.9-.722 3.8-1.482 5.7-2.165 2.583-1.748 5.205-3.458 7.789-5.168 1.254.076 2.47.114 3.724.19 0 .874-.038 1.748-.038 2.622l3.837.228c0 1.026-.038 2.09-.038 3.115l7.144.456c2.127-1.139 4.293-2.241 6.421-3.343 1.596-.608 3.23-1.216 4.826-1.824.874-.532 1.747-1.064 2.583-1.596v-1.9l.342-.456c3.42-4.483 7.904-5.851 9.766-5.965.152 0 .304 0 .455-.038 0 1.634-.038 3.305-.038 4.939.418.038.874.076 1.292.114v9.803l-.342.456c-9.043 12.007-12.766 20.747-13.412 22.19.038 1.216.076 2.47.076 3.686 1.329.114 2.659.266 3.989.418-.38.532-.722 1.026-1.102 1.558.608.38-.418 1.9-2.165 4.484-1.254 1.785-1.786 3.039-1.596 3.609.228.646 1.368.342 1.406.342l.683-.228.114 3.002c8.626-2.584 11.703 5.661 11.855 6.003.304 5.13 7.182 4.104 7.258 4.104.152-.038.266-.038.418-.076.038.114.076.19.152.304 1.938 4.294 4.521 5.433 5.205 5.661 15.769-4.521 20.442-1.291 21.202-.683 1.064.228 2.09.455 3.116.645.912.988 1.824 1.976 2.698 2.964.57 2.47 1.178 4.902 1.786 7.334-.836 1.291-1.672 2.545-2.508 3.837l.342 3.99c.57.114 1.102.228 1.672.342a975.372 975.372 0 001.862 18.428c.797 1.026 1.595 2.09 2.393 3.154.228 1.9.456 3.838.684 5.737.912.19 1.824.418 2.736.608.418 3.344.836 6.688 1.254 9.993a169.338 169.338 0 00-2.014 3.572l1.026 7.409c.874.228 1.748.418 2.622.646.266 1.9.57 3.8.836 5.7.722.19 1.406.342 2.127.532.114.646.19 1.292.304 1.938 2.28.57 4.522 1.178 6.764 1.785.228 1.406.418 2.812.646 4.18.646.19 1.254.342 1.9.532.342 2.242.722 4.484 1.102 6.725a186.37 186.37 0 00-1.976 3.876c2.317.646 4.635 1.292 6.915 1.976.19 1.064.38 2.166.57 3.23 1.292.38 2.546.76 3.838 1.14.342 1.823.646 3.647.988 5.433 1.329.418 2.697.836 4.027 1.254 1.026-.646 2.014-1.292 3.04-1.938.722 1.026 1.444 2.052 2.128 3.04.494.152.988.304 1.482.494 2.013-1.292 4.065-2.546 6.117-3.8.076.38.152.722.19 1.102 1.824-1.102 3.648-2.242 5.472-3.306.38 2.128.76 4.256 1.177 6.346 1.824-1.102 3.61-2.204 5.434-3.268.456 1.216.608 2.128.798 3.04zM321.446 162.99c.532-.19 1.026-.418 1.558-.608.114-.684.19-1.405.304-2.089-3.496-.152-8.245 2.013-8.283 2.051-.798.38-1.558.722-2.356 1.102a.54.54 0 01.076.228c0 .076.038.152.038.266-.722.57-1.406 1.178-2.128 1.748-.076.456-.114.874-.19 1.33a41.004 41.004 0 011.862-.874 58.78 58.78 0 011.938-1.33c1.558-.608 3.115-1.254 4.673-1.862.836 0 1.672 0 2.508.038zm-34.501 6.308c.494.038.988.038 1.482.076a102.09 102.09 0 012.508-1.786l-3.99 1.71zm-27.395 68.128c-.076.038-.19.076-.266.114-.836.38-1.976.722-2.85.304-.076-.038-.152-.076-.266-.114.076-.114.152-.266.19-.38.076-.152 1.938-3.534 9.195-7.068.152-.076.342-.152.494-.266.988.076 1.976.152 2.964.19-1.938 1.482-3.914 2.964-5.852 4.446-.494.532-1.937 1.938-3.609 2.774zm-.608-1.216c.228.038.456 0 .684-.114.684-.304 1.596-1.178 1.975-1.558.114-.114.266-.228.38-.342.988-.76 2.014-1.558 3.002-2.318h-.076c-3.761 1.9-5.395 3.572-5.965 4.332zm-17.669 9.955c-.114.038-.19.076-.304.152-1.178.456-3.951 1.406-4.331.646-.076-.19-.114-.608.646-1.444.836-1.368 6.725-10.525 14.476-15.427 0 0 2.242-1.672 5.092-3.381a387.671 387.671 0 00-5.624 2.811c-.608-.038-1.215-.076-1.823-.076-1.748.912-3.534 1.786-5.282 2.698-1.444 1.254-2.888 2.47-4.332 3.724-.114.076-.228.114-.342.19-.303.152-1.823.988-2.621.836-.342-.076-.608-.342-.114-1.292.114-.114.19-.266.304-.38.342-.38 9.385-9.689 20.1-14.059 2.204-.798 5.889-1.33 4.863 1.9-.038.076-.038.152-.076.266a61.06 61.06 0 00-1.557 1.52 31.395 31.395 0 011.633-.76c2.85-1.368 5.662-2.698 8.512-4.066 1.596.114 3.191.228 4.825.342-1.178 1.14-2.356 2.242-3.533 3.382-1.368.798-2.736 1.634-4.066 2.432-1.064 1.292-2.09 2.583-3.154 3.875l-3.647 1.824c-1.14-.076-2.318-.152-3.496-.19.874-.874 1.748-1.748 2.622-2.584.038-.19.038-.418.076-.608-1.254.646-2.546 1.254-3.8 1.9l-3.078 1.938c-.912.836-1.786 1.71-2.698 2.584-.835 1.14-1.671 2.242-2.507 3.382-.266.57-.57 1.177-.836 1.747-1.102 1.406-3.534 4.826-5.928 6.118zm19.037-20.176c-3.762 1.861-7.828 4.863-7.866 4.901-7.257 4.598-13.033 14.021-13.071 14.097-.076.114-.19.228-.266.342.076.076 1.254-.228 2.394-.646.684-.494 2.28-2.432 3.42-4.142.304-.646.608-1.292.95-1.937.988-1.292 1.976-2.622 2.964-3.914 1.102-1.064 2.203-2.128 3.305-3.154a246.414 246.414 0 014.142-2.584c2.128-1.063 4.256-2.127 6.421-3.153-.076.836-.19 1.672-.266 2.507-.532.494-1.025 1.026-1.557 1.52.38.038.797.038 1.177.076.418-.228.874-.418 1.292-.646.988-1.216 1.976-2.431 2.926-3.647 1.444-.874 2.926-1.748 4.37-2.622.38-.38.76-.722 1.14-1.102-.836-.038-1.672-.114-2.508-.152-.532.266-1.064.494-1.558.76-2.052.95-4.104 1.938-6.118 2.888-.417.19-.835.38-1.291.608zm-21.43 8.929c-.038.076 0 .076 0 .076.038 0 .152-.076.304-.152a202.623 202.623 0 014.369-3.724c2.356-1.216 4.674-2.394 7.029-3.609.608.038 1.216.076 1.824.076 2.204-1.102 4.408-2.204 6.65-3.268.19-.19.418-.38.608-.608.57-2.394-2.774-1.254-3.192-1.14-8.549 3.496-16.225 10.943-17.592 12.349zm39.44-10.715c-.152.076-.304.152-.456.19-.798.304-1.9.608-2.622.228a.288.288 0 00-.152-.076c0-.076.038-.152.038-.19.152-.836 1.634-2.964 6.194-5.092.38-.228.912-.456 1.406-.532.798-.152 1.329.038 1.633.532.038.076.114.19.152.266-.19.152-.342.342-.532.494-.303.304-3.039 2.964-5.661 4.18zm-.608-1.178c.228.038.456-.038.608-.114.95-.38 2.432-1.596 3.382-2.47-.076-.038-.152-.076-.19-.076a.83.83 0 00-.19.114c-2.584 1.216-3.382 2.128-3.61 2.546z",
    fill: "url(#prefix__paint234_linear_6821_29592)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M249.289 186.776c-.76 0-1.52-.038-2.28-.038a238.206 238.206 0 00-4.408 2.204c-3.001.494-6.041.988-9.043 1.482 4.826-2.47 9.651-4.94 14.477-7.334.076-.114.152-.19.19-.266.038-.076-.038-.152-.152-.152-3.23 1.558-6.459 3.154-9.689 4.75.076-.57.19-1.102.266-1.672.57-.38 1.102-.76 1.672-1.14l-2.736.912c-2.28 1.824-4.522 3.648-6.763 5.472-2.47 1.254-4.902 2.507-7.372 3.761-.456-.608-.874-1.216-1.33-1.823l3.382-3.154a905.596 905.596 0 0113.831-9.955c3.837-1.862 7.675-3.724 11.513-5.548 2.432-.836 4.901-1.672 7.333-2.508 1.178.038 2.318.076 3.496.076l3.305-1.481a170.41 170.41 0 014.408-2.698c1.33-.608 2.622-1.178 3.952-1.786.304.19.57.38.874.57l2.279-1.938c2.774-1.216 5.51-2.432 8.284-3.61a93.363 93.363 0 00-.874 3.078c-.646.532-1.254 1.064-1.9 1.596 1.178-.076 2.356-.114 3.534-.19-.266.76-.494 1.52-.76 2.242-2.318 1.406-4.598 2.812-6.878 4.217-2.317 1.178-4.635 2.318-6.953 3.534-2.964 1.14-5.928 2.28-8.853 3.42-.874.57-1.786 1.102-2.66 1.672-1.406.76-2.812 1.519-4.256 2.279-.722.342-1.482.722-2.203 1.064-1.292.988-2.47 1.976-3.686 2.964zm-1.102-1.748c.532 0 1.064.038 1.558.038a116.4 116.4 0 012.508-2.014l2.849-1.367c1.292-.722 2.622-1.406 3.914-2.09l2.85-1.824c3.039-1.178 6.117-2.394 9.195-3.534 2.128-1.102 4.294-2.166 6.421-3.268 1.672-1.025 3.344-2.089 5.016-3.115.076-.266.19-.532.266-.798-1.52.076-3.04.19-4.56.266 1.102-.95 2.204-1.862 3.268-2.774.114-.418.266-.874.38-1.292l-4.674 2.052c-1.368 1.178-2.773 2.356-4.141 3.572-.532-.342-1.026-.722-1.558-1.064-.722.342-1.444.646-2.204.988l-4.218 2.621a181.248 181.248 0 00-4.749 2.128l-3.686-.114c-2.204.76-4.369 1.482-6.573 2.242-3.496 1.672-6.992 3.344-10.449 5.054a814.868 814.868 0 00-13.109 9.461c-.57.57-1.178 1.102-1.748 1.672l.57.798 4.902-2.508c2.393-1.938 4.749-3.876 7.181-5.776a968.284 968.284 0 019.841-3.267c-1.52.987-3.04 2.013-4.522 3.039l6.612-3.191h.342c.95.038 1.064.456.95.798-.19.759-1.368 1.709-1.482 1.823-.114.076-.228.19-.342.266-2.622 1.292-5.244 2.622-7.865 3.914.874-.152 1.709-.266 2.583-.418 1.558-.798 3.116-1.558 4.674-2.318z",
    fill: "url(#prefix__paint235_linear_6821_29592)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M296.483 159.799l-7.6-.228c3.154-1.33 6.346-2.66 9.499-3.989 1.482-1.064 2.926-2.166 4.408-3.23.76-.266 1.52-.532 2.318-.836.418-.38 1.064-.912 1.938-1.254 1.976-.798 3.951-1.558 5.889-2.356-.722 1.102-1.444 2.166-2.166 3.268-1.14.95-2.279 1.938-3.419 2.888-1.52.95-3.04 1.862-4.56 2.811-2.09.988-4.218 1.938-6.307 2.926zm-1.634-1.672c.912.038 1.824.038 2.698.076 1.633-.76 3.305-1.52 4.977-2.279 1.216-.76 2.47-1.52 3.686-2.28.874-.76 1.786-1.558 2.66-2.318.189-.342.417-.646.607-.988-.797.342-1.633.646-2.431.988-.076.076-.19.19-.228.266-.152.19-.266.38-.418.532-1.026.342-2.052.722-3.078 1.102-1.444 1.026-2.85 2.09-4.294 3.153-1.367.608-2.773 1.178-4.179 1.748z",
    fill: "url(#prefix__paint236_linear_6821_29592)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M317.305 149.997l-5.244 1.71c.114-.76.266-1.558.38-2.318 2.242-1.178 4.446-2.356 6.688-3.534 3.077-1.178 6.117-2.356 9.195-3.496-.152.836-.266 1.672-.418 2.546a496.464 496.464 0 00-8.017 3.04 60.983 60.983 0 01-2.584 2.052zm-2.622-.228c.646-.228 1.292-.418 1.976-.646.798-.646 1.596-1.254 2.394-1.9 2.203-.836 4.369-1.672 6.573-2.508 0-.114.038-.19.038-.304-2.166.836-4.37 1.672-6.535 2.508-1.444.76-2.926 1.558-4.37 2.318-.038.19-.038.38-.076.532z",
    fill: "url(#prefix__paint237_linear_6821_29592)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M370.037 148.476a511.942 511.942 0 00-10.791 3.648l-10.981-.684c-.722.266-1.482.532-2.204.798-1.52.76-3.04 1.558-4.56 2.356-1.519.57-3.039 1.102-4.559 1.672-1.064-.114-2.166-.228-3.23-.342.95-.722 1.862-1.482 2.812-2.204 3.192-1.33 6.345-2.66 9.537-3.952 1.216-.418 2.432-.874 3.648-1.292a402.066 402.066 0 014.901-3.685c2.926-1.026 5.89-2.014 8.853-3.002.874-.19 1.748-.342 2.622-.532.152-.114.266-.19.418-.304-3.762-.456-7.523-.912-11.285-1.33-.836.304-1.71.57-2.546.874-.114 0-.228 0-.342-.038-.418 0-.798.114-1.177.38-.114.114-.266.19-.38.304-2.432.836-4.864 1.71-7.296 2.584-.646-.076-1.292-.114-1.9-.19-1.33.494-2.697.988-4.027 1.482-.798.608-1.558 1.215-2.356 1.823-2.698.988-5.434 1.976-8.131 3.002-.38.076-3.762.684-4.104-.38-.114-.38.114-1.14 1.9-2.546a.829.829 0 00.19-.152c2.812-1.823 5.623-3.647 8.473-5.433 1.064-.38 2.128-.798 3.192-1.178.304-.228.646-.494.95-.722a915.862 915.862 0 0120.974-7.333c2.09 0 4.141 0 6.231.038 2.09-.874 4.142-1.748 6.232-2.622 1.634.19 3.267.418 4.901.608 2.28-.304 4.56-.608 6.878-.874.494.722.988 1.444 1.482 2.204 2.013.266 4.027.57 6.041.874-.152.95-.266 1.9-.418 2.849-1.216.836-2.432 1.71-3.648 2.584-.912.646-3.039 1.406-4.673 1.9-.19.038-.342.114-.532.152l-4.104-.57c-1.178.456-2.356 1.026-2.622 1.254.038 0 .114.038.304.076 2.47.342 2.28 1.102 1.862 1.596-.152.95-.266 1.938-.418 2.888l-6.611 2.165c.152.38.342.836.494 1.254zm-9.689 2.166c2.241-.76 4.521-1.52 6.763-2.28-.152-.456-.304-.874-.456-1.33 2.394-.798 4.75-1.595 7.143-2.355.114-.722.19-1.444.304-2.166.076-.038.114-.076.19-.114-.038-.114-.266-.342-1.443-.494-1.14-.152-1.064-.646-.76-1.026.836-1.14 4.369-2.508 5.433-2.926.19-.076.418-.152.608-.228l4.218.57c1.064-.342 2.128-.76 2.431-.912.912-.646 1.862-1.33 2.774-1.976.076-.645.19-1.291.266-1.937-1.938-.266-3.837-.532-5.775-.798-.456-.684-.912-1.33-1.368-2.014l-6.384.798c-1.367-.19-2.773-.342-4.179-.532-2.014.836-4.028 1.672-6.042 2.546-2.165 0-4.331-.038-6.459-.038a1128.55 1128.55 0 00-19.112 6.687c-.304.228-.646.494-.95.722-1.178.418-2.318.836-3.496 1.254a537.307 537.307 0 00-7.675 4.939c-.722.57-1.026.95-.988 1.178.152.418 1.672.304 2.546.152a671.368 671.368 0 016.345-2.356c.798-.607 1.558-1.215 2.356-1.823 2.014-.76 4.065-1.482 6.079-2.204.646.076 1.292.114 1.9.19 1.748-.608 3.534-1.254 5.282-1.862 1.406-.912 2.887-1.254 3.799-1.33.874-.304 1.786-.608 2.66-.912 4.56.494 9.119 1.064 13.641 1.634l-3.42 2.508c-1.292.266-2.546.532-3.838.798-2.431.798-4.825 1.634-7.257 2.47-1.634 1.215-3.268 2.469-4.901 3.685-1.52.532-3.04 1.064-4.56 1.634-2.85 1.178-5.7 2.318-8.549 3.534-.076.076-.19.152-.266.228l.912.114c1.102-.418 2.203-.798 3.267-1.216 1.52-.798 3.04-1.558 4.56-2.356 1.14-.418 2.242-.798 3.382-1.216 3.685.304 7.371.532 11.019.76z",
    fill: "url(#prefix__paint238_linear_6821_29592)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M353.058 133.81c-2.774.95-5.548 1.9-8.283 2.888-1.596.418-3.192.836-4.826 1.254-2.432.684-4.863 1.406-7.295 2.128.152-.988.342-2.014.494-3.002 1.292-.494 2.584-.95 3.913-1.406 2.622-1.14 5.244-2.28 7.866-3.381l2.166.228c6.573-2.166 13.184-4.218 19.758-6.232 1.064.114 2.166.266 3.229.38-1.291.912-2.583 1.824-3.837 2.736-4.446 1.406-8.815 2.888-13.185 4.407zm-7.713 1.634a1235.94 1235.94 0 0119.986-6.877c.38-.266.798-.57 1.178-.836-.304-.038-.646-.076-.95-.114a919.776 919.776 0 00-19.758 6.269c-.646-.076-1.292-.114-1.938-.19-2.28.988-4.522 1.938-6.764 2.926-.532.19-1.101.418-1.633.608-.038.304-.114.646-.152.95 1.785-.532 3.571-1.026 5.357-1.558 1.52-.342 3.078-.76 4.674-1.178z",
    fill: "url(#prefix__paint239_linear_6821_29592)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M350.367 128.299c-2.052.494-4.142.988-6.194 1.482l.456-2.736a589.501 589.501 0 0110.487-4.103c2.85-.95 5.662-1.9 8.511-2.85-.19 1.064-.342 2.128-.532 3.192-1.405.455-2.811.949-4.217 1.405-2.85 1.14-5.7 2.356-8.511 3.61zm-3.61-.228c1.292-.304 2.546-.608 3.838-.912l8.321-3.534c.608-.227 1.254-.417 1.862-.607a9.72 9.72 0 01.19-1.026 366.713 366.713 0 00-5.89 1.975c-2.736 1.064-5.433 2.128-8.169 3.192-.038.266-.076.57-.152.912z",
    fill: "url(#prefix__paint240_linear_6821_29592)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M375.711 123.854c-1.862.57-3.724 1.178-5.548 1.786-1.368.152-2.736.266-4.103.418a825.492 825.492 0 00-12.653 4.332c-.722.228-2.888.874-3.344.418-.304-.304.114-.836 1.254-1.672l.342-.228a842.563 842.563 0 0110.411-3.914c-.38-.304-.76-.608-1.14-.95l6.611-2.279 2.394-2.85a484.733 484.733 0 017.942-2.47c1.823-.342 3.685-.684 5.509-.988 1.748-.532 3.534-1.064 5.282-1.596.038-.152.038-.304.076-.456-1.406.304-2.812.608-4.18.912-1.71.494-3.382 1.026-5.092 1.558-4.065.874-8.131 1.748-12.235 2.66 4.674-1.938 9.348-3.876 14.059-5.738 5.51-1.672 11.019-3.305 16.529-4.901 1.406-.646 2.812-1.292 4.217-1.9a3050.19 3050.19 0 009.423-2.622c.152-.038 4.56-1.064 6.042-1.444 1.52-.418 8.663-2.431 8.739-2.47l9.803-3.077c-.114.76-.228 1.482-.342 2.242a863.614 863.614 0 00-8.967 3.343c-2.622 1.102-5.205 2.166-7.789 3.306a827.243 827.243 0 00-17.783 6.155c-2.165.95-4.293 1.862-6.459 2.812a468.165 468.165 0 00-6.117 3.23c-2.128 1.026-4.256 2.014-6.384 3.04-2.204 1.026-4.369 2.165-6.497 3.343zm-4.788.494c1.444-.456 2.85-.912 4.294-1.368a908.737 908.737 0 016.003-3.191c2.128-1.026 4.218-2.052 6.346-3.04 2.051-1.102 4.103-2.166 6.155-3.268 2.28-1.026 4.598-2.014 6.877-3.001a991.246 991.246 0 0117.859-6.194l7.523-3.192c2.432-.912 4.826-1.823 7.258-2.697 0-.114.038-.19.038-.304-2.318.722-4.636 1.444-6.954 2.203-.418.114-7.447 2.09-9.043 2.546a390.996 390.996 0 01-6.193 1.482c-3.002.836-6.042 1.672-9.044 2.508-1.405.646-2.811 1.254-4.217 1.9a1384.385 1384.385 0 00-16.681 4.939c-1.102.456-2.242.912-3.343 1.33.721-.152 1.405-.304 2.127-.456a251.798 251.798 0 015.016-1.52l6.269-1.368c-.114.798-.266 1.596-.38 2.356-2.773.836-5.585 1.634-8.359 2.508-1.824.342-3.686.684-5.509 1.026-1.9.608-3.8 1.178-5.662 1.786-.798.95-1.558 1.9-2.356 2.849-1.52.532-3.077 1.026-4.597 1.558.38.304.722.57 1.102.874-4.294 1.596-8.626 3.192-12.919 4.826h-.038a5.851 5.851 0 001.026-.266c4.369-1.52 8.777-3.04 13.185-4.484 1.481-.076 2.849-.228 4.217-.342z",
    fill: "url(#prefix__paint241_linear_6821_29592)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M439.994 131.15c-2.356.57-4.75 1.178-7.106 1.748l-7.295.684c-1.634-.57-3.268-1.102-4.864-1.672.114-.836.228-1.634.304-2.47l-.114-2.508c.114-1.026.266-2.052.418-3.078 3.268-1.823 6.498-3.647 9.804-5.433 1.557-.722 3.077-1.444 4.635-2.166.114-.76.19-1.482.304-2.242-1.33 0-2.66.038-3.99.038-.493-.722-1.025-1.482-1.519-2.204a197.024 197.024 0 00-4.256-1.557c-.836-.152-1.672-.266-2.546-.418-1.406-.228-2.926.152-3.002.152-6.725 1.785-13.45 3.685-20.176 5.623a116.37 116.37 0 01-.532-3.268 874.422 874.422 0 0113.983-4.673c2.394-.874 4.826-1.71 7.219-2.546a505.484 505.484 0 0110.449-4.332c2.774-1.101 5.586-2.165 8.36-3.23 1.672-.417 3.343-.797 5.015-1.177 1.406-.494 2.812-1.026 4.218-1.52 2.66-.532 5.281-1.026 7.941-1.52 2.508-.418 5.016-.798 7.524-1.178 3.305-.722 6.611-1.406 9.879-2.09 2.089-.608 4.217-1.254 6.307-1.861 2.66-.57 5.32-1.178 8.017-1.71 2.47-.608 4.978-1.216 7.486-1.824 2.659-.646 5.281-1.292 7.941-1.938 2.47-.38 4.94-.722 7.447-1.064 1.71-.266 3.458-.57 5.168-.836l6.155-1.824a434.07 434.07 0 019.879-.912c2.85-.303 5.738-.645 8.588-.911l8.245-.228c1.634.152 3.306.342 4.939.494 1.9-.418 3.838-.836 5.738-1.254 2.508-.19 5.053-.418 7.561-.608-1.14.988-2.318 1.938-3.457 2.925-3.534.38-7.106.798-10.639 1.216-1.406.418-2.812.874-4.218 1.292-1.102.532-2.204 1.064-3.268 1.634a56.123 56.123 0 01-.266 2.508c-3.078 1.52-6.117 3.078-9.157 4.635-4.066.988-8.169 1.976-12.235 3.002-.304.152-.646.342-.95.494.152.038.304.076.418.114 1.71.114 3.42.19 5.13.304.494.57.988 1.178 1.482 1.748-1.786.57-3.534 1.178-5.32 1.748l-2.394 1.254c.342.418.722.874 1.064 1.291l-6.383 1.026c-2.812.646-5.586 1.292-8.397 1.938-.456.152-3.8 1.102-5.092 1.33-2.546.456-5.054.912-7.599 1.368a412.273 412.273 0 00-6.346 2.09l-7.751 2.964c-1.14.57-2.28 1.101-3.42 1.671-1.786.57-3.571 1.178-5.357 1.748-1.482.456-2.964.95-4.484 1.406-1.52.456-3.04.912-4.521 1.368l-3.648 1.596c-1.406.874-2.812 1.71-4.218 2.584-1.672.874-3.343 1.747-4.977 2.621-.38.646-1.064 1.634-1.824 2.128-.114.076-.456.38-.722.608-1.026.912-2.128 1.862-3.61 2.242-.57.19-3.153 1.406-5.167 2.432-.114.038-.228.114-.342.152a1.24 1.24 0 00-.456.076zm-6.27.494c2.014-.532 4.028-1.026 6.042-1.52 2.242-1.14 5.053-2.508 6.269-2.812.152-.114.95-.836 1.368-1.178.418-.38.798-.684 1.14-.912.266-.19.836-.95 1.216-1.634l.114-.228c1.862-.987 3.762-1.975 5.661-2.963 1.482-.912 3.002-1.862 4.484-2.774 1.444-.608 2.888-1.254 4.37-1.862 1.557-.456 3.077-.912 4.635-1.368l4.332-1.368c1.71-.57 3.381-1.102 5.091-1.671 1.064-.532 2.09-1.064 3.154-1.558 2.66-1.026 5.32-2.052 7.979-3.04 2.356-.76 4.75-1.558 7.106-2.318a560.96 560.96 0 017.827-1.406c.608-.114 2.812-.722 4.484-1.216a716.055 716.055 0 018.777-2.014c1.026-.151 2.014-.341 3.039-.493-.189-.228-.341-.418-.531-.646a425.095 425.095 0 014.065-2.128l3.42-1.14c-.19-.228-.38-.456-.532-.646-1.558-.114-3.116-.228-4.712-.304l-2.279-.57c1.101-.608 2.241-1.178 3.381-1.786 4.066-1.026 8.132-2.014 12.197-3.001l7.865-3.99c.076-.836.19-1.672.266-2.508 1.52-.76 3.04-1.482 4.56-2.204 1.634-.532 3.306-1.026 4.978-1.52 3.191-.38 6.383-.76 9.613-1.14.342-.265.684-.57.988-.835-1.14.076-2.28.19-3.42.266-2.128.456-4.218.912-6.346 1.368l-5.699-.57-7.561.228c-2.812.303-5.624.607-8.474.911-3.115.266-6.193.57-9.309.874-2.052.608-4.141 1.216-6.193 1.824-1.824.304-3.648.57-5.51.874-2.393.342-4.825.684-7.219 1.026-2.546.608-5.13 1.216-7.675 1.862l-7.638 1.824c-2.621.57-5.243 1.14-7.903 1.71-2.166.646-4.37 1.291-6.535 1.937-3.42.684-6.84 1.406-10.259 2.128-2.546.38-5.092.798-7.638 1.216-2.432.456-4.901.95-7.333 1.406-1.444.494-2.888 1.026-4.294 1.52-1.672.38-3.305.798-4.977 1.178-2.546.988-5.092 1.975-7.638 3.001-3.571 1.444-7.105 2.926-10.639 4.408-2.507.874-5.015 1.748-7.523 2.66a598.403 598.403 0 00-11.589 3.875l.228 1.482c2.09-.608 4.142-1.178 6.232-1.786 3.913-1.101 7.827-2.127 11.74-3.191.114-.038 2.584-.684 4.712-.304.874.152 1.786.304 2.66.456 1.558.57 3.116 1.178 4.635 1.748l1.368 1.937c1.444 0 2.926-.038 4.37-.038-.152 1.178-.304 2.318-.456 3.496-1.938.912-3.914 1.824-5.852 2.736a633.644 633.644 0 00-8.549 4.749c-.114.836-.228 1.634-.342 2.47l.114 2.508c-.076.722-.19 1.406-.266 2.128l3.99 1.368c2.128-.152 4.294-.342 6.421-.532z",
    fill: "url(#prefix__paint242_linear_6821_29592)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M521.422 98.207c-1.824.304-3.686.57-5.51.874-1.064-.266-2.166-.532-3.267-.798a231.548 231.548 0 015.167-3.154c1.292.228 2.584.456 3.838.684-.038.798-.152 1.596-.228 2.394zm-4.332-.304c.608-.114 1.254-.19 1.862-.304l.114-.912c-.342-.076-.684-.114-1.026-.19-.608.38-1.254.76-1.862 1.14.266.114.608.19.912.266z",
    fill: "url(#prefix__paint243_linear_6821_29592)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M530.389 108.391c-1.216.151-2.394.341-3.61.493-1.672-.038-3.305-.076-4.977-.076-.228-.076-.456-.114-.684-.19l-5.472 1.14a365.265 365.265 0 013.686-4.065c3.23-.912 6.497-1.824 9.727-2.698 3.192-.608 6.345-1.178 9.537-1.786 1.634-.228 3.306-.456 4.94-.684 1.748-.038 3.533-.076 5.281-.076.076 0 .152.038.228.038.228.076 2.318.608 1.862 1.558-.152.342-.722.874-2.47 1.406-1.71.532-3.457 1.064-5.167 1.596l-5.244 1.254c-1.14.152-2.242.304-3.381.494-1.444.532-2.85 1.064-4.256 1.596zm-2.774-.646c.722-.114 1.482-.228 2.204-.342 1.406-.532 2.85-1.026 4.256-1.558l3.875-.57c1.52-.38 3.002-.722 4.522-1.064 1.634-.532 3.306-1.026 4.977-1.558.38-.114.836-.266.912-.418.114-.228-.494-.532-.95-.684-1.443.038-2.887.038-4.331.076-1.482.19-2.964.418-4.446.608a354.12 354.12 0 00-9.157 1.71c-2.774.76-5.51 1.52-8.283 2.28-.494.532-.988 1.064-1.482 1.634.798-.152 1.634-.342 2.432-.494l1.368.342c1.367.038 2.735.038 4.103.038z",
    fill: "url(#prefix__paint244_linear_6821_29592)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M473.047 220.062a592.311 592.311 0 00-7.903 1.9c.038-1.14.114-2.28.19-3.42a478.07 478.07 0 0110.031-2.394c-.798 1.33-1.558 2.622-2.318 3.914zm-5.206-.114c1.14-.266 2.242-.532 3.382-.798.152-.228.266-.456.418-.684l-3.762.912c0 .152-.038.342-.038.57z",
    fill: "url(#prefix__paint245_linear_6821_29592)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M477.883 220.746c-1.824.341-3.61.683-5.434 1.025.038-.835.076-1.671.114-2.469 1.824-.418 3.648-.874 5.434-1.292l-.114 2.736z",
    fill: "url(#prefix__paint246_linear_6821_29592)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M483.542 219.455c-1.824.341-3.648.645-5.433.987l.114-2.469 5.471-1.254c-.076.95-.114 1.824-.152 2.736z",
    fill: "url(#prefix__paint247_linear_6821_29592)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M483.12 223.481c-3.381.76-6.763 1.558-10.145 2.356.038-1.064.114-2.128.152-3.192.874-.228 1.71-.456 2.584-.646 0-.228.038-.456.038-.722 2.508-.608 5.054-1.178 7.561-1.748a144.42 144.42 0 00-.19 3.952zm-7.485.342l4.902-1.14c0-.38.038-.76.038-1.102-.76.19-1.558.38-2.318.57 0 .228-.038.456-.038.722-.874.19-1.71.418-2.584.608v.342z",
    fill: "url(#prefix__paint248_linear_6821_29592)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M770.074 324.021a593.249 593.249 0 00-5.054-4.218c.19-3.723.342-7.485.494-11.209 2.47-1.292 4.94-2.584 7.447-3.875l.114-2.508c-1.064-.76-3.343-2.66-3.267-4.902.114-2.508 1.481-5.015 1.557-5.091.076-.152.19-.342.266-.494l6.27.342 6.953-1.71a410.834 410.834 0 018.208-3.838c.683-1.444 1.405-2.85 2.089-4.293 1.52 1.178 3.002 2.393 4.484 3.571 1.444 1.14 1.482 4.066 1.406 5.282.228 1.482.418 2.964.608 4.445-.95 1.14-1.9 2.242-2.812 3.382-1.52 2.698-3.04 5.434-4.56 8.169-2.089 2.052-4.141 4.142-6.193 6.232-.646 2.318-1.254 4.635-1.9 6.991-.038 1.064-.114 2.166-.152 3.23-2.622.266-5.205.57-7.827.874-2.698-.152-5.434-.266-8.131-.38zm-2.394-4.636l3.419 2.85c2.242.076 4.484.19 6.726.304 1.9-.228 3.762-.456 5.661-.646.038-.722.076-1.444.114-2.128.684-2.508 1.406-5.015 2.128-7.523 2.052-2.09 4.142-4.18 6.232-6.27 1.482-2.697 2.963-5.357 4.445-8.017.836-1.026 1.71-2.09 2.584-3.116-.19-1.367-.38-2.697-.57-4.065.076-1.824-.266-3.686-.684-4.104a32.59 32.59 0 01-1.33-1.064c-.342.722-.684 1.406-1.026 2.128-3.039 1.406-6.079 2.812-9.081 4.218-2.66.608-5.281 1.216-7.903 1.824-1.596-.114-3.192-.19-4.788-.266-.38.798-1.102 2.507-1.14 4.141-.076 1.938 2.736 3.724 2.774 3.724.19.114.342.228.532.342-.076 1.368-.114 2.698-.19 4.065-2.508 1.254-4.977 2.546-7.447 3.838l-.456 9.765z",
    fill: "url(#prefix__paint249_linear_6821_29592)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M776.873 285.871l-6.269-1.026-3.762-.456c.038-.569.038-1.177.076-1.747-.532-.076-1.064-.114-1.595-.19.038-1.33.114-2.66.152-3.952 2.241.266 4.483.532 6.763.798 0 .418-.038.798-.038 1.216 1.938.304 3.914.608 5.851.95-.38 1.444-.798 2.925-1.178 4.407zm-7.295-2.811c.418.038.798.114 1.216.152 1.292.228 2.584.418 3.914.646l.342-1.254c-1.786-.304-3.572-.57-5.396-.836-.038.418-.076.836-.076 1.292zm-1.52-1.938c.494.038.988.114 1.444.19 0-.228 0-.456.038-.722-.494-.076-.988-.114-1.444-.19-.038.266-.038.494-.038.722z",
    fill: "url(#prefix__paint250_linear_6821_29592)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M825.618 271.928c.076-1.634.114-3.268.19-4.864 2.356.532 4.674 1.064 6.992 1.634-.038 1.14-.076 2.242-.152 3.382a424.64 424.64 0 00-7.03-.152zm2.774-2.698c0 .38-.038.76-.038 1.102.608 0 1.178.038 1.786.038 0-.228.038-.494.038-.722-.608-.152-1.216-.266-1.786-.418z",
    fill: "url(#prefix__paint251_linear_6821_29592)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M833.569 318.055c-2.774-.57-5.51-1.14-8.283-1.71.266-1.444.494-2.887.76-4.331 2.583.532 5.205 1.026 7.789 1.596-.114 1.481-.19 2.963-.266 4.445zm-5.396-2.888c.95.19 1.938.38 2.888.57 0-.304.038-.646.038-.95-.912-.19-1.862-.38-2.774-.57-.038.342-.114.646-.152.95z",
    fill: "url(#prefix__paint252_linear_6821_29592)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M905.72 262.162l-4.901-1.368c-1.14-.988-2.242-1.976-3.382-2.964-.684-.57-2.166-2.014-1.52-2.736.266-.266.912-.532 2.546-.076 2.47.684 3.838.304 3.914.304l.456-.114c1.025.342 2.089.722 3.115 1.064l-.228 5.89zm-3.761-2.584l1.253.342c.038-.95.077-1.938.077-2.888-.912.114-2.508.114-4.712-.456.19.228.456.494.722.722.874.76 1.786 1.52 2.66 2.28z",
    fill: "url(#prefix__paint253_linear_6821_29592)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M939.037 267.329c-1.33-.418-3.382-1.254-4.787-2.432-.988-.836-1.482-1.748-1.482-2.584l.228-4.483c.874-1.026 1.709-2.052 2.583-3.078.342.114.646.266.988.38.456.19 4.598 1.786 6.498 3.572.684.608 1.33 1.253 2.014 1.861-.038 2.09-.114 4.142-.19 6.232-1.406.342-2.774.722-4.18 1.064-.152-.038-.304-.076-.418-.114-.114-.076-.57-.19-1.254-.418zm-3.572-8.321l-.114 4.141c0 .418.19.798.646 1.178.912.76 2.698 1.406 3.648 1.672.912-.228 1.862-.456 2.774-.722.038-1.672.114-3.306.152-4.978-.418-.379-.836-.797-1.292-1.177-.836-.76-2.736-1.672-4.028-2.242-.608.722-1.178 1.406-1.786 2.128z",
    fill: "url(#prefix__paint254_linear_6821_29592)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M613.109 242.328c-2.584.19-5.205.38-7.789.608l.114-3.723c2.584-.494 5.205-.95 7.789-1.406 0 1.52-.038 3.039-.114 4.521zm-5.053-1.102c.797-.076 1.633-.114 2.431-.19 0-.418.038-.798.038-1.216-.798.152-1.634.304-2.431.456 0 .304-.038.646-.038.95z",
    fill: "url(#prefix__paint255_linear_6821_29592)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M616.109 238.528c-1.861.114-3.685.266-5.547.418a177.027 177.027 0 01-1.9-3.8c2.508-.19 5.054-.38 7.561-.57l-.114 3.952zm-3.495-1.216c.266-.038.57-.038.836-.076 0-.342.038-.646.038-.988l-1.368.114c.19.304.342.608.494.95z",
    fill: "url(#prefix__paint256_linear_6821_29592)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M621.277 146.463c-1.102-.57-2.204-1.178-3.306-1.748.076-1.101.114-2.165.19-3.267 2.242-.228 4.522-.418 6.764-.608-.076 1.33-.152 2.66-.19 3.951-1.178.532-2.318 1.102-3.458 1.672zm-.646-2.317c.342.19.646.342.988.532l.456-.228.114-2.204c-.494.038-.988.076-1.482.152 0 .532-.038 1.14-.076 1.748z",
    fill: "url(#prefix__paint257_linear_6821_29592)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M622.335 140.649c-.798.038-1.748.038-2.812 0-.228 0-.456-.038-.684-.038-.076-.076-.152-.19-.228-.266-.228-.304-1.368-1.824.456-2.698 1.596-.798 5.016-.988 5.699-1.026.456-.038.874-.038 1.33-.076a55.606 55.606 0 01-.152 2.584c.076.266-.076.646-.722.95-.683.304-1.595.494-2.887.57zm-1.444-1.178c1.938.038 2.432-.152 2.432-.152 0-.494.038-1.026.038-1.52-1.026.114-2.09.266-2.508.494-.266.152-.228.684.038 1.178z",
    fill: "url(#prefix__paint258_linear_6821_29592)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M695.561 154.861c-3.42-.114-6.877-.19-10.297-.228-2.28-.532-4.56-1.026-6.839-1.52.911-.494 1.861-1.026 2.773-1.52h.646c2.128 0 10.221-.304 10.297-.304h.532c1.976.76 3.99 1.52 5.966 2.28-1.064.418-2.09.836-3.078 1.292zm-9.423-1.368c2.774.038 5.547.076 8.321.152.038-.038.076-.038.152-.076-.912-.342-1.862-.722-2.812-1.064-1.596.038-6.269.228-8.853.266 1.064.228 2.128.456 3.192.722z",
    fill: "url(#prefix__paint259_linear_6821_29592)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M645.978 153.645c-2.204-.152-4.446-.342-6.649-.494l.114-2.47 6.687-.228a89.687 89.687 0 00-.152 3.192zm-3.99-1.52l1.368.114c0-.152 0-.304.038-.456-.456 0-.912.038-1.368.038 0 .076 0 .19-.038.304z",
    fill: "url(#prefix__paint260_linear_6821_29592)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M595.818 149.539c-2.432.038-4.901.076-7.333.152l.114-2.165c1.026-.076 2.052-.19 3.078-.266l.114-1.9c2.773-.228 5.547-.494 8.321-.684-.076 1.102-.114 2.204-.19 3.305-1.33.114-2.698.228-4.028.342-.038.38-.038.798-.076 1.216zm-4.027-1.14c.494 0 .949-.038 1.443-.038v-.114c-.456.076-.949.114-1.443.152zm2.507-1.177c1.026-.076 2.014-.19 3.04-.266 0-.304.038-.608.038-.95a82.006 82.006 0 00-3.04.266c0 .342 0 .646-.038.95z",
    fill: "url(#prefix__paint261_linear_6821_29592)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M606.155 145.969c-2.052.152-4.142.304-6.193.494.038-.836.114-1.71.152-2.546l6.193-.456c-.038.798-.114 1.672-.152 2.508zm-3.496-.912c.304-.038.608-.038.912-.076v-.19c-.304.038-.608.038-.912.076.038.076 0 .114 0 .19z",
    fill: "url(#prefix__paint262_linear_6821_29592)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M569.115 127.844c-.418.038-.836.038-1.178-.038-.494-.114-.987-.38-.456-1.14.038-.076.114-.152.152-.228 2.052-.722 4.066-1.482 6.118-2.204-.494-.076-1.026-.19-1.52-.266-.76-.228-1.52-.494-2.28-.722.456-.836.874-1.672 1.33-2.47 1.482-.379 2.926-.721 4.408-1.101l.114-1.14c.152-.266.342-.532.494-.798-.722 0-1.444.038-2.166.038-.95-.304-1.9-.608-2.888-.912-.304-.684-.646-1.368-.95-2.052.038-.684.114-1.33.152-2.014.874-.532 1.786-1.064 2.66-1.596l4.408-.342c1.025.114 2.089.19 3.115.304.912.266 1.786.532 2.698.798-.114.608-.228 1.178-.342 1.786-.38.152-.76.266-1.14.418.874.076 1.748.152 2.622.266.76.228 1.482.494 2.242.722.266.57.57 1.102.836 1.672.57.342 1.14.646 1.71.988.949.228 1.899.494 2.849.722 1.33.038 2.622.114 3.952.19.342.418.646.836.988 1.292-.038.342-.038.721-.076 1.063-.912.266-1.862.57-2.774.836a5.234 5.234 0 00-.76.304c-.076.19-.456.608-2.014 1.368-.114.076-.266.114-.38.19-1.14.114-2.317.19-3.457.304-.874.19-1.748.418-2.622.608-1.444.304-2.888.646-4.294.95-1.026.19-2.052.38-3.039.608-1.026.114-2.052.228-3.078.304-1.102.266-2.204.532-3.306.76-.532.19-1.33.418-2.128.532zm3.724-5.244c.38.114.722.228 1.102.38 1.558.266 3.154.57 4.711.836-1.785.608-3.533 1.254-5.319 1.862a49.54 49.54 0 011.064-.228c1.026-.114 2.09-.228 3.116-.342.835-.152 1.671-.342 2.545-.494 2.47-.57 4.94-1.102 7.41-1.634.874-.076 1.71-.152 2.583-.228.418-.228.798-.456.874-.532 0-.38 1.14-.874 2.128-1.178.456-.152.912-.266 1.368-.418 0-.114 0-.189.038-.303-.152-.19-.304-.342-.456-.532-1.14-.076-2.242-.114-3.382-.19-1.14-.304-2.317-.608-3.457-.912-.684-.418-1.406-.874-2.09-1.292-.228-.494-.494-.988-.722-1.482-.494-.152-1.026-.342-1.52-.494-2.166-.152-4.332-.342-6.497-.494 1.406-.532 2.849-1.026 4.255-1.558.038-.228.076-.456.152-.722-.57-.152-1.102-.342-1.672-.494-.797-.076-1.557-.114-2.355-.19-.798.076-1.558.114-2.356.19-.418.228-.798.494-1.216.722l-.114 1.558c.266.532.532 1.064.76 1.596l1.824.57c1.368-.038 2.698-.038 4.065-.076-.418.646-.798 1.254-1.216 1.9l-.113 1.71c-1.596.38-3.154.759-4.75 1.177-.342.456-.57.874-.76 1.292z",
    fill: "url(#prefix__paint263_linear_6821_29592)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M554.291 127.122c-.076 0-.152 0-.228.038-1.178.114-3.23.304-4.027 0-.304-.114-.456-.304-.418-.494.114-.57.949-2.584.987-2.698.076-.076.152-.152.19-.228.19-.152.418-.304.608-.456.038-.57.076-1.14.152-1.71 2.242-1.215 4.522-2.393 6.802-3.571 1.938-.19 3.913-.38 5.851-.532l5.434-.342c-.038.722-.114 1.444-.152 2.204-.266.608-.57 1.254-.836 1.862-.456.228-.912.456-1.368.721-.076.874-.114 1.748-.19 2.584-2.28.228-4.56.456-6.877.722-.532.266-1.064.57-1.596.836-1.444.304-2.888.684-4.332 1.064zm-2.014-.988c.418 0 1.102-.038 1.71-.114 1.102-.304 2.166-.57 3.268-.874a94.356 94.356 0 011.976-1.026c1.786-.19 3.533-.38 5.319-.57.038-.646.114-1.292.152-1.9.532-.265 1.026-.531 1.558-.797.228-.456.418-.95.646-1.406.038-.38.038-.76.076-1.102-1.026.076-2.014.152-3.04.19-1.558.152-3.077.304-4.635.418-1.71.912-3.42 1.786-5.13 2.697l-.114 1.596c-.304.228-.57.456-.874.684a22.392 22.392 0 00-.912 2.204z",
    fill: "url(#prefix__paint264_linear_6821_29592)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M646.584 115c-1.558.038-5.738-.19-6.574-.228l-8.777.114c.038-.836.114-1.671.152-2.507l7.637-1.938 7.296-.228c1.976-.836 3.913-1.672 5.889-2.508-.418-.57-.874-1.102-1.292-1.672 2.204-.988 4.446-1.938 6.65-2.888-1.102-.456-2.242-.911-3.382-1.367-.684-.722-1.368-1.444-2.09-2.128 2.242-.912 4.484-1.824 6.726-2.698 2.621-.494 5.243-1.178 5.547-1.406 0-.608 3.344-2.584 5.32-3.686.228-.114.494-.266.722-.38l1.026.228c.076 0 1.671.418 3.001.912 1.596.646 1.558 1.634 1.52 2.204 0 .19-.038.722-5.395 2.242-.038.418-.038.874-.076 1.292.456.912.874 1.862 1.33 2.774.797.304 1.595.646 2.355.95 1.748-.076 6.612-.228 7.942-.19.57 0 1.253.038 1.975.114.722.038 2.09.152 2.432.076 1.14-.456 4.294-.266 6.726-.038.114 0 .266.038.38.038 1.139.493 2.279.987 3.381 1.443-1.786.418-3.609.836-5.395 1.254-1.862.152-3.724.266-5.624.418a823.393 823.393 0 00-9.689-.076c.114.038.228.076.304.114 1.672.684 3.306 1.368 4.978 2.09-1.33.456-2.622.874-3.952 1.33-1.824-.342-3.648-.646-5.434-.988h-2.203c-1.026.57-1.596 1.14-1.33 1.254.874.342.988.722.95.988-.076.456-.722.798-1.102.988-.228.304-.456.608-.684.95-1.52.456-3.002.95-4.522 1.406l-7.941.114c-1.406.038-4.294.417-5.851.683-.38.418-1.33.912-2.926.95zm-12.691-1.216c2.204-.038 4.408-.076 6.649-.076 1.824.114 5.054.266 6.118.228.418 0 .608-.342.608-.342.038-.114.114-.228.152-.341.266-.038.494-.076.76-.114.494-.076 4.977-.798 7.333-.836l7.067-.114c1.026-.342 2.052-.646 3.078-.988.228-.304.418-.608.646-.874.114-.038.19-.076.304-.114.152-.038.456-.228.494-.304 0 0 0-.076-.228-.152-2.242-.912.95-2.584 1.596-2.888.152-.076.266-.114.418-.19 1.406 0 2.85 0 4.255.038 1.406.266 2.812.494 4.218.76.152-.038.342-.114.494-.152-.988-.418-2.014-.836-3.002-1.254-.418-.114-2.584-.038-4.407.152-.532.038-1.064.114-1.634.152l.114-2.204c5.699-.038 11.361 0 17.06.038 1.634-.152 3.306-.266 4.94-.38.684-.152 1.368-.342 2.052-.494-.19-.076-.38-.152-.608-.266-1.786-.152-3.686-.228-4.142-.152-1.026.38-2.888.266-4.522.152-.57-.038-1.139-.076-1.557-.076-1.216 0-6.422.152-8.322.228-.19 0-.418 0-.608.038-1.254-.494-2.507-1.025-3.761-1.519-.494-1.064-1.026-2.166-1.52-3.23a30.49 30.49 0 00.076-1.862c.19-.038.38-.114.57-.152 2.318-.646 4.559-1.406 4.825-1.672-.038-.304 0-1.026-.836-1.368-.493-.19-1.063-.38-1.519-.494-2.014 1.14-4.028 2.432-4.142 2.774-.038.608-2.356 1.33-6.877 2.204-1.634.684-3.268 1.33-4.94 2.014.456.456.912.95 1.368 1.406l4.673 1.823c-2.469 1.064-4.901 2.09-7.333 3.192.456.57.874 1.14 1.33 1.71a480.406 480.406 0 00-7.827 3.344c-2.584.076-5.13.152-7.714.266-1.899.456-3.761.95-5.661 1.406 0 .114-.038.379-.038.683z",
    fill: "url(#prefix__paint265_linear_6821_29592)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M664.249 349.82a252.28 252.28 0 00-5.661-.874c-1.634-1.33-3.268-2.698-4.902-4.027l.114-6.232-2.85-4.901a666.717 666.717 0 00-10.145-6.764l-.798-11.931c-.797-2.583-1.557-5.167-2.355-7.751-1.178-2.28-2.356-4.522-3.534-6.763-1.938-1.178-3.876-2.318-5.813-3.458.076-3.8.189-7.637.265-11.437.988-2.28 1.976-4.598 3.002-6.877 1.292-1.862 2.584-3.724 3.914-5.586l.114-5.281c-.874-1.482-1.748-2.926-2.622-4.408-1.178-.988-2.356-2.014-3.534-3.002-.494-1.292-.988-2.546-1.481-3.837-.76-1.178-1.52-2.318-2.318-3.496a843.958 843.958 0 00-10.069-5.206c.114-1.975.19-3.989.304-5.965l3.989-4.902c-.152-.988-.304-1.938-.456-2.925-.532-.342-1.026-.684-1.558-1.026-2.545.19-5.129.342-7.675.57 1.748-1.102 3.534-2.166 5.32-3.268-1.748-.304-3.458-.608-5.206-.912-2.014.532-4.065 1.064-6.079 1.596a491.373 491.373 0 00-4.408-2.052.288.288 0 01-.076-.152c-.038-.076-1.52-2.242-7.751-1.634-2.052.19-4.104.418-6.156.608-3.343 1.026-6.687 2.09-10.031 3.154a937.986 937.986 0 00-9.765 2.66c-2.774.342-5.509.722-8.283 1.102-2.47.569-4.94 1.177-7.409 1.747-2.204.342-4.37.684-6.574 1.026-2.926.19-5.813.418-8.739.646l-6.384-.456a1018.303 1018.303 0 00-11.436-4.369l-1.14-3.42c-1.672-.608-3.306-1.216-4.978-1.786-1.748-.874-3.534-1.71-5.319-2.584-1.292-.456-2.584-.912-3.876-1.33.228-1.405.418-2.849.646-4.255l-1.368-.456c.076-1.368.114-2.698.19-4.066 1.672-1.824 3.382-3.609 5.091-5.433-.038-1.482-.038-3.002-.076-4.484-1.101-.874-2.203-1.71-3.305-2.584l.57-3.647a591.194 591.194 0 0110.069-9.575 735.606 735.606 0 017.941-7.448 612.322 612.322 0 017.067-3.609c2.052-1.292 4.104-2.584 6.156-3.838 1.102-.76 2.242-1.558 3.344-2.318.076-1.102.152-2.204.228-3.344 4.141-2.507 8.359-5.015 12.576-7.485l6.498-2.85c2.356-.304 4.749-.57 7.105-.836 1.824.038 3.686.114 5.51.152 3.153-.874 6.307-1.709 9.461-2.545l7.979-2.394a950.89 950.89 0 0114.553-1.824c2.394-.076 4.787-.19 7.181-.266 2.736-.19 5.434-.38 8.169-.532 1.444-.722 2.926-1.444 4.37-2.166 2.584-.152 5.13-.266 7.713-.418-.114 1.976-.19 3.914-.304 5.89.456.798.874 1.634 1.33 2.432l4.332 1.709c2.166-.076 4.294-.19 6.459-.266 2.508.114 5.016.266 7.524.418a257.723 257.723 0 013.267 3.078c2.356-.038 4.674-.076 7.03-.076 1.596.304 3.229.608 4.825.95 1.102-.532 2.204-1.026 3.306-1.558l.114-3.078c4.446-.038 8.891 0 13.337.038 3.154.57 6.307 1.14 9.423 1.71 2.812.418 5.623.874 8.435 1.33 2.698.266 5.358.532 8.055.836 2.774.114 5.548.19 8.322.342 2.393.266 4.749.532 7.143.798 1.52.076 3.078.152 4.598.266 1.672-.76 5.015-2.546 5.053-3.762.038-.836.076-1.634.076-2.469l1.596-2.964c-.152-.532-.266-1.102-.418-1.634-2.888-.038-5.585.038-6.345.228.114.456.95.988 1.292 1.178.19.076.341.19.531.266l-.227.342c-.114.152-1.14 1.52-3.762 1.9-.988.152-2.546.19-4.598-.342-.342-.076-.684-.19-.988-.266.646-.988 1.254-1.938 1.9-2.926v-.266l-4.331-.456-2.508-1.254-3.078 1.254c-2.622-.342-5.243-.684-7.865-.988-.988.418-2.014.836-3.002 1.254-1.406-.684-2.774-1.368-4.18-2.014.608-.266 1.254-.532 1.862-.798-.57-.342-1.14-.722-1.748-1.064.038-.646.038-1.292.076-1.937l-4.103-1.938c-.152-.456-.342-.912-.494-1.368v-1.064c.228-.114.494-.19.722-.304l-1.482-.684c-.912 0-1.786-.038-2.698-.038-.95.418-1.938.798-2.888 1.216-1.329 0-2.659-.038-3.989-.038-.38.19-.76.418-1.14.608.836.38 1.672.76 2.47 1.14.114 1.406.266 2.811.38 4.255l-5.7 2.508a519.337 519.337 0 00-8.055-3.686c1.33-.607 2.698-1.177 4.027-1.785-.114-.076-.265-.114-.379-.19l-7.106.114c-.912-.418-1.862-.836-2.812-1.254l.342-4.522c-.038-.038-.76-2.584-5.813-2.508-2.318.038-4.598.076-6.916.152-2.051-1.064-4.103-2.089-6.155-3.115-.836.038-1.634.038-2.47.076-1.482-.608-2.963-1.216-4.445-1.786-.266.152-.494.342-.532.532-.114.38.38.798 1.444 1.216 2.089.836 4.141 1.709 6.231 2.545 2.622.684 5.206 1.33 7.827 2.014 2.698.57 5.396 1.178 8.094 1.786l-.114 2.47c-1.368.038-2.736.038-4.104.076l-.114 1.026c-.76.836-1.558 1.672-2.318 2.508-1.33.607-2.622 1.215-3.951 1.823-.038.608-.038 1.216-.076 1.862-2.318.076-4.636.114-6.954.228-2.166-.646-4.331-1.254-6.497-1.9l.114-2.051c2.242-.076 4.445-.19 6.687-.266.988.038 2.014.076 3.002.152.342-.152.684-.342 1.026-.494l.114-2.204c-.152-.228-1.178-1.368-6.156-2.508-1.671.038-7.789 0-11.589-2.66-2.469-.988-4.977-1.976-7.447-2.964-2.28.494-4.56.988-6.801 1.482-4.56.304-9.081.608-13.603.95-1.178.608-2.394 1.216-3.572 1.824l-.114 1.596c-.95.494-1.938.95-2.888 1.444-1.861.608-3.761 1.216-5.623 1.824-.912.836-1.824 1.672-2.736 2.469-1.368.722-2.774 1.482-4.141 2.204-.038.646-.076 1.33-.114 2.014-1.292.722-2.622 1.406-3.914 2.128-2.014.418-4.066.836-6.079 1.254-2.204.532-4.446 1.064-6.65 1.634-2.09.266-4.217.494-6.307.76-1.938.418-3.876.797-5.852 1.215-1.672-.57-3.305-1.139-4.977-1.671-1.634.228-3.23.456-4.864.684l.342-5.054c.988-.988 2.014-1.976 3.002-2.964.152-2.318.342-4.597.494-6.915 2.963-.418 5.889-.798 8.853-1.178 2.66-.228 5.282-.456 7.941-.646l6.308.228c1.52-.152 3.039-.342 4.597-.494a352.379 352.379 0 003.838-2.052l-.456-3.989c-.646-.38-3.42-1.862-7.333-1.406-1.862.19-3.002.076-3.42-.342-.836-.836 1.9-2.356 2.736-2.812.114-.076.266-.152.38-.19 2.659-.304 5.281-.57 7.941-.836 1.824-.76 3.61-1.52 5.433-2.28.912-.076 1.824-.152 2.736-.266a586.27 586.27 0 016.916-3.457c1.823-.152 3.609-.304 5.433-.456 2.014-1.064 4.028-2.166 6.042-3.23 1.899-.912 3.837-1.824 5.737-2.736 2.546-.152 5.092-.342 7.675-.456l1.71-.798c.114-1.634.19-3.229.304-4.863 2.09-.95 4.218-1.9 6.346-2.85.912.912 1.823 1.786 2.697 2.698.418.152.874.304 1.292.494.836-.228 1.71-.456 2.546-.684 0-.342.038-.646.038-.988-2.204-.836-4.408-1.672-6.649-2.47-.836.38-1.672.722-2.47 1.102-3.42.19-6.84.38-10.297.57a206.3 206.3 0 00-4.446-1.558c.114-1.178.19-2.394.304-3.572a212.466 212.466 0 012.774-3.153l7.637-.456c4.408-1.52 8.815-3.002 13.261-4.484a1113.813 1113.813 0 0116.832-6.953 752.77 752.77 0 0116.073-3.344c3.42-.038 6.801-.038 10.221-.038 2.166-.038 14.363.342 14.895.38.19.038.342.038.532.076 3.609.76 7.219 1.558 10.829 2.356 3.989.19 7.941.456 11.931.684 4.141.874 8.283 1.824 12.387 2.736 1.291.57 2.545 1.14 3.837 1.71-1.216.417-2.432.797-3.647 1.215a912.013 912.013 0 00-17.631-.836c-1.824-.266-3.61-.57-5.433-.836v.228c1.33.304 2.621.608 3.951.95 2.622 1.14 5.282 2.318 7.904 3.458.835.038 1.671.076 2.545.114-.722-.76-1.406-1.52-2.127-2.318 2.165.076 4.293.19 6.459.304.76.342 1.482.684 2.242.988.874-.304 1.748-.57 2.584-.874 0-.418-.001-.836.037-1.254l7.448.57c.874-.304 1.748-.57 2.622-.874-.532-.76-1.102-1.482-1.634-2.242 2.736.19 5.433.343 8.169.57 1.254.608 2.546 1.178 3.8 1.786 2.849-.494 5.699-.95 8.549-1.406 3.724.228 7.409.494 11.133.76 1.406.152 2.812.266 4.217.418h6.004c2.698.304 5.395.57 8.093.874 1.52-.038 3.002-.038 4.522-.076 4.103.494 8.245 1.026 12.349 1.558l4.901 1.254c1.178.266 2.394.532 3.572.798a117.804 117.804 0 00-5.396-2.128c-.228-.076-.417-.152-.645-.228 0-1.254-.038-2.508-.038-3.761 2.469.076 4.939.19 7.409.303 2.432.38 4.863.798 7.295 1.178 1.368 1.102 2.774 2.204 4.142 3.306.038 0 .076-.038.152-.038 0-.532-.038-1.102-.038-1.634 3.913.418 7.789.874 11.703 1.33 2.811-.152 5.623-.266 8.435-.38 3.268.456 6.497.912 9.765 1.406l2.356-2.584c3.686.684 7.371 1.406 11.057 2.128 2.242.228 4.445.494 6.687.76 2.432.57 4.826 1.14 7.258 1.748 2.165-.19 6.497-.494 8.397-.076 1.406.304 6.839 1.292 8.815 1.634.114.038.266.038.38.076 2.47 1.102 4.902 2.203 7.371 3.305 3.8.912 7.562 1.824 11.361 2.774 3.534 1.102 7.03 2.242 10.563 3.382.038.836.114 1.672.152 2.508-2.317-.19-4.673-.38-6.991-.57-.038.076 0 .19.114.304.266.228 1.026.494 2.128.798 2.47.341 4.977.683 7.447 1.063 1.786.494 3.572.95 5.358 1.444l5.357 1.824c2.394.456 6.346 1.368 7.752 2.356.532.342 3.495 1.406 6.345 2.318a831.89 831.89 0 0113.831 4.217c3.419 1.026 6.839 2.052 10.259 3.116a999.296 999.296 0 0117.934 9.309c1.139.152 3.569.532 4.939 1.026 1.48.532 6.31 2.356 6.5 2.432.11.038.23.076.3.152 1.41.684 2.81 1.406 4.18 2.128 1.03.342 2.09.684 3.12 1.064.68-.418 1.37-.874 2.05-1.292 2.17.456 4.29.95 6.46 1.406 6.04 2.507 12.04 5.091 18.05 7.713 3.15 1.862 6.27 3.724 9.38 5.623 1.67.912 3.31 1.862 4.94 2.774 4.87 2.052 9.73 4.18 14.59 6.308 1.83 1.177 3.61 2.317 5.44 3.495 2.43.836 4.82 1.672 7.25 2.546.12.228.19.456.31.684 0 .038.64 1.178 4.59 3.002 5.1 2.355 9.85 4.901 10.04 4.977 4.18 1.938 8.32 3.914 12.46 5.928 5.77 2.887 11.55 5.813 17.29 8.777 4.44 2.622 8.85 5.281 13.26 8.017 3.91 2.546 7.83 5.092 11.74 7.713 2.85 1.824 5.66 3.648 8.47 5.51 3.16 2.166 6.31 4.37 9.43 6.611 2.31 1.824 4.63 3.686 6.91 5.51 2.66 1.748 5.32 3.496 7.94 5.243a896.68 896.68 0 017.75 6.08c1.33 2.09 2.7 4.218 3.99 6.345-.57-.342-1.14-.684-1.67-.988-1.25-.76-12.04-7.143-16.19-11.361-1.63-.987-3.26-1.975-4.9-2.963-.57-.608-1.14-1.254-1.71-1.862-.41.456-.79.912-1.21 1.368-.34-.19-.69-.38-1.07-.57.12.114.19.228.31.342 2.2 1.748 4.44 3.495 6.65 5.243 1.71 1.33 3.42 2.698 5.13 4.028.6.532 2.5 2.394 2.16 3.002-.3.57-2.05-.19-6-2.622-1.18-.722-2.36-1.444-3.57-2.166h-3.8l-3.57-.114c-1.26-.76-2.55-1.52-3.8-2.242-1.03-1.14-2.09-2.28-3.12-3.457-.91-.038-1.82-.038-2.77-.076-1.68-.988-3.35-1.938-5.06-2.888-.79-.152-1.59-.304-2.35-.418.72.76 1.44 1.558 2.16 2.318 1.18 1.102 2.36 2.166 3.5 3.267 1.71 1.748 3.42 3.458 5.13 5.206.42.836.83 1.71 1.25 2.546 1.48 1.672 2.97 3.305 4.45 4.977-.04.836-.12 1.672-.15 2.546-.92-.038-1.79-.038-2.7-.076.99 2.09 2.01 4.142 2.96 6.231-.72-.038-1.4-.038-2.13-.038-2.31-1.405-4.63-2.773-6.95-4.179a939.282 939.282 0 00-12.01-13.375l-5.01-6.155a525.149 525.149 0 00-4.64-4.94c.27-.912.5-1.786.76-2.698 1.03 0 2.02 0 3.04.038.15-.988.27-1.976.38-2.963-.04-.418-.07-.798-.11-1.216l-2.4-2.85c-.53-.532-1.06-1.102-1.59-1.634-.42.076-.8.228-.8.532 0 .152.11.266.3.494.69.722 1.37 1.444 2.06 2.128-2.85-1.558-5.7-3.116-8.55-4.636-.76-.798-1.56-1.596-2.32-2.356-2.2-1.177-4.37-2.317-6.57-3.457h-1.33c.15 1.786.26 3.571.41 5.357-1.52-.988-3.04-2.014-4.59-3.001l-2.85-1.482c-.84-.836-1.64-1.634-2.47-2.47-2.17-1.102-4.33-2.166-6.5-3.268-.84 0-1.67.038-2.51.038-1.94-.95-3.87-1.9-5.77-2.85-1.07-.798-2.17-1.595-3.23-2.393-.84.038-1.64.038-2.47.076l-2.85-1.368-5.17.228c.19.76.34 1.52.53 2.28-.49.607-1.02 1.215-1.52 1.823 1.45.912 2.89 1.786 4.3 2.698 2.01 1.102 4.06 2.166 6.07 3.268.61-.038 1.22-.038 1.83-.076 2.47 1.444 4.94 2.926 7.41 4.407l3.99 3.99c2.73 1.368 5.43 2.774 8.13 4.142 1.06 1.634 2.13 3.267 3.19 4.939 2.01 1.672 3.99 3.306 5.97 4.978 1.74 1.596 3.49 3.192 5.24 4.787 1.06 1.368 2.13 2.774 3.19 4.142-.87 0-1.71.038-2.58.038 1.97 2.166 3.99 4.294 5.92 6.459l.12 2.774c-1.9-1.064-3.8-2.128-5.7-3.154-1.18-1.291-2.36-2.545-3.53-3.837-1.3-1.71-2.55-3.458-3.84-5.168-1.41-1.482-2.78-2.963-4.18-4.445-.42-1.026-.84-2.052-1.26-3.116l-4.56-5.13c-.34 0-.64 0-.98.038 1.36 1.406 2.73 2.85 4.06 4.294.53 1.064 1.07 2.09 1.6 3.154.07 1.102.11 2.166.15 3.267.38 2.204.8 4.446 1.14 6.65-.76.912-1.48 1.862-2.24 2.774-1.6.038-3.19.114-4.79.152-1.48-.798-3-1.596-4.48-2.356-.84-.874-1.64-1.748-2.47-2.584-.57.038-1.1.038-1.67.076.03.798.07 1.558.07 2.356-.11.874-.26 1.748-.38 2.622l-2.43.114c0 .418.04.835.04 1.253 2.16 1.824 4.33 3.686 6.5 5.51 1.82 2.014 3.64 3.99 5.43 6.003.83 1.634 1.63 3.268 2.47 4.902l-.69 2.166c-1.4-.418-2.81-.874-4.21-1.292-1.98-.874-3.99-1.748-5.97-2.622-1.1-1.216-2.16-2.432-3.27-3.648-1.02-1.861-2.09-3.685-3.11-5.547-1.9-2.014-3.8-4.066-5.7-6.079-1.03-.532-2.09-1.064-3.12-1.558-.04-.798-.03-1.596-.07-2.394-.95-1.026-1.94-2.014-2.93-3.04l-1.14-.57c-.83.038-1.63.114-2.47.152-1.25-.608-2.47-1.216-3.72-1.824-1.1-.494-2.21-.988-3.35-1.482-1.02-1.063-2.09-2.127-3.11-3.153.07-.494.11-1.026.19-1.52-.27-.114-.53-.266-.8-.38-2.01.152-4.03.304-6.04.494.49.494 1.03.988 1.52 1.52 1.9 1.444 3.76 2.925 5.62 4.369 2.74 1.14 5.47 2.318 8.21 3.458 1.29 1.33 2.58 2.698 3.88 4.028l-4.53.342c-1.14-.038-2.28-.114-3.42-.152.27.608.54 1.178.8 1.786 1.75 1.367 3.46 2.773 5.17 4.141.04.114.11.228.15.342 1.07 2.28 2.51 5.054 2.97 5.624.41.456 3.26 2.583 5.58 4.331.27.19.49.38.76.57.04 1.33.04 2.66.04 3.99.76.798 1.52 1.558 2.28 2.356v4.559c-.46.722-.95 1.444-1.41 2.166-1.63 1.216-3.23 2.394-4.86 3.61-.95.076-1.9.152-2.81.228-.8.836-1.56 1.671-2.36 2.507-3.61-1.861-7.26-3.685-10.87-5.509-1.86-.38-3.76-.798-5.62-1.178-1.18.114-2.35.228-3.57.342-1.33-.304-2.66-.57-3.99-.836-.8.114-1.63.19-2.43.304-1.64-1.178-3.31-2.318-4.94-3.496-.46-.722-.88-1.482-1.33-2.203-.65-.304-1.29-.608-1.94-.912l-6.95.912c-.5.493-1.03.949-1.52 1.443 1.29 1.368 2.62 2.774 3.91 4.142 2.09 1.52 4.22 3.04 6.31 4.598.72 1.33 1.44 2.659 2.2 3.951 1.07 2.394 2.09 4.75 3.12 7.144.26 1.292.57 2.545.83 3.837.27 1.786.54 3.572.76 5.358-.38.608-.79 1.178-1.17 1.786-1.87-.456-3.73-.912-5.59-1.33-1.98.304-3.99.57-5.96.874-1.56-.76-3.16-1.482-4.72-2.242-.49-1.178-.95-2.356-1.44-3.572-1.29-.912-2.55-1.786-3.84-2.698a358.207 358.207 0 01-3.99-3.799c-.64-1.254-1.29-2.508-1.94-3.762-1.59-1.368-3.23-2.736-4.82-4.104a98.272 98.272 0 00-2.58-2.697c0 .57-.04 1.14-.04 1.71-1.18.19-2.32.38-3.5.608.34 1.405.65 2.811.99 4.217 0 .798-.04 1.596-.04 2.394 1.45 1.71 2.85 3.382 4.26 5.091.22.684.49 1.33.72 2.014 1.56 1.71 3.11 3.42 4.67 5.13 1.56 1.482 3.16 2.964 4.71 4.483.8 1.52 1.56 3.002 2.32 4.522.53 1.634 1.1 3.306 1.64 4.94.34 1.481.64 2.963.98 4.445a69.787 69.787 0 01-.15 3.23c-2.01-.874-4.03-1.748-6.04-2.622-3.23-3.8-6.5-7.561-9.84-11.323-.38-1.9-.76-3.762-1.18-5.661.04-.608.04-1.216.04-1.824-.76-1.33-1.52-2.622-2.32-3.952-1.97-2.166-3.99-4.331-6-6.497-1.37-.608-2.74-1.178-4.14-1.748.07-1.254.15-2.546.22-3.8.88-.912 1.79-1.824 2.66-2.736l.12-4.711c-1.03-1.064-2.05-2.128-3.08-3.154-1.06-2.888-2.17-5.737-3.27-8.625 0-.532 0-1.064.04-1.596l-1.14-1.14c-.65.646-1.25 1.254-1.86 1.9-1.86-.76-3.763-1.52-5.625-2.242-1.899-1.368-3.761-2.736-5.661-4.065 0-1.292.038-2.584.038-3.876-.532-.912-1.026-1.824-1.558-2.736-3.192-3.04-6.383-6.079-9.613-9.081-.646-1.026-1.33-2.09-1.976-3.116-.684-.608-1.368-1.254-2.052-1.862-.874-.455-1.71-.949-2.583-1.405-.494.114-.988.19-1.482.304-3.116-.646-6.232-1.254-9.347-1.862v2.242c-1.938.417-3.914.797-5.852 1.215-1.178.418-2.394.836-3.572 1.254a839.255 839.255 0 00-16.908 3.914c.19.608.418 1.254.608 1.862-.152 1.026-.266 2.09-.418 3.116-.076.038-.19.076-.266.114-1.254.455-2.432 1.101-2.508 1.367 0 .646.228 4.18.228 4.18-.038 1.064-.038 2.128-.076 3.192-1.406.228-2.774.456-4.18.684-1.329.342-2.659.722-4.027 1.064-2.546-.76-5.092-1.558-7.638-2.28.038-1.824.115-3.686.153-5.51a625.07 625.07 0 00-5.168-4.445c-1.71-3.952-3.458-7.942-5.206-11.893-2.621-2.85-5.281-5.7-7.979-8.511a479.763 479.763 0 00-2.47-6.726l1.938-3.876c.038-.076.266-.342-.038-.645-.19-.19-.608-.38-1.178-.57-.532.721-1.026 1.443-1.558 2.165-1.557-.418-3.115-.798-4.673-1.178-1.634-.455-3.23-.911-4.864-1.367-2.204-1.558-4.369-3.078-6.573-4.636 1.33-.38 2.66-.722 4.028-1.102-.494-.266-.988-.57-1.482-.836-.988-.19-1.976-.342-2.964-.532-1.444-1.064-2.85-2.128-4.294-3.191-2.507-1.824-5.053-3.61-7.599-5.396l-2.394.684c-1.482-.304-2.964-.646-4.445-.95-2.888-.608-5.966-1.558-6.688-1.786a593.658 593.658 0 00-13.869-2.698c-2.165-.57-4.331-1.177-6.535-1.747-1.558-.684-3.154-1.368-4.711-2.052-.304-.19-.57-.38-.874-.57.342.38.531.836.569 1.33.76.494 1.52 1.026 2.28 1.52a332.7 332.7 0 014.788 3.115c.95.646 1.938 1.33 2.888 2.014 1.481.494 2.963 1.026 4.445 1.52.494 1.216 1.026 2.432 1.52 3.648-1.064.494-2.128 1.026-3.192 1.558-4.179 1.329-8.321 2.659-12.424 4.065.189.836.341 1.71.531 2.546-1.557-.266-3.153-.57-4.749-.836-2.242-.038-4.484-.076-6.726-.076-1.101.38-2.165.76-3.267 1.14-1.026.532-2.052 1.026-3.078 1.558-1.254.418-2.508.836-3.762 1.292-4.141.19-8.245.418-12.349.646-3.229.342-6.421.684-9.613 1.063-2.545-.265-5.053-.531-7.599-.797-1.938-.38-3.876-.76-5.813-1.102.038-.912.038-1.862.076-2.774-.494-.798-.95-1.558-1.444-2.356-.988-1.178-1.938-2.394-2.926-3.572-1.862-1.139-3.686-2.317-5.548-3.457-.76-1.482-1.481-2.926-2.241-4.408a220.78 220.78 0 00-4.332-2.014c-1.14-.722-2.28-1.406-3.42-2.127a357.62 357.62 0 00-3.153-4.826c-1.406-1.14-2.85-2.242-4.256-3.382a281.435 281.435 0 00-4.636-2.659c-1.292-1.406-2.583-2.774-3.875-4.18-1.368-1.406-2.774-2.812-4.142-4.18 0-.684.038-1.368.038-2.09l-1.9-.114c.418.608.798 1.254 1.216 1.862-1.102.456-2.242.912-3.344 1.368 1.482.646 3.002 1.292 4.484 1.938.646 1.102 1.254 2.204 1.9 3.306 1.102 1.026 2.242 2.052 3.344 3.077l4.787 3.762a711.945 711.945 0 013.838 7.523c1.178.684 2.356 1.368 3.496 2.09l5.357 3.99c.494 1.064.95 2.166 1.444 3.23 1.064.911 2.09 1.785 3.154 2.697 1.709.798 3.419 1.596 5.129 2.432 1.444.95 2.888 1.862 4.37 2.812.836 1.14 1.672 2.242 2.508 3.382 1.519.987 3.001 1.937 4.521 2.925 1.102.798 2.166 1.634 3.268 2.432l4.901-.114 9.006.342h6.497c1.178-.456 2.318-.874 3.496-1.292.95.76 1.9 1.52 2.849 2.242.494 2.014.988 3.99 1.482 6.003 0 .608-.038 1.178-.038 1.786-1.672.608-3.305 1.254-4.977 1.9-.988 1.482-1.976 2.926-2.964 4.408-1.824.722-3.61 1.444-5.434 2.165-.683 1.254-1.329 2.508-2.013 3.762-1.178.456-2.318.912-3.496 1.368-2.356.38-4.75.722-7.105 1.102-1.52.798-3.04 1.634-4.56 2.432a346.21 346.21 0 00-6.725 2.242c-2.128.949-4.218 1.899-6.346 2.849-.76.836-1.558 1.672-2.318 2.508-1.481.684-2.925 1.368-4.369 2.014-1.33 1.254-2.698 2.508-4.028 3.762-.038 1.557-.114 3.077-.152 4.635.532 2.774 1.026 5.51 1.52 8.283 1.368.874 2.736 1.71 4.104 2.584-.038 1.52-.114 3.078-.19 4.598-.038 1.292.418 5.813.418 5.851-.076 1.52-.114 3.04-.19 4.522l-2.622 4.559c-3.344.798-6.687 1.634-10.031 2.47-1.634.19-3.268.342-4.902.532-1.368.494-2.698.988-4.065 1.482-1.14 1.216-2.28 2.432-3.382 3.648a85.991 85.991 0 00-3.154 1.785c-.038.57-.038 1.178-.076 1.748 1.178.874 2.356 1.786 3.534 2.66-.114 1.786-.19 3.572-.304 5.358l-3.078 5.015c-2.546.494-5.091.95-7.637 1.482a241.905 241.905 0 00-3.23 1.938c.038 1.216.114 2.394.152 3.609-.38 1.178-.798 2.394-1.178 3.572l-2.394 1.482c-1.633.874-3.267 1.786-4.901 2.698a62.15 62.15 0 00-.076 2.66c0 .38-.114 1.215-10.259 7.903-.152.076-.304.114-.418.19a798.475 798.475 0 00-13.641 3.648 928.907 928.907 0 00-14.553-.114c-2.051.417-4.065.835-6.117 1.291-.912 1.026-2.014 1.824-3.078 2.622zm-4.217-2.622c1.14.19 2.279.342 3.419.532.912-.684 1.824-1.33 2.736-2.013 2.432-.532 4.864-1.026 7.295-1.52 4.826 0 9.652.038 14.477.114 4.18-1.178 8.397-2.356 12.653-3.458 4.028-2.698 8.587-5.852 9.233-6.649l.114-3.344c1.9-1.064 3.838-2.128 5.776-3.154.57-.342 1.178-.722 1.747-1.064.304-.95.608-1.862.95-2.812-.076-1.405-.114-2.773-.19-4.179 1.596-.912 3.154-1.824 4.75-2.736 2.242-.456 4.522-.874 6.763-1.292.836-1.368 1.71-2.774 2.546-4.141.038-1.406.114-2.774.152-4.18-1.178-.874-2.356-1.786-3.534-2.66l.114-3.191a190.707 190.707 0 013.8-2.128l3.344-3.686 5.129-1.824c1.672-.19 3.306-.38 4.978-.532 2.888-.722 5.813-1.482 8.701-2.166.722-1.253 1.406-2.507 2.128-3.723.038-1.406.114-2.812.152-4.218 0-.114-.456-4.521-.418-5.927.038-1.292.114-2.584.152-3.876-1.33-.836-2.622-1.634-3.952-2.47-.532-3.001-1.102-6.003-1.634-9.005.038-1.71.114-3.42.152-5.129l4.674-4.332a220.78 220.78 0 014.332-2.014c.76-.836 1.557-1.672 2.317-2.508l6.612-2.963c2.242-.76 4.483-1.52 6.763-2.242 1.634-.874 3.23-1.71 4.864-2.546l7.181-1.14 2.508-1.026c.684-1.254 1.33-2.508 2.014-3.761 1.824-.722 3.647-1.482 5.471-2.204.988-1.482 1.976-2.926 2.964-4.408 1.558-.608 3.078-1.178 4.636-1.786 0-.342-.001-.722.037-1.064l-1.367-5.471-.57-.456c-.646.228-1.292.494-1.938.722h-7.295a360.393 360.393 0 00-8.968-.342 370.74 370.74 0 00-6.421.152c-1.406-1.064-2.85-2.128-4.256-3.23a361.95 361.95 0 00-4.901-3.23c-.836-1.139-1.672-2.241-2.508-3.381-1.254-.798-2.47-1.596-3.724-2.356-1.824-.874-3.647-1.748-5.509-2.622a140.854 140.854 0 00-3.61-3.153c-.494-1.064-.95-2.128-1.444-3.23-1.596-1.178-3.191-2.356-4.825-3.496-1.292-.76-2.584-1.52-3.914-2.318a755.472 755.472 0 00-3.952-7.751c-1.519-1.178-3.001-2.318-4.521-3.496-1.216-1.102-2.394-2.241-3.61-3.343a116.64 116.64 0 01-1.672-2.964c-2.052-.874-4.141-1.786-6.193-2.66 1.444-.608 2.888-1.178 4.369-1.786-.608-.95-1.215-1.862-1.823-2.811 2.735.152 5.471.342 8.207.532-.038.987-.038 2.013-.076 3.001 1.292 1.292 2.584 2.622 3.876 3.914 1.253 1.368 2.545 2.736 3.799 4.104 1.482.835 2.926 1.671 4.37 2.507 1.558 1.254 3.116 2.47 4.673 3.724 1.026 1.596 2.09 3.192 3.116 4.75.912.531 1.824 1.101 2.774 1.633l4.901 2.28c.76 1.52 1.558 3.002 2.318 4.522 1.824 1.14 3.648 2.318 5.472 3.457l3.077 3.762c.57.912 1.102 1.862 1.634 2.774 0 .57-.038 1.14-.038 1.71 1.102.228 2.204.418 3.268.646 2.356.228 4.712.456 7.067.722 2.964-.38 5.966-.722 8.968-1.064 4.065-.266 8.131-.456 12.196-.646a69.71 69.71 0 013.002-1.064c1.026-.532 2.052-1.064 3.078-1.558 1.292-.456 2.546-.912 3.838-1.368l7.941.114c.646.114 1.33.228 1.976.342-.114-.532-.228-1.102-.342-1.634a666.387 666.387 0 0113.222-4.331c.798-.38 1.558-.76 2.356-1.14-.304-.722-.608-1.482-.912-2.204l-3.647-1.254c-1.102-.76-2.204-1.52-3.344-2.28-2.622-1.748-5.244-3.457-7.865-5.167v-.266c0-.57-.228-1.064-.684-1.292a2.432 2.432 0 00-1.064-.266l-3.192 1.026c-1.824.456-3.648.874-5.433 1.33l-3.99 1.368a87.341 87.341 0 00-3.116-2.014s-2.469-1.634-3.761-2.394c-.95-.608-1.064-1.254-.836-1.748-.95-.19-1.862-.418-2.812-.608-1.406-.19-2.774-.38-4.18-.57-.114-.836-.266-1.672-.38-2.47-.304-.949-.646-1.899-.988-2.849-2.583-1.596-5.205-3.192-7.827-4.788.646-.228 1.254-.456 1.9-.646.608-.494 1.254-.95 1.862-1.444 1.634.228 3.305.418 4.939.646l5.928 3.648v1.254c1.52.684 3.078 1.368 4.597 2.09.988.608 1.938 1.253 2.926 1.861 1.596.532 3.154 1.064 4.75 1.596 1.634.456 3.229.912 4.863 1.368.19.038.38.114.532.152.798-.266 1.596-.494 2.356-.76 1.938.304 3.838.646 5.775.988v1.672c.798.532 1.634 1.064 2.432 1.634l3.99 1.71c1.9.494 3.838.988 5.737 1.52 4.674.873 9.31 1.785 13.945 2.735.038 0 .114.038.152.038.038 0 3.306 1.064 6.232 1.672 1.101.228 2.241.456 3.343.722 1.178-.342 2.318-.684 3.496-.988a311.566 311.566 0 014.332 3.154c1.709 1.178 3.381 2.394 5.053 3.572 1.14.835 2.318 1.709 3.458 2.583.874.152 1.748.304 2.622.494a240.84 240.84 0 015.281 3.04c-.988.152-1.976.342-2.964.494l-1.71.456 3.876 2.736c1.292.38 2.584.722 3.876 1.102.874.228 1.786.456 2.66.684.532-.722 1.025-1.444 1.557-2.166.304.076.646.152.95.228 2.014.532 3.42 1.178 4.218 1.976 1.026 1.063.456 1.823.38 1.899-.608 1.178-1.178 2.356-1.786 3.534.76 2.09 1.52 4.142 2.28 6.231 2.66 2.812 5.319 5.624 7.941 8.436 1.748 3.875 3.42 7.751 5.092 11.627 1.824 1.558 3.647 3.153 5.433 4.711l-.114 4.636c1.33.418 2.66.798 4.028 1.216 1.102-.304 2.242-.608 3.344-.874 1.102-.19 2.203-.38 3.343-.57.038-.798.038-1.634.076-2.432 0-.114-.228-3.534-.228-4.256 0-.759 1.672-1.557 2.812-1.975l.342-2.508c-.266-.836-.57-1.672-.836-2.508a866.41 866.41 0 0117.783-4.142c1.177-.418 2.393-.835 3.571-1.253 1.71-.38 3.458-.722 5.206-1.102v-2.698c3.533.646 7.067 1.368 10.563 2.052.722-.152 1.406-.266 2.128-.418 1.557.836 3.077 1.672 4.635 2.508.95.873 1.9 1.785 2.85 2.659.684 1.026 1.33 2.09 1.976 3.116 3.229 3.04 6.459 6.079 9.651 9.157.608 1.14 1.254 2.242 1.862 3.382 0 1.064-.038 2.128-.038 3.192 1.292.911 2.545 1.823 3.837 2.773 1.102.418 2.204.874 3.307 1.292.87-.912 1.78-1.786 2.66-2.698 1.52 1.482 3 2.964 4.48 4.446 0 .722-.04 1.406-.04 2.128 1.03 2.622 2.02 5.243 3.01 7.865 1.1 1.14 2.24 2.28 3.34 3.458-.08 1.9-.15 3.838-.23 5.737-.87.912-1.78 1.824-2.66 2.736-.04.646-.04 1.254-.07 1.9.87.38 1.78.76 2.66 1.14 2.35 2.546 4.71 5.091 7.03 7.675.87 1.52 1.78 3.04 2.66 4.56-.04.684-.04 1.368-.08 2.052.34 1.633.68 3.305 1.06 4.939 2.89 3.268 5.74 6.535 8.55 9.841.88.38 1.79.76 2.66 1.14.04-.532.04-1.026.08-1.558-.31-1.406-.65-2.774-.95-4.179-.5-1.558-1.03-3.154-1.56-4.712-.68-1.292-1.33-2.584-2.01-3.876-1.45-1.367-2.89-2.773-4.37-4.141-1.71-1.938-3.46-3.838-5.21-5.738-.26-.76-.53-1.482-.83-2.242a935.529 935.529 0 00-4.45-5.167c.04-.95.04-1.862.08-2.812-.38-1.634-.76-3.268-1.14-4.939 1.21-.228 2.47-.418 3.68-.646l.12-4.674c2.24 2.318 4.44 4.636 6.64 6.953 1.71 1.444 3.42 2.888 5.13 4.37.69 1.292 1.33 2.546 2.02 3.838 1.1 1.064 2.24 2.128 3.34 3.191 1.48 1.026 2.97 2.052 4.41 3.078.42 1.026.87 2.09 1.29 3.116.65.304 1.29.608 1.98.95 1.93-.266 3.87-.532 5.85-.76 1.56.38 3.15.76 4.71 1.14.23-.342.46-.684.65-1.026-.23-1.672-.46-3.306-.73-4.978-.26-1.216-.53-2.431-.79-3.609-.99-2.318-2.02-4.598-3.04-6.916-.57-1.064-1.18-2.128-1.75-3.191-2.02-1.482-4.03-2.964-6.04-4.446-1.75-1.862-3.46-3.686-5.21-5.51.84-.759 1.67-1.481 2.51-2.241 2.62-.342 5.2-.684 7.83-1.026 1.48.684 2.96 1.368 4.44 2.09.53.873 1.03 1.747 1.56 2.621.87.608 1.71 1.216 2.58 1.824.61-.038 1.22-.114 1.83-.152 1.33.266 2.66.57 3.99.836l3.53-.342c2.2.456 4.37.95 6.57 1.444 3.2 1.596 6.35 3.192 9.5 4.788.73-.684 1.41-1.368 2.13-2.09.95-.076 1.9-.152 2.85-.266 1.48-1.14 2.96-2.28 4.45-3.382.41-.684.87-1.33 1.29-2.014 0-1.216 0-2.432-.04-3.647-.76-.798-1.52-1.558-2.32-2.356 0-1.216-.04-2.47-.04-3.686-1.82-1.368-4.86-3.61-5.66-4.483-.87-.95-2.43-4.104-3.38-6.08-1.75-1.406-3.46-2.774-5.2-4.18-.54-1.177-1.07-2.355-1.6-3.533 1.52.076 3.08.114 4.64.19.91-.076 1.82-.152 2.73-.19-.45-.456-.91-.912-1.33-1.406-2.62-1.102-5.24-2.204-7.83-3.306-2.24-1.748-4.44-3.495-6.72-5.243-1.14-1.102-2.24-2.242-3.38-3.344l8.43-.684c1.48.684 2.93 1.368 4.41 2.09-.08.76-.15 1.52-.27 2.28.54.532 1.03 1.026 1.56 1.558.76.341 1.56.683 2.32 1.025.95.456 1.86.912 2.81 1.368.84-.038 1.64-.114 2.47-.152 1.07.494 2.09 1.026 3.16 1.558 1.44 1.482 2.88 3.002 4.33 4.522 0 .532.03 1.064.03 1.596.57.304 1.14.57 1.71.874 2.28 2.431 4.56 4.863 6.84 7.333 1.07 1.862 2.09 3.686 3.12 5.547.65.722 1.33 1.444 1.98 2.166 1.55.684 3.07 1.368 4.63 2.052.88.266 1.75.532 2.62.76.12-.418.27-.798.38-1.216-.72-1.406-1.4-2.85-2.12-4.256-1.64-1.785-3.23-3.533-4.87-5.319-2.43-2.052-4.86-4.142-7.33-6.194-.04-.873-.04-1.709-.08-2.583.84-.038 1.71-.076 2.55-.152.11-.722.19-1.406.3-2.128-.04-.95-.07-1.9-.11-2.812 1.33-.076 2.66-.114 3.99-.19 1.18 1.216 2.32 2.432 3.46 3.648.83.456 1.71.874 2.54 1.33 1.25-.038 2.51-.076 3.72-.152.65-.798 1.3-1.596 1.94-2.394-.38-2.128-.72-4.256-1.1-6.421a85.366 85.366 0 00-.19-3.192c-.46-.874-.91-1.71-1.37-2.584a660.829 660.829 0 00-5.32-5.471l4.22-.114c.72.721 1.44 1.481 2.17 2.203 1.55 1.786 3.15 3.61 4.71 5.434.38.95.76 1.9 1.18 2.85a372.48 372.48 0 013.95 4.217c1.29 1.71 2.58 3.42 3.84 5.168.87.95 1.71 1.862 2.58 2.812.8.455 1.6.873 2.39 1.329 0-.304-.03-.608-.03-.874-2.32-2.507-4.6-5.015-6.96-7.523.95 0 1.9-.038 2.85-.038-.64-.836-1.29-1.672-1.94-2.47-1.55-1.405-3.11-2.849-4.67-4.255-2.17-1.824-4.33-3.648-6.54-5.434-.95-1.444-1.9-2.925-2.85-4.369-2.54-1.292-5.09-2.622-7.63-3.876-1.41-1.406-2.78-2.774-4.18-4.18-1.83-1.064-3.61-2.165-5.44-3.229-.57.038-1.17.038-1.74.076-2.47-1.368-4.94-2.698-7.45-4.066-2.28-1.444-4.56-2.888-6.84-4.294.68-.836 1.37-1.633 2.09-2.469-.19-.874-.42-1.748-.61-2.622 2.21-.114 4.41-.19 6.61-.266.95.456 1.9.912 2.85 1.33l3-.114c1.45 1.026 2.85 2.09 4.3 3.153 1.4.684 2.81 1.368 4.22 2.052.83-.038 1.67-.038 2.5-.076 2.82 1.406 5.63 2.812 8.44 4.218.83.836 1.67 1.634 2.47 2.47.76.418 1.56.798 2.32 1.216.6.38 1.17.76 1.78 1.139-.11-1.405-.23-2.811-.3-4.217.87 0 1.78-.038 2.66-.038 2.85 1.482 5.66 2.964 8.51 4.445.76.798 1.56 1.558 2.32 2.356 1.02.532 2.01 1.064 3.04 1.634 0-.076-.04-.114-.04-.19-.04-1.102 1.94-1.064 2.16-1.026.27 0 .54.038.8.038l3.42 3.534c.99 1.178 1.98 2.394 2.97 3.572.03.57.07 1.139.11 1.709-.15 1.14-.3 2.28-.46 3.42-1.02 0-2.05-.038-3.07-.038-.19.608-.35 1.216-.54 1.824 1.3 1.368 2.59 2.736 3.88 4.142 1.67 2.051 3.34 4.103 5.02 6.155 3.76 4.142 7.52 8.283 11.2 12.463 1.68.988 3.39 2.014 5.06 3.04h.53c-.99-2.09-2.01-4.142-3-6.232 1.02.038 2.05.038 3.08.076.03-.494.07-1.026.11-1.52-1.37-1.52-2.7-3.039-4.07-4.559-.38-.836-.79-1.634-1.21-2.47-1.52-1.52-3-3.078-4.52-4.598-1.18-1.102-2.4-2.241-3.57-3.343-1.45-1.558-2.89-3.078-4.34-4.636 1.71.304 3.39.608 5.1.912 1.59.912 3.22 1.824 4.82 2.774l3.69.114a685.23 685.23 0 014.1 4.521c.65.38 1.29.76 1.94 1.14l2.92.114h4.45l4.56 2.736c2.13 1.292 3.15 1.824 3.61 2.052-.19-.19-.42-.456-.65-.646-1.59-1.254-3.19-2.546-4.82-3.8-2.43-1.976-4.9-3.913-7.34-5.851a217.017 217.017 0 00-4.06-4.408c1.44.76 2.92 1.558 4.37 2.356.61-.684 1.21-1.368 1.82-2.09 1.22 1.33 2.47 2.698 3.69 4.028 1.63.988 3.23 1.938 4.86 2.925.11.114.23.266.34.38 2.24 2.47 9.12 6.84 13.07 9.272-.6-.95-1.17-1.862-1.78-2.812-2.21-1.748-4.41-3.458-6.65-5.206-2.74-1.824-5.47-3.647-8.21-5.433-2.28-1.862-4.6-3.686-6.91-5.51-3.04-2.165-6.12-4.293-9.2-6.421-2.81-1.824-5.62-3.686-8.47-5.472-3.88-2.583-7.79-5.167-11.71-7.713-4.33-2.66-8.66-5.281-13.03-7.865-5.66-2.964-11.4-5.852-17.1-8.701-4.18-2.052-8.39-4.028-12.61-6.004-.23-.114-4.98-2.66-9.92-4.939-3.91-1.824-5.7-3.344-6.46-4.218-1.97-.684-3.95-1.406-5.93-2.09-1.97-1.292-3.95-2.546-5.92-3.838-4.79-2.127-9.62-4.179-14.44-6.231l-5.25-2.964a735.742 735.742 0 00-9.3-5.547 970.061 970.061 0 00-16.95-7.22c-1.67-.38-3.35-.759-5.02-1.101-.76.456-1.48.949-2.24 1.405l-5.01-1.709c-1.49-.76-3.01-1.52-4.53-2.28-.87-.342-4.94-1.9-6.19-2.318-.8-.266-3.08-.646-4.369-.836-.152-.038-.342-.038-.494-.076a1060.632 1060.632 0 00-18.466-9.613c-3.23-.988-6.498-2.014-9.727-2.964-4.636-1.444-9.271-2.85-13.945-4.255-2.014-.646-6.649-2.128-8.055-3.116-.532-.304-3.268-.988-5.7-1.482-.076 0-.152-.038-.228-.038-1.862-.646-3.723-1.292-5.623-1.938-1.672-.456-3.306-.912-4.978-1.33-2.47-.342-4.977-.722-7.447-1.064-2.128-.57-3.648-1.177-4.446-1.861-1.026-.874-.38-1.406-.266-1.482a.667.667 0 00.19-.152c2.166.152 4.332.342 6.498.532-.038-.304-.038-.646-.076-.95-2.736-.912-5.51-1.786-8.246-2.66-3.913-.988-7.865-1.938-11.779-2.888a404.605 404.605 0 00-7.219-3.229c-1.558-.304-7.105-1.292-8.739-1.634-.912-.19-4.484-.038-7.295.228-.114 0-.266.038-.38.038-2.622-.646-5.206-1.254-7.828-1.9-2.242-.266-4.483-.532-6.725-.76l-9.347-1.824c-.76.836-1.52 1.672-2.28 2.546-3.724-.57-7.447-1.102-11.171-1.634-2.812.114-5.624.228-8.397.38l-9.689-1.14c0 .38 0 .76.038 1.14l-3.192.798-5.13-4.104c-1.861-.304-3.685-.608-5.547-.912-1.71-.076-3.42-.152-5.092-.228 0 .798.038 1.596.038 2.394 6.65 2.47 7.714 3.306 7.296 3.8-.304.38-1.482.342-2.356.19-1.9-.418-3.8-.874-5.7-1.292-1.596-.418-3.229-.836-4.825-1.254-3.838-.494-7.714-.988-11.551-1.444-1.52.038-3.002.038-4.522.076-2.698-.304-5.433-.608-8.131-.912h-6.004c-1.443-.152-2.887-.266-4.293-.418-3.458-.266-6.916-.494-10.373-.722a738.087 738.087 0 00-9.727 1.634c-1.482-.722-3.002-1.406-4.484-2.09l-3.572-.228c.38.494.722.988 1.102 1.482l-4.559 1.482-5.852-.456v.608c-1.748.57-3.457 1.178-5.205 1.748l-3.306-1.482c-.532-.038-1.064-.038-1.596-.076.722.76 1.406 1.558 2.128 2.318l-7.409-.342a574.963 574.963 0 00-8.512-3.724c-1.595-.38-3.229-.76-4.825-1.102.038-.722.038-1.481.076-2.203 2.85.418 5.737.874 8.587 1.291 5.32.19 10.677.456 15.997.722l1.026-.342a38.952 38.952 0 01-1.824-.835 570.117 570.117 0 00-11.589-2.508 635.05 635.05 0 00-12.007-.684c-3.61-.798-7.22-1.596-10.829-2.356-1.862-.076-12.539-.38-14.515-.38-3.192 0-6.383 0-9.575.038a992.754 992.754 0 00-15.313 3.192 1069.636 1069.636 0 00-16.49 6.84 1529.098 1529.098 0 00-14.097 4.749c-2.204.114-4.446.266-6.649.38a109.54 109.54 0 00-2.014 2.317c-.076.95-.114 1.9-.19 2.888.988.342 1.976.684 2.964 1.064 2.697-.152 5.395-.304 8.131-.456 1.216-.532 2.394-1.064 3.61-1.596 3.077 1.14 6.155 2.28 9.195 3.42-.038.684-.076 1.368-.114 2.09-1.9.494-3.8.988-5.662 1.482-1.026-.418-2.052-.798-3.077-1.216l-1.368-1.368c-.912.418-1.824.798-2.698 1.216-.114 1.634-.19 3.229-.304 4.863-1.102.494-2.166.988-3.268 1.52l-7.675.456c-1.634.76-3.268 1.558-4.902 2.318-2.279 1.216-4.559 2.394-6.801 3.61-1.862.152-3.686.304-5.548.456a387.394 387.394 0 00-6.915 3.457c-.988.076-1.938.19-2.926.266-1.823.76-3.647 1.52-5.433 2.28-2.584.266-5.13.532-7.713.798-.912.532-1.71 1.102-1.71 1.292.038 0 .342 0 1.064-.076 6.003-.646 9.575 1.748 9.727 1.824.038.076.114.152.152.228.19 1.558.342 3.115.532 4.635-1.862.95-3.686 1.938-5.51 2.926-2.09.228-4.217.418-6.307.646l-6.384-.228c-2.469.19-4.901.418-7.371.646-2.052.266-4.066.532-6.117.798-.152 2.014-.304 4.027-.418 6.041-.988.988-2.014 1.976-3.002 2.964l-.228 3.572 3.306-.456 4.787 1.596c1.558-.342 3.116-.646 4.712-.988 2.127-.266 4.217-.532 6.345-.798 2.052-.532 4.104-1.026 6.156-1.558 1.823-.38 3.609-.76 5.433-1.14.836-.456 1.71-.95 2.546-1.406l.114-1.976a288.45 288.45 0 014.787-2.545c.912-.874 1.824-1.71 2.736-2.584a391.304 391.304 0 016.194-2.014c.532-.266 1.102-.57 1.633-.836l.114-1.596c1.71-.874 3.42-1.748 5.168-2.622 4.826-.38 9.651-.722 14.477-1.026 2.583-.569 5.129-1.139 7.713-1.709a624.102 624.102 0 018.929 3.571c3.496 2.508 9.499 2.242 9.727 2.242.114 0 .266 0 .38-.038.114.038.228.038.342.076 6.878 1.52 7.676 3.192 7.714 3.382l-.114 2.888c-.95.455-1.9.873-2.812 1.329a150.975 150.975 0 00-4.142-.19c-1.254.038-2.546.076-3.799.152v.228c1.557.456 3.153.912 4.711 1.368l3.458-.114c0-.38.038-.76.038-1.14 1.52-.722 3.04-1.405 4.521-2.127.608-.684 1.216-1.368 1.786-2.09.038-.646.038-1.254.076-1.9 1.368-.038 2.736-.076 4.104-.076 0-.19 0-.418.038-.608-2.28-.494-4.522-.988-6.802-1.482a519.326 519.326 0 00-8.245-2.128 429.02 429.02 0 00-6.307-2.583c-1.634-.646-2.356-1.368-2.128-2.128.304-1.026 2.318-1.71 2.546-1.748.304-.076.608-.19.912-.266 1.747.722 3.533 1.406 5.281 2.128.874-.038 1.748-.038 2.584-.076 2.052 1.026 4.104 2.052 6.155 3.115l5.7-.114c5.889-.114 8.093 2.28 8.397 3.572-.114 1.368-.19 2.736-.304 4.104.418.19.836.38 1.254.532l7.105-.114c.988.456 2.014.912 3.002 1.368-1.33.57-2.698 1.178-4.028 1.747 1.444.646 2.926 1.33 4.37 2.014.988-.418 1.976-.874 2.964-1.292-.114-1.102-.19-2.165-.304-3.267-1.14-.532-2.28-1.026-3.42-1.558 1.14-.646 2.242-1.254 3.382-1.9 1.406 0 2.812.038 4.217.038.95-.418 1.938-.798 2.888-1.216 1.634.038 3.268.038 4.864.076 1.368.646 2.736 1.292 4.065 1.938-.608.266-1.215.494-1.823.76v.456l.342.912c1.443.684 2.849 1.368 4.293 2.052-.038.683-.038 1.329-.076 2.013.874.532 1.748 1.064 2.584 1.596-.532.228-1.102.456-1.634.684.152.076.342.152.494.228.722-.304 1.406-.608 2.128-.874 2.622.304 5.243.646 7.865.988 1.33-.532 2.622-1.064 3.952-1.596 1.254.608 2.47 1.254 3.723 1.862 1.9.19 3.838.418 5.738.608-.038.532-.076 1.026-.076 1.558-.418.646-.874 1.33-1.292 1.976a3.9 3.9 0 001.33 0c.95-.152 1.672-.608 2.052-.95-.608-.418-1.52-1.102-1.482-1.862 0-.342.038-1.444 10.107-1.14.418 0 .836.038 1.254.038.266.988.494 2.014.76 3.002-.57 1.026-1.102 2.052-1.672 3.116 0 .759-.038 1.519-.038 2.241-.038 2.09-5.548 4.446-6.194 4.75-.114.038-.265.114-.379.152l-5.928-.342c-2.394-.266-4.75-.532-7.143-.798l-8.36-.342c-2.811-.304-5.623-.57-8.435-.836-2.888-.456-5.775-.912-8.701-1.368-3.078-.57-6.193-1.14-9.309-1.71-3.344-.038-6.65-.038-9.993 0-.038.798-.076 1.558-.076 2.356-1.824.836-3.61 1.672-5.396 2.508-2.09-.418-4.141-.798-6.231-1.216-2.622.038-5.244.114-7.827.19l-3.42-3.192-6.004-.342c-2.431.076-4.825.19-7.257.304a242.386 242.386 0 00-5.624-2.203 116.067 116.067 0 01-1.557-3.002l.228-4.788-3.99.228c-1.444.722-2.926 1.444-4.37 2.166-3.115.19-6.269.38-9.385.608l-7.067.228c-4.712.57-9.385 1.14-14.097 1.786-2.508.76-4.977 1.52-7.447 2.28a810.657 810.657 0 00-10.411 2.811c-2.052-.076-4.104-.114-6.156-.19-1.9.228-3.799.456-5.699.722-1.862.798-3.724 1.634-5.624 2.432-3.875 2.28-7.751 4.56-11.589 6.877-.076 1.102-.152 2.166-.19 3.268-1.367.95-2.735 1.862-4.065 2.812l-6.384 3.99c-2.355 1.177-4.673 2.393-7.029 3.571-2.508 2.356-4.978 4.674-7.447 7.068a737.96 737.96 0 00-9.69 9.195c-.152.988-.303 1.938-.455 2.925 1.101.836 2.165 1.71 3.267 2.546.038 1.748.038 3.458.076 5.206-1.71 1.824-3.419 3.609-5.129 5.433-.038 1.026-.114 2.09-.152 3.116.456.152.95.304 1.406.494-.228 1.406-.456 2.812-.646 4.218 1.064.38 2.089.722 3.115 1.101 1.786.874 3.534 1.71 5.32 2.584 1.824.646 3.648 1.33 5.433 1.976l1.14 3.42a1220.01 1220.01 0 0110.715 4.065c1.862.114 3.724.228 5.586.38 2.698-.228 5.357-.418 8.055-.608 2.052-.304 4.104-.646 6.156-.95a532.956 532.956 0 017.409-1.747l8.321-1.14 9.119-2.508c3.534-1.102 7.068-2.204 10.601-3.268 2.128-.228 4.256-.456 6.384-.646 7.219-.684 9.575 1.596 10.107 2.242.95.456 1.9.874 2.85 1.33 1.823-.494 3.647-.95 5.471-1.406 3.23.532 6.46 1.102 9.689 1.71-1.178.684-2.318 1.406-3.457 2.09.835-.076 1.709-.114 2.545-.19.95.608 1.862 1.216 2.812 1.862.19 1.254.418 2.507.608 3.723-1.406 1.71-2.774 3.42-4.18 5.13-.038 1.634-.076 3.23-.152 4.863a593.514 593.514 0 019.804 5.206c.835 1.254 1.633 2.508 2.469 3.762.494 1.253.988 2.545 1.482 3.799 1.14.95 2.318 1.938 3.458 2.888.95 1.634 1.9 3.268 2.812 4.902-.076 1.975-.152 3.951-.266 5.889a506.55 506.55 0 00-3.952 5.624c-.988 2.203-1.938 4.445-2.888 6.649a951.262 951.262 0 00-.19 10.411c1.824 1.102 3.648 2.166 5.472 3.268 1.254 2.393 2.508 4.825 3.761 7.257.836 2.66 1.634 5.32 2.432 7.979.266 3.8.494 7.562.76 11.361 3.344 2.204 6.612 4.446 9.879 6.688 1.064 1.862 2.09 3.723 3.154 5.585l-.114 5.7c1.026 1.064 2.28 2.089 3.496 3.115zm139.599-165.247c.646.076 1.292.19 1.938.266 2.166.456 4.332.912 6.497 1.406-.304.228-.646.456-.95.684-.228.152-.608.646-.228.912 1.254.798 3.762 2.432 3.762 2.432.418.266.836.532 1.254.836.722-.266 1.482-.494 2.242-.76 1.824-.456 3.609-.912 5.433-1.33 1.216-.38 2.394-.798 3.61-1.178h.304c.19 0 1.672.038 3.116.608-.228-.152-.494-.304-.722-.494v-.912l-2.052-.342c-.19.076-.38.114-.57.19.266.19.38.418.228.646-.418.57-1.444.266-4.294-.532-1.672-.494-3.343-.95-5.015-1.406a952.722 952.722 0 00-5.624-1.938c-1.026-.646-2.014-1.292-3.039-1.899a344.21 344.21 0 00-5.472-2.432v-1.444a271.917 271.917 0 00-4.37-2.698c-.76-.114-1.519-.19-2.279-.304-.532.38-1.064.722-1.634 1.102 2.204 1.33 4.369 2.698 6.535 4.028l1.14 3.305c.038.342.114.798.19 1.254zm2.736-22.266c-.19-.114-.38-.228-.532-.342-.684-.38-6.536-2.583-11.855-4.483-.114-.038-.228-.114-.342-.152l-5.699-3.306.797-.342s1.748-.722 1.748-1.748c0-.76 0-1.558.038-2.318a77.904 77.904 0 00-1.33-2.431 238.838 238.838 0 00-5.015-1.216c-1.292-.874-2.546-1.748-3.838-2.622l-1.14-1.254c-1.14-.608-2.28-1.254-3.381-1.862 2.583-.836 5.205-1.71 7.827-2.508 3.116-.379 6.269-.759 9.385-1.101a2.8 2.8 0 01.532.152c1.862.494 6.345 1.709 7.371 2.279.988.57 2.204 1.938 2.204 2.736 0 .342-.228.608-.684.722-1.026.304-3.989.038-6.079-.19l-1.026.684v1.406c.798.456 1.634.912 2.432 1.368 1.405.646 2.773 1.254 4.179 1.9 1.976.266 3.914.532 5.89.798 1.33 1.063 2.697 2.127 4.027 3.191v2.166c-.988-.152-1.937-.266-2.925-.418-.38.038-.76.038-1.14.076v1.216a664.368 664.368 0 016.915 4.142c-.152.76-.266 1.519-.418 2.317-1.254.38-2.47.76-3.723 1.178-1.406-.038-2.812-.038-4.218-.038zm-11.019-5.661c3.078 1.102 9.423 3.419 11.627 4.407h2.204c.835-.266 1.709-.532 2.545-.798.076-.455.152-.873.228-1.329-2.279-1.368-4.521-2.736-6.801-4.066v-2.47c1.178-.038 2.318-.076 3.496-.152.19.038.38.038.57.076v-.646c-.95-.76-1.862-1.482-2.812-2.242-1.786-.228-3.572-.494-5.358-.721l-5.015-2.28c-1.102-.646-2.204-1.254-3.344-1.9v-2.166c.722-.456 1.406-.95 2.128-1.406.266.038.494.076.76.114 2.204.266 4.559.456 5.053.38.038-.19-.912-1.444-1.596-1.824-.493-.266-3.267-1.064-5.813-1.748-2.736.304-5.509.646-8.245.988-1.862.608-3.686 1.178-5.51 1.786.684.38 1.33.76 1.976 1.14l1.178 1.292c1.026.684 2.052 1.368 3.04 2.09 1.862.456 3.761.912 5.623 1.406.608 1.102 1.178 2.241 1.786 3.343 0 .798 0 1.596-.038 2.394 0 .95-.95 1.672-1.672 2.09 1.406.722 2.698 1.482 3.99 2.242zm-41.758-9.879l-7.258-.57c-3.001-.57-6.041-1.102-9.043-1.634-2.394-.684-4.826-1.368-7.219-2.052-2.774-.152-5.51-.304-8.284-.418-1.025.38-2.013.798-3.039 1.178-2.09.152-4.218.342-6.308.532-2.431-.266-4.863-.494-7.257-.722-.304-.076-3.078-.798-3.762-1.976-.304-.57-.076-1.14.722-1.672.912-1.178 7.22-8.587 15.617-8.245.19 0 .38 0 .57.038 1.482.76 2.926 1.558 4.369 2.356.494.722 1.026 1.406 1.52 2.128 2.014.114 4.028.19 6.042.304l2.166-.798c-1.52-.76-3.002-1.482-4.522-2.242 4.522-.76 9.043-1.52 13.565-2.242.836 1.292 1.672 2.546 2.469 3.838-1.025.38-2.013.722-3.039 1.102.608.532 1.178 1.064 1.786 1.596 2.469.569 4.901 1.101 7.333 1.671 2.356.76 4.711 1.558 7.029 2.356 1.596.836 3.154 1.672 4.75 2.508-.95.684-1.938 1.406-2.888 2.09-1.748.304-3.534.608-5.319.874zm-6.726-1.672l6.118.456c1.368-.228 2.735-.418 4.065-.646.532-.38 1.026-.76 1.558-1.14-1.064-.57-2.166-1.14-3.23-1.71-2.127-.722-4.255-1.406-6.421-2.128-2.698-.608-5.396-1.254-8.093-1.824-1.064-.949-2.09-1.899-3.154-2.811 1.102-.418 2.204-.798 3.306-1.216-.38-.608-.76-1.216-1.178-1.786-2.508.418-5.054.798-7.561 1.216 1.291.646 2.583 1.292 3.875 1.9-1.596.608-3.23 1.178-4.825 1.786-3.002-.152-6.004-.342-9.006-.456-.684-.95-1.329-1.862-2.013-2.812-1.026-.532-2.09-1.064-3.116-1.596-5.472.114-10.905 5.471-12.577 7.637-.038.038-.114.076-.152.152-.456.266-.608.532-.456.798.266.494 1.596.95 2.242 1.14 2.014.19 4.065.38 6.079.57 1.71-.152 3.382-.304 5.092-.418 1.102-.418 2.204-.874 3.344-1.292 3.343.152 6.649.304 9.993.494l7.637 2.166c2.812.456 5.623.988 8.473 1.52zm88.038-37.275c-1.102-.722-2.166-1.444-3.267-2.166l2.279-.57c-.494-.684-.988-1.329-1.444-2.013 0-.57-.037-1.14-.037-1.71 1.291.228 2.583.456 3.875.646l3.306 1.14c1.292.912 2.584 1.823 3.838 2.735-.836.19-1.634.38-2.47.57-.076.38-.152.722-.228 1.102-1.292 0-2.622 0-3.914.038a16.83 16.83 0 01-1.938.228zm.152-1.52c.152.076.266.19.418.266h.19c.874 0 1.786-.038 2.66-.038.076-.304.114-.57.19-.874.532-.114 1.064-.266 1.596-.38-.722-.532-1.444-1.025-2.166-1.557-.798-.266-1.634-.57-2.432-.836-.152-.038-.342-.038-.494-.076v.608c.608.798 1.216 1.633 1.824 2.431-.608.152-1.178.304-1.786.456z",
    fill: "url(#prefix__paint266_linear_6821_29592)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.21 343.057a1.117 1.117 0 01-.3-.152c-3-2.584-6-5.168-9.01-7.713-1.97-3.42-3.99-6.878-6-10.259.08-1.216.15-2.47.23-3.686a777.352 777.352 0 00-22.42-25.192c.11-2.28.19-4.597.27-6.877a771.412 771.412 0 0116.41 11.285c.88 1.862 1.71 3.723 2.55 5.623 2.13 2.394 4.21 4.788 6.27 7.182 2.31 1.823 4.63 3.685 6.91 5.547.61 1.596 1.26 3.192 1.86 4.826 1.45.684 2.85 1.368 4.26 2.051-.04.836-.11 1.672-.15 2.508 1.29 1.558 2.58 3.154 3.84 4.712.64 3.04 1.29 6.041 1.93 9.043.04.19.12 1.9-1.59 2.318-1.14.266-2.85-.152-5.06-1.216zm-7.48-8.321a647.92 647.92 0 017.9 6.763c1.33.608 2.32.874 2.97.722.95-.228.91-1.254.91-1.254-.57-2.812-1.18-5.585-1.79-8.397-1.33-1.634-2.7-3.306-4.06-4.94.03-.532.07-1.064.07-1.558-1.18-.57-2.35-1.139-3.57-1.709-.68-1.786-1.37-3.572-2.05-5.396-2.17-1.786-4.37-3.534-6.54-5.281-2.28-2.66-4.56-5.282-6.87-7.904l-2.28-5.015a665.139 665.139 0 00-12.09-8.322c-.04 1.33-.11 2.66-.15 3.952 7.68 8.321 15.16 16.719 22.38 25.268-.08 1.292-.15 2.622-.23 3.913 1.86 3.04 3.65 6.118 5.4 9.158z",
    fill: "url(#prefix__paint267_linear_6821_29592)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.63 374.631c-2.24-1.33-4.48-2.622-6.72-3.952-1.71-1.633-3.46-3.229-5.21-4.825-2.73-1.938-5.51-3.876-8.24-5.814-2.36-1.482-4.75-2.963-7.11-4.445-6.57-3.8-10.33-6.384-11.06-7.714-.38-.722-1.55-2.925-.26-3.381 1.25-.418 3.8 1.254 4.79 1.976 3.34 1.709 6.65 3.419 9.99 5.205l2.16 2.85c.88-.152 1.75-.304 2.66-.456 2.47 1.33 4.91 2.66 7.38 3.99 1.74 2.355 3.45 4.711 5.16 7.067 2.36 1.33 4.68 2.66 7.03 3.989-.23 1.862-.42 3.686-.57 5.51zm-5.81-5.168c1.22.684 2.43 1.368 3.65 2.09.07-.684.11-1.33.19-2.014a749.605 749.605 0 00-5.66-3.191c-1.71-2.356-3.42-4.712-5.17-7.068a376.26 376.26 0 00-5.4-2.925c-1.21.19-2.47.418-3.68.608-1.03-1.368-2.05-2.736-3.08-4.066a739.51 739.51 0 00-9.54-4.978c-.87-.646-2.01-1.291-2.32-1.329.04.038 0 .342.61 1.481.8.874 5.44 3.762 9.31 6.004a515.86 515.86 0 017.26 4.521c2.92 2.052 5.85 4.104 8.74 6.156 1.71 1.558 3.38 3.116 5.09 4.711z",
    fill: "url(#prefix__paint268_linear_6821_29592)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.29 359.965c-.11-.076-.23-.152-.38-.266-1.6-1.329-3.19-2.621-4.79-3.951-3.91-2.204-7.83-4.37-11.78-6.498a594.358 594.358 0 00-7.52-9.841c-.87-2.584-1.79-5.167-2.7-7.751.08-1.368.15-2.736.23-4.142 1.14-.19 2.28-.342 3.42-.532 2.2 1.14 4.41 2.28 6.61 3.42.08-1.14.11-2.242.19-3.382 1.79.076 3.57.114 5.36.19 1.56-.228 3.08-.418 4.63-.646l5.25 2.85c1.06-1.102 2.13-2.166 3.19-3.268 2.54 1.406 5.09 2.812 7.64 4.256 1.52 1.976 3.04 3.914 4.56 5.89-.08 1.519-.16 3.077-.27 4.597-1.06.114-2.13.228-3.19.38l-.12 1.634c1.45 2.166 2.89 4.294 4.3 6.459-.08 1.216-.15 2.432-.23 3.61-1.48.19-2.93.342-4.41.532-.07.912-.11 1.824-.19 2.698-1.52.19-3.08.38-4.6.608.04 1.064-.07 3.495-1.86 3.951-.83.266-2.01 0-3.34-.798zm-15.81-11.817c3.8 2.052 7.56 4.18 11.36 6.308 1.6 1.292 3.2 2.622 4.79 3.914.57.304 1.03.417 1.41.304 1.21-.304 1.25-2.584 1.18-3.382 0-.152-.04-.304-.04-.456 1.56-.228 3.15-.418 4.75-.608.07-.912.11-1.786.19-2.698 1.48-.19 2.92-.38 4.4-.532.04-.76.12-1.558.16-2.318-1.41-2.165-2.85-4.293-4.3-6.459.08-.95.12-1.938.15-2.888 1.07-.114 2.13-.266 3.2-.38.07-1.064.11-2.166.19-3.229a195.572 195.572 0 00-3.23-4.142c-1.68-.95-3.39-1.9-5.06-2.812a197.899 197.899 0 01-3.23 3.268 618.13 618.13 0 00-5.85-3.192c-1.37.19-2.7.342-4.06.532-1.49-.076-3.01-.114-4.49-.152-.07 1.406-.15 2.774-.23 4.18-2.66-1.406-5.31-2.812-7.97-4.18-.65.114-1.3.19-1.94.304-.08 1.102-.12 2.204-.19 3.306.83 2.356 1.67 4.711 2.51 7.067 2.05 2.698 4.18 5.472 6.3 8.245z",
    fill: "url(#prefix__paint269_linear_6821_29592)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.57 280.475c-2.74-1.444-5.47-2.85-8.21-4.217.04-1.824.04-3.648.08-5.51 3.57 1.33 7.14 2.698 10.71 4.066 0 1.786-.04 3.571-.07 5.357-.84.114-1.67.19-2.51.304zm-5.78-4.445c1.64.835 3.23 1.671 4.87 2.507.34-.038.64-.076.99-.114 0-1.026.03-2.013.03-3.039-1.93-.76-3.91-1.482-5.85-2.204 0 .912-.04 1.862-.04 2.85z",
    fill: "url(#prefix__paint270_linear_6821_29592)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.36 290.924c-1.29-.722-2.58-1.406-3.91-2.089-.99-1.178-2.02-2.318-3.04-3.496v-2.774c.38-1.026.79-2.09 1.17-3.116 1.49-.114 3.01-.228 4.53-.342 1.02 1.178 2.05 2.356 3.11 3.534v2.698c.34 1.14.69 2.242 1.03 3.382.15.342 1.02 2.507-.19 2.925-.42.076-1.22.076-2.7-.722zm-2.93-3.039c.99.532 1.94 1.064 2.93 1.557.57.304.68.266.76.266.38-.114.15-1.139-.15-1.861a133.39 133.39 0 01-1.1-3.762v-2.166c-.23-.266-.5-.57-.73-.836-.76.076-1.55.114-2.31.19-.35.874-.69 1.748-1.03 2.622v2.052c.57.646 1.1 1.292 1.63 1.938z",
    fill: "url(#prefix__paint271_linear_6821_29592)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.25 280.515c-.26-.152-.53-.304-.8-.456l-1.71-3.42c-.87-1.026-1.74-2.014-2.62-3.002l-1.02-3.078c.49-.721 1.02-1.405 1.52-2.127 1.78 1.52 3.57 3.039 5.35 4.597.95 1.102 1.87 2.204 2.78 3.268.11.228 1.18 2.204 1.18 3.23 0 .494 0 1.026.03 1.52.16.417.19.835-.22 1.025-.65.304-2.13-.228-4.49-1.557zm-3-6.422l2.58 3.04c.38.798.8 1.558 1.18 2.356 1.45.76 1.75.722 1.75.722-.04-.076-.08-.152-.11-.228v-.114c0-.57 0-1.102-.04-1.672 0-.532-.61-1.786-.88-2.356-.76-.874-1.48-1.748-2.24-2.584-.8-.684-1.59-1.368-2.39-2.052-.19.228-.34.494-.53.722.22.76.45 1.444.68 2.166z",
    fill: "url(#prefix__paint272_linear_6821_29592)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.67 279.868c-.38-.228-.76-.456-1.18-.684 0-.646 0-1.292-.04-1.938-.49-.836-.99-1.672-1.48-2.47v-.494c-.72-.342-1.45-.722-2.17-1.064-1.44-.836-2.92-1.634-4.37-2.47-.23-1.025-.45-2.051-.68-3.077 1.71-.076 3.46-.152 5.17-.19 1.78 1.14 3.61 2.318 5.39 3.457.99.532 1.94 1.102 2.93 1.672 1.14-.038 2.31-.076 3.45-.076l5.4.342c.27-.798.53-1.596.76-2.393-.8-.95-1.63-1.9-2.43-2.812l-.12-3.8c1.37.798 2.7 1.596 4.07 2.394 1.63 1.33 3.31 2.66 4.94 3.99.57 1.367 1.14 2.773 1.71 4.141.49 1.026.99 2.052 1.48 3.04.38 1.178.76 2.356 1.14 3.572.53.911 1.03 1.823 1.52 2.735.04 1.33.08 2.698.08 4.028-.84 0-1.71.038-2.55.038-.15-.076-.3-.152-.42-.228 0 0-1.36-.76-3.49-2.052-1.18-.722-2.36-1.406-3.54-2.128-.72-.342-1.4-.722-2.12-1.064-.69 0-1.33.038-2.02.038-.15 1.102-.3 2.242-.42 3.344-1.14-1.406-2.31-2.812-3.45-4.217-.61-1.064-1.18-2.128-1.79-3.192-.84-.494-1.67-.988-2.51-1.444.46.532.92 1.064 1.37 1.596-.04.114-.08.19-.08.304-.22.76-.3 1.71-.15 2.052.19.228.38.456.57.646-.11.076-.23.152-.38.228-.3.227-.57.493-4.59-1.824zm-.35-4.104c.5.836.99 1.672 1.49 2.508v.836c.26.152.53.304.79.418-.07-.494-.07-1.102.12-1.938-.8-.95-1.6-1.862-2.43-2.812.68-.038 1.4-.038 2.09-.076 1.78 1.026 3.57 2.052 5.35 3.116.65 1.14 1.29 2.28 1.94 3.42.04-.266.08-.532.11-.76 1.03-.038 2.09-.038 3.12-.076 1.03.494 2.05 1.026 3.08 1.519 1.25.722 2.47 1.482 3.68 2.204 1.33.798 2.36 1.406 2.89 1.71.42 0 .88 0 1.29-.038-.03-1.026-.03-2.052-.07-3.116-.5-.874-.95-1.747-1.45-2.621-.38-1.178-.72-2.356-1.1-3.534-.49-.988-.99-1.976-1.44-2.964-.46-1.102-.91-2.242-1.41-3.343-1.21-.988-2.43-1.976-3.65-2.964-.38-.228-.76-.418-1.1-.646.04.608.04 1.254.08 1.862.87 1.026 1.75 2.014 2.62 3.039-.38 1.14-.72 2.242-1.1 3.382-1.98-.152-3.95-.266-5.97-.418l-4.06.114c-1.33-.76-2.7-1.558-4.03-2.318-1.48-.95-2.93-1.899-4.41-2.811l-3.53.114c.07.304.15.608.19.912.76.417 1.52.835 2.28 1.291 1.52.76 3.04 1.482 4.6 2.242 0 .57.03 1.14.03 1.748z",
    fill: "url(#prefix__paint273_linear_6821_29592)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.95 260.603c-.49-1.216-.95-2.431-1.44-3.647-.04-.684-.04-1.406-.08-2.09.72 0 1.45-.038 2.17-.038-1.26-1.406-2.51-2.812-3.8-4.18l-.12-2.584c1.87.988 3.73 1.976 5.59 2.964 1.18 1.292 2.36 2.622 3.53 3.914 1.75 1.406 3.5 2.85 5.21 4.255 1.52 1.026 3.08 2.052 4.6 3.04 1.1 1.254 2.2 2.546 3.3 3.8-.61.38-1.21.76-1.82 1.14h-3.88c-1.48-1.064-3-2.166-4.48-3.23l-1.71-1.938c-.38.038-.72.038-1.1.076.11.646.23 1.292.34 1.9a326.123 326.123 0 01-6.31-3.382zm.88-2.431c.26.683.53 1.329.79 2.013.69.38 1.33.722 2.02 1.102-.08-.342-.12-.684-.19-1.026l3.38-.228c.99 1.14 1.97 2.242 2.96 3.382.88.608 1.71 1.254 2.59 1.862h2.85c.3-.19.57-.38.87-.57-.53-.608-1.03-1.216-1.56-1.786-1.44-.95-2.85-1.938-4.29-2.888-1.98-1.633-3.95-3.267-5.93-4.901-.99-1.102-1.94-2.166-2.92-3.268-.8-.418-1.56-.836-2.36-1.254 0 .266.04.494.04.76 1.59 1.786 3.19 3.534 4.79 5.32-1.03 0-2.09.038-3.12.038.04.494.08.988.08 1.444z",
    fill: "url(#prefix__paint274_linear_6821_29592)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.11 542.73c-1.3-1.14-2.59-2.28-3.88-3.42-.68-1.748-1.33-3.534-2.01-5.282-3.16-2.735-6.35-5.395-9.54-8.055-.99-2.394-1.94-4.749-2.97-7.143.46-2.014.95-3.99 1.41-6.004l1.71-3.077c-.68-1.14-1.41-2.242-2.09-3.382-.8.114-1.6.266-2.39.38.38-1.748.76-3.496 1.1-5.244-.27-.19-.53-.418-.8-.608-1.03.152-2.09.342-3.11.532-.76-2.203-1.56-4.407-2.36-6.611.08-1.178.11-2.318.19-3.496a563.085 563.085 0 00-5.97-7.561c-.76-1.596-1.55-3.192-2.35-4.788-1.14-.38-2.32-.76-3.46-1.178-2.13-.987-4.29-1.937-6.42-2.887-1.79-.608-3.57-1.216-5.32-1.824a458.494 458.494 0 00-5.4-3.724c-1.52.152-3 .304-4.52.418-4.9-2.888-9.84-5.661-14.82-8.435l-5.01-1.14c-1.37-.418-2.7-.798-4.07-1.178-1.9-.798-3.8-1.634-5.7-2.394a403.891 403.891 0 00-5.35-3.267c-1.11-1.938-2.21-3.838-3.31-5.776v-2.356c.08-.38.23-1.405 6.42-2.203.31-1.292.61-2.622.88-3.914.72-4.56 1.4-9.157 2.05-13.717.64-2.432 1.29-4.863 1.93-7.295-.07-2.47-.19-4.902-.26-7.371 1.33-.266 2.66-.57 3.99-.836 3.3-.038 6.61-.076 9.92-.038 2.47.836 4.94 1.671 7.4 2.545 2.59 1.064 5.13 2.166 7.68 3.268 1.98.646 3.91 1.292 5.89 1.976.84-.874 1.67-1.71 2.47-2.584a263.64 263.64 0 003.38-3.23c1.56.988 3.08 1.976 4.64 3.002 4.06-.57 8.17-1.102 12.27-1.596 2.39.798 4.79 1.634 7.14 2.47.72 1.178 1.45 2.394 2.13 3.572 1.79 1.9 3.53 3.837 5.28 5.737.38.19 1.07.418 1.14-.19.23-1.786 1.79-3.837 1.86-3.951.08-.114.16-.19.23-.304 1.86.722 3.76 1.443 5.63 2.203 2.12.304 4.29.608 6.42.912 1.71 1.254 3.42 2.508 5.09 3.762a764.46 764.46 0 017.9 7.903c.95 1.748 1.94 3.496 2.89 5.244-1.6.456-3.19.912-4.75 1.406-.46.532-.91 1.026-1.37 1.558.57 1.633 1.14 3.229 1.71 4.863 1.45 1.9 2.89 3.8 4.33 5.738 1.11 2.089 2.17 4.179 3.23 6.269.69.646 1.33 1.254 2.02 1.9 1.21-.114 2.43-.19 3.64-.304 1.45-.19 2.85-.342 4.3-.532.34-2.204.68-4.446 1.02-6.649l2.4-4.332c1.29-.19 2.58-.342 3.91-.532 1.07 1.938 2.13 3.838 3.19 5.775.16 1.482.35 2.964.5 4.484a978.82 978.82 0 014.63 9.043c.19 2.85.34 5.7.46 8.549-.04.038-.04.114-.08.152-.49.912-.8 2.204-.68 2.698.57 1.178.34 2.926-.72 5.054.91 2.014 1.78 3.989 2.69 6.003.8 3.078 1.56 6.194 2.32 9.271.34 2.28.69 4.56.99 6.84.68 2.28 1.33 4.597 2.01 6.877 1.45 3.534 2.89 7.106 4.3 10.639-1.37 2.394-2.74 4.75-4.11 7.144l-1.71 7.637c-3.15 1.748-6.3 3.496-9.42 5.281-1.06.076-2.16.114-3.23.19-2.58-.836-5.13-1.671-7.71-2.469-1.83.19-3.69.342-5.51.532a59.73 59.73 0 01-.65 2.545c-.68.076-1.37.152-2.01.228-2.09.38-4.22.798-6.31 1.216-1.33-.038-2.66-.038-3.99-.076-1.56-1.406-3.11-2.85-4.63-4.255-1.64-.38-3.27-.798-4.91-1.178-1.29.228-2.54.418-3.79.57zm-2.51-4.826c.72.646 1.44 1.292 2.2 1.938 1.14-.152 2.28-.304 3.42-.418 1.86.418 3.72.874 5.55 1.33 1.48 1.33 3 2.698 4.48 4.065 1.07 0 2.13.038 3.16.076 2.5-.456 5.01-.911 7.52-1.367.19-.836.42-1.71.61-2.546 2.2-.228 4.4-.418 6.65-.608 2.58.798 5.13 1.596 7.71 2.432l2.74-.228c2.88-1.672 5.81-3.306 8.73-4.94.57-2.47 1.14-4.901 1.68-7.371 1.21-2.128 2.43-4.218 3.64-6.346-1.21-3.115-2.5-6.231-3.76-9.347-.72-2.546-1.44-5.091-2.2-7.599-.31-2.28-.65-4.522-.99-6.802-.72-2.963-1.48-5.927-2.24-8.891-1.03-2.318-2.09-4.597-3.15-6.877.07-.152.15-.266.22-.418.69-1.292 1.18-2.926 1.07-3.496-.72-1.558-.08-3.419.45-4.521-.11-2.432-.26-4.902-.41-7.372-1.52-3.001-3.04-6.003-4.6-8.967-.15-1.482-.34-2.964-.5-4.445-.45-.798-.91-1.634-1.33-2.432-.6.076-1.25.152-1.86.266-.72 1.292-1.44 2.583-2.16 3.913-.35 2.356-.69 4.75-1.07 7.106-1.67.19-3.34.38-4.98.608-1.52.114-3 .228-4.52.38-1.25-1.178-2.5-2.356-3.76-3.534-1.18-2.318-2.35-4.636-3.57-6.915-1.48-1.938-2.96-3.876-4.48-5.814-.8-2.242-1.6-4.522-2.4-6.763.72-.76 1.41-1.558 2.13-2.318 1.18-.342 2.36-.684 3.5-1.026-.42-.798-.88-1.558-1.3-2.356a558.43 558.43 0 00-7.22-7.219c-1.33-.988-2.66-1.976-3.99-2.926-2.05-.304-4.14-.646-6.19-.95-1.56-.608-3.15-1.254-4.71-1.862-.49.684-1.33 2.052-1.44 3.116-.27 1.976-2.47 1.178-3.61.494-.12-.076-.19-.114-.31-.19-2.09-2.356-4.22-4.674-6.34-7.029-.46-.76-.88-1.482-1.33-2.242-1.83-.646-3.65-1.254-5.51-1.9-4.14.532-8.29 1.102-12.43 1.748-1.37-.874-2.73-1.786-4.1-2.66-.87.836-1.75 1.672-2.66 2.508-.99 1.026-1.98 2.052-2.96 3.078-2.36-.798-4.68-1.596-7.03-2.356-2.59-1.102-5.13-2.204-7.72-3.306-2.35-.836-4.75-1.634-7.1-2.47-3.08 0-6.16.038-9.24.114-.98.19-1.97.418-2.92.608.07 2.204.15 4.408.23 6.612-.65 2.47-1.3 4.939-1.98 7.409-.65 4.598-1.37 9.157-2.09 13.717-.38 1.596-.72 3.192-1.1 4.825-.15 0-.27.038-.42.038-2.39.304-5.17.874-5.77 1.33v1.216c.76 1.33 1.52 2.66 2.28 3.952 1.44.874 2.88 1.748 4.29 2.622 1.75.721 3.46 1.443 5.2 2.165 1.3.38 2.55.722 3.84 1.102 1.83.418 3.65.836 5.47 1.292 4.79 2.622 9.54 5.32 14.29 8.093 1.52-.152 3.08-.304 4.6-.456 2.01 1.368 4.03 2.774 6.04 4.142 1.63.532 3.23 1.026 4.86 1.558 2.13.95 4.3 1.9 6.42 2.888 1.6.532 3.2 1.064 4.79 1.596 1.03 2.089 2.05 4.141 3.08 6.231 2.2 2.698 4.37 5.433 6.5 8.169-.08 1.406-.15 2.812-.23 4.18.34.95.68 1.938 1.03 2.888.6-.114 1.17-.19 1.78-.304 1.25.988 2.55 1.975 3.8 3.001-.19.988-.42 1.976-.65 3.002 1.37 2.166 2.74 4.37 4.07 6.536-.76 1.405-1.56 2.811-2.32 4.217-.34 1.596-.72 3.192-1.1 4.788.68 1.634 1.37 3.267 2.01 4.901 3.2 2.66 6.39 5.358 9.58 8.094.76 1.747 1.44 3.495 2.13 5.243z",
    fill: "url(#prefix__paint275_linear_6821_29592)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.61 552.911c-1.56-2.432-3.12-4.864-4.71-7.296.41-1.405.79-2.811 1.21-4.217.72-.684 1.48-1.33 2.2-2.014.42-1.216.84-2.432 1.3-3.648 1.63 1.368 3.26 2.774 4.86 4.18.04.646.08 1.33.08 1.976 2.28 1.976 4.56 3.989 6.8 6.003-.46 1.824-.95 3.686-1.45 5.51-1.25.114-2.5.19-3.76.304-.87.114-1.75.228-2.58.342-1.29-.418-2.62-.76-3.95-1.14zm-2.28-6.992c.98 1.482 1.93 2.964 2.88 4.484.95.266 1.87.494 2.82.76.72-.114 1.44-.228 2.2-.342.99-.076 1.98-.152 2.96-.266.19-.798.42-1.558.61-2.356a422.6 422.6 0 00-6.27-5.509c-.04-.646-.07-1.33-.07-1.976-.5-.418-.99-.874-1.49-1.292-.3.76-.57 1.52-.87 2.28-.72.646-1.44 1.33-2.2 1.976-.23.798-.42 1.519-.57 2.241z",
    fill: "url(#prefix__paint276_linear_6821_29592)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.44 616.479c.61-1.747 1.18-3.533 1.75-5.281.91-1.444 1.78-2.888 2.7-4.294 2.24.684 4.48 1.406 6.68 2.128 2.24 1.824 4.52 3.648 6.77 5.51l7.44-.456c4.18 2.013 8.36 4.103 12.54 6.269.99 1.178 1.98 2.394 2.97 3.61-.16 2.85-.35 5.737-.54 8.587-1.1.038-2.2.114-3.3.152-1.37-.988-2.78-1.976-4.14-2.964-1.37.152-2.7.342-4.07.494-1.14-.95-2.24-1.9-3.38-2.85-2.2-.797-4.41-1.557-6.61-2.317-.8.076-1.56.152-2.36.19-.76.456-1.48.912-2.24 1.33-1.22-.798-2.43-1.596-3.61-2.356-2.13-2.432-4.25-4.826-6.38-7.22-1.41-.228-2.81-.38-4.22-.532zm3.46-2.925a.678.678 0 00-.08.266c.34.038.65.076.99.114 2.32 2.545 4.6 5.129 6.88 7.751.8.494 1.63 1.026 2.43 1.52.64-.38 1.29-.76 1.97-1.14.95-.076 1.9-.114 2.85-.19 2.4.836 4.79 1.71 7.22 2.584.99.836 1.98 1.634 2.93 2.47 1.33-.152 2.62-.342 3.95-.494 1.41.987 2.81 1.975 4.22 3.001.61-.038 1.18-.076 1.78-.076.12-1.596.19-3.191.31-4.787-.5-.608-.99-1.178-1.48-1.786a553.718 553.718 0 00-11.71-5.738c-2.5.152-5.01.342-7.52.532a992.532 992.532 0 00-7.14-5.851c-1.79-.57-3.57-1.102-5.36-1.634-.8 1.178-1.52 2.318-2.24 3.458z",
    fill: "url(#prefix__paint277_linear_6821_29592)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.04 631.451c.34-1.026.65-2.014.99-3.04 1.14-.038 2.28-.076 3.42-.152.68-2.166 1.4-4.331 2.09-6.535l6.84 2.849c.64-2.013 1.25-4.027 1.86-6.041.53-2.508 1.06-5.054 1.56-7.561 1.25 1.52 2.5 3.077 3.76 4.635-.46 1.558-.91 3.116-1.41 4.636-.04 1.862-.07 3.686-.11 5.547.15.684.3 1.368.49 2.052.57 1.406 1.14 2.774 1.71 4.18.99 1.254 1.94 2.508 2.93 3.761-.53 1.634-1.07 3.268-1.6 4.902-.42.874-.83 1.786-1.25 2.66-1.29-.988-2.59-1.938-3.88-2.926-1.1-.076-2.16-.114-3.27-.19l-4.29.114c-1.79-1.33-3.61-2.66-5.43-3.99-1.52-1.595-2.97-3.267-4.41-4.901zm7.83-6.232c-.65 2.052-1.3 4.104-1.98 6.156l-3.04.114c.69.798 1.37 1.558 2.09 2.356 1.56 1.102 3.08 2.241 4.64 3.343l3.91-.114 3.88.342c.98.722 1.93 1.444 2.92 2.166.19-.418.42-.836.61-1.292.27-.836.53-1.672.8-2.508-.53-.683-1.07-1.367-1.6-2.089-.76-1.9-1.52-3.762-2.28-5.624-.23-1.102-.45-2.204-.68-3.344.04-1.785.07-3.571.11-5.357-.07.418-.19.798-.26 1.216a409.77 409.77 0 01-2.32 7.447c-2.28-.912-4.56-1.862-6.8-2.812zm10.18-9.613c-.04.266-.11.494-.15.76.04-.266.11-.532.15-.76z",
    fill: "url(#prefix__paint278_linear_6821_29592)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M1247.46 567.655c-1.9-2.204-3.84-4.37-5.78-6.535a849.116 849.116 0 00-4.52-16.567c.42-2.014.83-4.027 1.25-6.041 1.22 1.292 2.43 2.584 3.65 3.913 1.63 4.484 3.19 8.968 4.71 13.451.69 2.508 1.37 4.978 2.05 7.485-.45 1.406-.91 2.85-1.36 4.294zm-4.41-7.599c1.06 1.178 2.09 2.356 3.15 3.533.19-.569.38-1.139.57-1.747-.57-2.052-1.1-4.104-1.67-6.156a726.142 726.142 0 00-4.22-12.083c-.3-.342-.61-.684-.95-.988-.23 1.102-.45 2.204-.68 3.306 1.29 4.674 2.58 9.423 3.8 14.135z",
    fill: "url(#prefix__paint279_linear_6821_29592)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.16 558.534c-1.41-2.089-2.77-4.217-4.18-6.307-.45-2.85-.95-5.7-1.44-8.511.87-1.672 1.78-3.344 2.66-5.054.49 1.368.99 2.774 1.52 4.142l3.26.114c.54 1.52 1.07 3.039 1.64 4.559-.5 2.394-.99 4.788-1.48 7.182-.57 0-1.14-.038-1.71-.038-.12 1.33-.19 2.621-.27 3.913zm-2.54-6.611c.26.418.57.836.83 1.254.04-.494.08-1.026.08-1.52.6 0 1.25.038 1.86.038.38-1.824.76-3.648 1.14-5.51a2.333 2.333 0 00-.15-.418l-3.31-.114c-.23-.607-.42-1.177-.64-1.785-.31.57-.61 1.14-.92 1.709.42 2.166.76 4.256 1.11 6.346z",
    fill: "url(#prefix__paint280_linear_6821_29592)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.87 596.341a956.322 956.322 0 00-5.01-6.459c.53-2.204 1.02-4.408 1.56-6.65 1.21 1.52 2.39 3.04 3.61 4.56.22-1.026.45-2.052.68-3.04 2.24 3.002 4.48 6.042 6.73 9.081-.31 1.368-.65 2.736-.99 4.142-1.03-.456-2.05-.95-3.08-1.406-1.18-.076-2.36-.152-3.5-.228zm-2.77-6.307c.84 1.102 1.71 2.166 2.55 3.268l3.07.227c.76.342 1.49.684 2.25 1.026.07-.304.15-.608.22-.95-1.06-1.481-2.16-2.925-3.23-4.407-.22.988-.45 1.976-.68 2.964l-3.57-4.598a55.57 55.57 0 00-.61 2.47z",
    fill: "url(#prefix__paint281_linear_6821_29592)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.37 500.44c-1.79-1.9-3.61-3.8-5.44-5.7.08-.494.15-.95.19-1.444-.15-.836-.38-2.888.72-2.812 1.03.038 3.23 2.546 4.41 4.028.27.342.53.646.8.988-.23 1.672-.46 3.306-.68 4.94zm-3.27-5.586c.53.532 1.06 1.102 1.56 1.634.07-.456.11-.912.19-1.406-.84-.95-1.64-1.748-1.87-1.862-.03.038-.07.722.08 1.444.04.114.04.152.04.19z",
    fill: "url(#prefix__paint282_linear_6821_29592)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.31 518.296a562.556 562.556 0 00-5.28-5.927c.08-.494.15-.988.23-1.482-.15-.874-.34-2.926.72-2.85 1.03.076 3.12 2.66 4.3 4.18.26.342.53.684.76 1.026-.27 1.71-.5 3.381-.73 5.053zm-3.15-5.775c.49.57 1.03 1.14 1.52 1.71.08-.456.15-.95.19-1.406-.8-.988-1.6-1.824-1.82-1.938-.04.076-.08.76.07 1.482.04.038.04.114.04.152z",
    fill: "url(#prefix__paint283_linear_6821_29592)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M1293.78 489.496c-1.78-1.899-3.6-3.837-5.39-5.737.04-.456.11-.95.15-1.406-.15-.836-.45-2.812.61-2.736 1.03.114 3.19 2.584 4.37 4.066.26.342.53.646.8.988-.16 1.596-.35 3.192-.54 4.825zm-3.26-5.585c.53.532 1.02 1.102 1.55 1.672.04-.456.12-.912.16-1.368-.84-.988-1.64-1.748-1.87-1.862-.07.076-.03.798.12 1.406 0 .038.04.114.04.152z",
    fill: "url(#prefix__paint284_linear_6821_29592)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.11 441.469c-1.9-1.748-3.84-3.458-5.78-5.205.04-.456.08-.912.11-1.368-.18-.798-.56-2.66.57-2.622 1.07.038 3.39 2.318 4.64 3.686.27.304.57.608.84.912-.08 1.519-.23 3.039-.38 4.597zm-3.58-5.167c.57.494 1.11.988 1.68 1.482.03-.418.07-.874.11-1.292-.91-.874-1.75-1.596-1.98-1.71-.03.076-.03.684.16 1.33.03.114.03.152.03.19z",
    fill: "url(#prefix__paint285_linear_6821_29592)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M1304.76 575.9c-1.64-2.09-3.31-4.179-4.98-6.269.11-.532.23-1.026.3-1.558-.07-.912-.15-3.116.91-3.04 1.03.076 3.01 2.812 4.11 4.446.23.342.49.722.72 1.064-.34 1.786-.68 3.571-1.06 5.357zm-2.82-6.155c.5.608.95 1.216 1.45 1.824.11-.494.19-.988.3-1.482-.76-1.064-1.48-1.938-1.71-2.052-.07.076-.11.798-.04 1.596v.114z",
    fill: "url(#prefix__paint286_linear_6821_29592)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.73 624.003c-1.56-2.204-3.08-4.408-4.64-6.612.15-.532.27-1.102.42-1.634-.04-.95 0-3.267 1.1-3.153 1.03.114 2.89 3.001 3.88 4.711.23.38.45.76.64 1.14-.45 1.824-.91 3.686-1.4 5.548zm-2.47-6.46c.45.646.91 1.292 1.37 1.9.11-.532.26-1.026.38-1.558-.73-1.14-1.41-2.052-1.64-2.166-.07.076-.15.836-.11 1.634v.19z",
    fill: "url(#prefix__paint287_linear_6821_29592)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M1303.88 631.414c-1.55-2.204-3.07-4.408-4.63-6.574.45-1.748.91-3.457 1.37-5.205 1.59 2.052 3.19 4.103 4.78 6.155-.53 1.862-1.02 3.724-1.52 5.624zm-2.39-6.422c.46.608.87 1.254 1.33 1.862.11-.38.19-.76.3-1.14-.45-.57-.91-1.178-1.36-1.748-.12.342-.19.684-.27 1.026z",
    fill: "url(#prefix__paint288_linear_6821_29592)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.42 625.752c-1.4-2.014-2.81-3.99-4.21-6.004.6-1.9 1.21-3.799 1.82-5.699 1.29 1.482 2.58 2.964 3.88 4.445.64 2.508 1.25 5.016 1.86 7.562-1.1-.114-2.21-.19-3.35-.304zm-1.86-5.662c.57.836 1.18 1.672 1.75 2.508l1.14.114c-.23-.912-.46-1.824-.68-2.736-.54-.608-1.07-1.216-1.6-1.824-.19.646-.42 1.292-.61 1.938z",
    fill: "url(#prefix__paint289_linear_6821_29592)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.54 623.51a674.91 674.91 0 00-5.55-7.941c.49-.342.99-.684 1.48-1.026.23-.988.46-1.938.68-2.926 1.64 1.786 3.31 3.61 4.94 5.434-.53 2.166-1.02 4.293-1.55 6.459zm-2.47-6.421c.45.608.87 1.254 1.33 1.862.15-.57.26-1.14.41-1.71-.45-.532-.91-1.026-1.4-1.558l-.34 1.406z",
    fill: "url(#prefix__paint290_linear_6821_29592)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.19 374.025c-2.28-2.128-4.6-4.218-6.88-6.346.38-.987.72-2.013 1.1-3.001 2.05 1.406 4.07 2.773 6.12 4.179-.12 1.748-.23 3.458-.34 5.168zm-4.26-5.738c.72.646 1.41 1.292 2.13 1.938.04-.418.04-.836.07-1.254-.64-.456-1.33-.912-1.97-1.368a7.13 7.13 0 01-.23.684z",
    fill: "url(#prefix__paint291_linear_6821_29592)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.8 512.522l-2.97-3.534a412.03 412.03 0 00-2.39-5.054c-1.56-1.557-3.12-3.077-4.67-4.635.26-1.634.53-3.306.8-4.94 1.48 1.444 2.96 2.888 4.44 4.37 1.22-.912 2.43-1.786 3.69-2.698.72 3.648 1.4 7.296 2.05 10.905-.31 1.824-.61 3.724-.95 5.586zm-1.79-4.56c.08.076.15.19.23.266.19-1.026.34-2.09.53-3.116-.3-1.557-.61-3.115-.91-4.673-.65.456-1.29.95-1.9 1.406-1.22-1.216-2.43-2.432-3.65-3.648-.07.342-.11.722-.19 1.064 1.14 1.14 2.28 2.242 3.38 3.382.84 1.785 1.68 3.533 2.51 5.319z",
    fill: "url(#prefix__paint292_linear_6821_29592)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.03 478.781c-.11-.114-.22-.228-.3-.342-2.05-2.622-4.1-5.243-6.19-7.827-1.22-1.102-2.47-2.166-3.69-3.23a320.462 320.462 0 00-3.15-5.775c-1.87-3.762-3.8-7.562-5.74-11.323-.57-.836-1.14-1.672-1.71-2.47-.84-.152-1.63-.342-2.47-.494-.11.95-.27 1.938-.38 2.888-3.57-2.964-7.18-5.89-10.79-8.778-1.48-1.975-2.93-3.951-4.41-5.927a518.452 518.452 0 00-8.43-7.561c.22-1.862.45-3.762.64-5.624 1.07.798 2.09 1.596 3.16 2.394.07-.646.15-1.254.22-1.9.04-.38-.64-1.786-1.25-2.812-.91-1.595-1.86-3.191-2.77-4.787-1.75-1.976-3.54-3.914-5.29-5.852-1.93-1.71-3.91-3.419-5.89-5.129-1.59-1.14-3.23-2.28-4.82-3.42.91-1.254 1.86-2.508 2.77-3.762-1.06-1.063-2.16-2.127-3.23-3.191-1.02-2.09-2.05-4.218-3.07-6.308.91-.076 1.82-.114 2.73-.19l6.27 3.876c1.37 1.976 2.7 3.952 4.07 5.927.53 1.824 1.06 3.648 1.59 5.434.5.38 1.03.722 1.52 1.102 2.7.304 5.4.646 8.1.988 1.63 1.216 3.26 2.432 4.9 3.647 1.74 2.28 3.49 4.56 5.2 6.84 1.9 2.204 3.76 4.407 5.63 6.611 2.05 2.09 4.06 4.142 6.08 6.232 1.63 2.09 3.26 4.179 4.9 6.307 1.55 2.318 3.07 4.636 4.63 6.992 1.37 2.317 2.78 4.635 4.11 6.953-.19 1.672-.42 3.306-.65 4.977.19 1.786.38 3.534.57 5.32.95 1.938 1.94 3.876 2.89 5.813a427.85 427.85 0 014.56 8.322c.8 1.824 1.59 3.647 2.35 5.471.04.152.19 1.368-.53 1.596-.42.076-1.02 0-2.13-.988zm-9.19-12.653l3.42 3.078c2.09 2.584 4.14 5.205 6.19 7.789.04.038.08.038.08.076-.65-1.444-1.26-2.849-1.9-4.293-1.48-2.774-3-5.51-4.56-8.246-1.1-2.241-2.21-4.445-3.31-6.687-.23-2.09-.45-4.218-.68-6.307.19-1.406.34-2.812.53-4.218-1.1-1.9-2.2-3.762-3.34-5.662-1.49-2.241-2.97-4.483-4.45-6.725-1.56-2.014-3.11-4.028-4.67-6.003a906.204 906.204 0 00-5.93-6.08c-1.98-2.318-3.91-4.635-5.93-6.953-1.59-2.128-3.23-4.218-4.86-6.346-1.18-.874-2.36-1.786-3.54-2.659-2.69-.342-5.39-.684-8.09-.988a312.7 312.7 0 00-3.8-2.736c-.61-2.128-1.21-4.256-1.86-6.422-.99-1.443-1.98-2.887-2.96-4.331-1.52-.95-3.01-1.862-4.53-2.774-.22 0-.49.038-.72.038.61 1.216 1.18 2.432 1.75 3.648 1.52 1.52 3.08 3.002 4.6 4.521-.8 1.102-1.64 2.204-2.43 3.306.64.456 1.29.912 1.93 1.368a448.87 448.87 0 016.43 5.623c1.97 2.204 3.99 4.446 5.92 6.65.95 1.634 1.9 3.268 2.85 4.939.31.456 1.98 3.23 1.83 4.674-.16 1.254-.27 2.47-.42 3.724-1.03-.798-2.09-1.596-3.12-2.394-.07.722-.19 1.482-.26 2.204 2.39 2.127 4.75 4.293 7.14 6.459 1.37 1.862 2.77 3.686 4.14 5.548 2.74 2.165 5.44 4.369 8.13 6.573.08-.646.19-1.33.27-1.976 1.56.304 3.12.646 4.67.95 1.03 1.52 2.09 3.04 3.12 4.522 1.94 3.799 3.87 7.561 5.77 11.361.88 1.596 1.75 3.153 2.59 4.749z",
    fill: "url(#prefix__paint293_linear_6821_29592)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.54 463.355c-1.52-1.329-3-2.659-4.52-3.989-.95-2.432-1.86-4.902-2.85-7.334 2.05 1.254 4.06 2.508 6.08 3.762 1.18 0 2.35-.038 3.53-.038 1.06.228 2.17.418 3.23.646-.53-1.102-1.1-2.204-1.67-3.306-1.64-2.127-3.27-4.255-4.9-6.345 1.29 0 2.54 0 3.83-.038l4.03 4.142c1.1 2.203 2.21 4.407 3.31 6.611.68 1.596 1.37 3.192 2.05 4.788l-1.71 2.963c-1.9 0-3.84-.038-5.74-.038-1.52-.608-3.11-1.216-4.67-1.824zm-3.19-4.901c.99.874 1.94 1.71 2.92 2.584l4.11 1.595c1.63 0 3.26-.038 4.9-.038l1.14-1.937c-.46-1.102-.95-2.204-1.41-3.344-.91-1.862-1.86-3.724-2.81-5.586-.76-.798-1.56-1.595-2.36-2.393h-.57c.88 1.178 1.75 2.355 2.63 3.533 1.1 2.204 2.2 4.37 3.3 6.574-1.75-.38-3.46-.722-5.2-1.064-1.3 0-2.59.038-3.84.038-1.22-.76-2.43-1.52-3.69-2.28.27.76.57 1.52.88 2.318z",
    fill: "url(#prefix__paint294_linear_6821_29592)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M1232.53 492.193c-1.41-1.368-2.81-2.736-4.26-4.066.27-1.824.57-3.648.84-5.51-.61-.57-1.22-1.139-1.82-1.709-1.07-2.356-2.17-4.674-3.27-6.992.15-1.026.3-2.052.42-3.078.11-1.975.22-3.989.3-5.965 1.9 3.914 3.76 7.865 5.62 11.817 1.11 1.026 2.17 2.052 3.27 3.078.76 1.634 1.48 3.267 2.24 4.901-.42 2.66-.83 5.32-1.29 7.942-.68-.152-1.37-.266-2.05-.418zm-1.94-4.066c.5.494 1.03.988 1.52 1.444.19.038.42.076.61.114.34-2.09.68-4.18.99-6.232-.38-.874-.8-1.747-1.22-2.621-1.1-1.026-2.16-2.052-3.27-3.078-.91-1.938-1.78-3.876-2.69-5.776 0 .228-.04.456-.04.684-.12.798-.23 1.596-.34 2.394.76 1.596 1.48 3.192 2.2 4.788 1.03.95 2.01 1.899 3 2.849-.19 1.786-.45 3.61-.76 5.434z",
    fill: "url(#prefix__paint295_linear_6821_29592)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.04 498.728a518.858 518.858 0 00-4.71-4.636c0-.722 0-1.482-.04-2.204-.34-.798-.72-1.634-1.06-2.432.19-1.177.34-2.393.53-3.571 1.63 1.444 3.23 2.85 4.86 4.293.31 1.9.57 3.8.84 5.7-.11.95-.27 1.9-.42 2.85zm-2.7-4.902c.35.342.69.646 1.03.988.04-.228.08-.494.11-.722-.15-1.064-.34-2.166-.49-3.23-.49-.418-.95-.836-1.44-1.292-.04.342-.12.684-.16.988.31.722.65 1.482.95 2.204v1.064z",
    fill: "url(#prefix__paint296_linear_6821_29592)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.01 381.965c-1.78-1.064-3.61-2.166-5.39-3.23-.23-2.09-.5-4.217-.72-6.307 4.14 2.621 8.28 5.319 12.38 8.017-2.13.494-4.22.988-6.27 1.52zm-3.27-3.8c.8.456 1.6.95 2.4 1.406.72-.19 1.44-.342 2.16-.532-1.59-1.026-3.19-2.052-4.78-3.078.03.722.15 1.444.22 2.204z",
    fill: "url(#prefix__paint297_linear_6821_29592)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.16 390.02c-2.09-2.85-4.18-5.7-6.31-8.549a393.89 393.89 0 018.59 5.243c1.21 1.786 2.39 3.572 3.57 5.396-1.94-.684-3.88-1.368-5.85-2.09zm-.19-2.926c.3.418.61.836.91 1.254.3.114.65.228.95.342-.15-.266-.34-.494-.49-.76-.46-.304-.92-.57-1.37-.836z",
    fill: "url(#prefix__paint298_linear_6821_29592)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.31 391.35c-2.66-1.672-5.28-3.344-7.98-4.978.12-1.329.27-2.659.38-3.989 2.02 1.064 4.03 2.09 6.05 3.154 1.89 1.747 3.76 3.495 5.66 5.243l-4.11.57zm-5.47-5.32c1.56.988 3.16 1.938 4.71 2.926.19-.038.42-.038.61-.076-.61-.57-1.21-1.14-1.82-1.71l-3.42-1.823c-.04.266-.08.455-.08.683z",
    fill: "url(#prefix__paint299_linear_6821_29592)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.24 402.18c-2.51-1.861-5.02-3.723-7.53-5.547.16-1.368.31-2.736.42-4.104 2.43.532 4.83 1.064 7.26 1.596 2.77 1.406 5.55 2.812 8.32 4.256.99 1.558 1.98 3.115 2.93 4.711-2.17-.722-4.34-1.444-6.54-2.127l-1.71-1.14c-1.06.114-2.13.266-3.19.38 0 .646 0 1.329.04 1.975zm-5.06-5.699c.92.684 1.83 1.368 2.74 2.014v-.532c1.6-.19 3.15-.38 4.75-.57.8.532 1.6 1.064 2.39 1.596.92.266 1.79.57 2.7.836l-.04-.038c-2.31-1.216-4.63-2.394-6.91-3.572-1.83-.38-3.65-.798-5.47-1.178-.08.494-.12.988-.16 1.444z",
    fill: "url(#prefix__paint300_linear_6821_29592)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.66 378.356a604.397 604.397 0 00-10.33-6.27c.57-1.633 1.14-3.305 1.71-4.977-.65-.912-1.3-1.824-1.94-2.736 1.02-1.292 2.01-2.584 3.04-3.876.98.114 1.97.266 2.96.38.15-1.595.27-3.191.42-4.787.72-.988 1.44-1.938 2.16-2.926 1.33.532 2.66 1.102 3.99 1.672 2.47 1.33 4.98 2.698 7.45 4.066 1.98 1.215 3.95 2.431 5.89 3.647 1.71.456 3.46.874 5.21 1.33-.42 1.292-.84 2.584-1.3 3.876-.83.076-1.67.152-2.5.266a.602.602 0 01-.38.418c-.31.076-.84.076-1.83-.57-1.29-.836-5.32-3.8-5.81-4.142-.11-.076-.23-.19-.38-.266l-1.41-1.976c-1.33-.342-2.69-.684-4.02-1.026-.38.038-.8.076-1.18.152.34.456.68.95.99 1.406 1.44.874 2.92 1.786 4.37 2.66 1.93 1.368 3.83 2.736 5.77 4.142-2.2.228-4.41.456-6.61.722.99 1.405 1.94 2.811 2.93 4.255-.12 1.52-.27 3.002-.38 4.522-.76.076-1.52.19-2.25.266-1.48-.95-2.96-1.862-4.44-2.774.11-1.216.23-2.47.3-3.686-.72-.76-1.44-1.52-2.16-2.241-.88.114-1.75.228-2.59.304.31.417.57.835.88 1.253.49 2.28.98 4.598 1.44 6.916zm-7.45-6.384c1.56.912 3.08 1.862 4.64 2.812-.27-1.254-.53-2.508-.8-3.762-.65-.949-1.33-1.899-1.98-2.849 1.87-.228 3.77-.456 5.63-.684 1.59 1.672 3.23 3.343 4.82 5.015-.07.988-.15 2.014-.26 3.002.38.266.8.494 1.18.76.26-.038.53-.076.83-.114.08-1.026.19-2.052.27-3.078-1.26-1.862-2.55-3.685-3.84-5.509 1.6-.19 3.19-.38 4.79-.532-.31-.228-.65-.456-.95-.684a376.871 376.871 0 00-5.17-3.154c-1.06-1.482-2.13-3.002-3.23-4.483 1.14-.114 2.24-.228 3.38-.342 1.9.456 3.84.95 5.74 1.443.68.95 1.33 1.9 2.01 2.812 1.26.912 3.73 2.698 4.79 3.458 0-.038 0-.076-.04-.114.95-.114 1.9-.19 2.81-.304.08-.228.16-.418.19-.646-.53-.152-1.06-.266-1.59-.418-2.13-1.33-4.22-2.622-6.35-3.952-2.39-1.329-4.75-2.621-7.14-3.951-.84-.342-1.71-.684-2.55-1.064-.53.722-1.1 1.444-1.63 2.204-.11 1.785-.27 3.571-.38 5.357-1.14-.152-2.24-.304-3.38-.418-.72.912-1.45 1.862-2.17 2.774.57.836 1.18 1.634 1.75 2.47-.46 1.292-.91 2.621-1.37 3.951z",
    fill: "url(#prefix__paint301_linear_6821_29592)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.95 380.18a842.918 842.918 0 00-9.61-6.65l4.98-.456c-.15-2.052-.31-4.141-.46-6.193l.8.228c.27.076 2.81.912 4.33 1.9 2.32 1.52 2.32 4.293 2.24 5.129v.228c-.49.304-.98.608-1.48.912a40.94 40.94 0 01-.19 2.204c-.19.912-.38 1.824-.61 2.698zm-4.21-4.75c.76.532 1.55 1.064 2.31 1.596.08-.38.19-.76.27-1.14.08-.874.11-1.71.19-2.584.49-.304.99-.608 1.48-.912 0-.646-.11-1.444-.26-1.823-.65-.38-1.64-.798-2.44-1.064.16 1.899.27 3.837.38 5.737-.64.076-1.29.114-1.93.19z",
    fill: "url(#prefix__paint302_linear_6821_29592)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.02 391.123c-.95-1.52-1.94-3.001-2.89-4.483.11-1.102.19-2.204.3-3.306 2.36 1.596 4.68 3.192 7.03 4.788 1.75 1.861 3.46 3.723 5.17 5.623-1.33.304-2.66.608-3.99.95a276.155 276.155 0 00-5.62-3.572zm-.57-3.685c.53.836 1.06 1.671 1.63 2.507 1.22.76 2.39 1.52 3.61 2.28.42-.114.87-.19 1.29-.304-.8-.874-1.59-1.748-2.43-2.622a254.91 254.91 0 00-4.03-2.697c0 .266-.04.532-.07.836z",
    fill: "url(#prefix__paint303_linear_6821_29592)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.16 328.656c-2.32-1.482-4.63-2.926-6.95-4.408-.08-.19-.15-.418-.23-.608-.04-.114-1.1-3.115 1.29-3.381 1.9-.228 5.74-.038 5.89-.038.27 0 .57.038.84.038.87 1.064 1.71 2.166 2.58 3.229-.07.874-.15 1.71-.23 2.584-1.02.874-2.09 1.71-3.19 2.584zm-5.01-4.826c1.21.76 2.47 1.558 3.68 2.318.76-.608 1.56-1.254 2.32-1.862.04-.494.04-.988.08-1.482-.16-.19-.31-.379-.46-.569-1.22-.038-3.53-.076-4.83.075-.83.076-.87.95-.79 1.52z",
    fill: "url(#prefix__paint304_linear_6821_29592)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.25 324.971a778.427 778.427 0 00-6.27-5.433c-.04-1.406-.11-2.812-.15-4.218-.91-1.786-1.79-3.534-2.7-5.32-.46-1.975-.87-3.951-1.33-5.927 1.14-1.71 2.28-3.42 3.46-5.13 2.51 2.09 4.98 4.218 7.45 6.308.19 1.634.38 3.306.53 4.939-.57 1.026-1.1 2.014-1.67 3.04.95 1.178 1.9 2.394 2.85 3.572 1.86 1.254 3.68 2.546 5.54 3.799.65 1.444 1.29 2.888 1.94 4.332-.04.95-.08 1.9-.11 2.85-1.68-1.026-3.35-2.014-5.02-3.04-1.1-1.026-2.24-2.014-3.38-3.04-.42-.266-.87-.494-1.29-.76.04 1.368.11 2.698.15 4.028zm-3.95-5.205c.49.417.99.873 1.52 1.291-.04-1.026-.12-2.051-.15-3.077 1.52.874 3.04 1.785 4.52 2.659 1.14.988 2.24 2.014 3.38 3.04.64.38 1.29.76 1.94 1.14 0-.38.03-.722.03-1.102-.41-.874-.83-1.786-1.25-2.66-1.67-1.178-3.38-2.317-5.05-3.457-1.45-1.786-2.89-3.61-4.33-5.396.64-1.178 1.29-2.318 1.93-3.496-.15-1.215-.26-2.469-.41-3.685-1.26-1.064-2.51-2.128-3.77-3.192-.83 1.216-1.63 2.432-2.47 3.648.42 1.786.84 3.571 1.22 5.395.91 1.824 1.82 3.686 2.74 5.51.07 1.102.11 2.242.15 3.382z",
    fill: "url(#prefix__paint305_linear_6821_29592)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.98 353.125a336.45 336.45 0 00-4.86-3.002c-1.22-2.279-2.43-4.559-3.65-6.839-1.9-1.14-3.76-2.28-5.66-3.382.34-1.406.72-2.811 1.06-4.179 1.94 1.14 3.92 2.317 5.86 3.495l7.98-.456c.26.342.53.722.76 1.102 4.59 6.422 4.52 7.258 4.52 7.524a560.66 560.66 0 00-.23 4.103c-.15.798-.31 1.596-.46 2.394-1.78-.266-3.53-.532-5.32-.76zm-3.45-3.838c.95.57 1.9 1.178 2.85 1.786 1.25.152 2.5.342 3.76.494.11-.532.22-1.102.3-1.634.08-1.33.15-2.659.19-4.027-.15-.418-1.63-2.736-3.15-4.94-2.32.114-4.6.266-6.92.38-1.56-.95-3.15-1.9-4.71-2.85-.11.456-.23.874-.34 1.33 1.44.874 2.89 1.748 4.33 2.584 1.25 2.318 2.47 4.598 3.69 6.877z",
    fill: "url(#prefix__paint306_linear_6821_29592)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.01 338.573c-1.33-1.748-2.66-3.534-3.99-5.281.04-.532.04-1.064.08-1.634-.88-1.14-1.71-2.242-2.58-3.382-.57-.836-1.11-1.71-1.68-2.546.31-.874.61-1.71.95-2.584 1.26.722 2.55 1.482 3.8 2.204l1.71-.342c1.18.684 2.36 1.368 3.5 2.052-.5.76-.99 1.52-1.48 2.28-.27.038-.54.038-.76.076-.08.304-.16.646-.23.95.34.456.72.95 1.06 1.406.65.57 2.17 2.052 2.09 3.115-.04.836-1.37 2.394-1.78 2.85-.23.304-.46.57-.69.836zm-1.63-4.559c.26.379.57.721.83 1.101.5-.646.92-1.329.95-1.557-.03-.152-.53-.646-.83-.912-.08-.076-.19-.152-.27-.228-.72-.95-1.48-1.938-2.2-2.888.15-.684.3-1.406.49-2.09-.87-.532-1.78-1.026-2.66-1.558-.11.304-.22.608-.34.912.34.494.65.988.99 1.482 1.06 1.368 2.09 2.736 3.15 4.104-.07.532-.11 1.102-.11 1.634z",
    fill: "url(#prefix__paint307_linear_6821_29592)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.43 336.217c.08-1.52.12-3.04.19-4.56-1.18-1.558-2.35-3.078-3.53-4.636 2.96 1.406 5.89 2.85 8.85 4.294 1.29 1.672 2.55 3.382 3.8 5.054h-3.38c-.34.57-.68 1.178-1.03 1.747-1.59-.607-3.23-1.253-4.9-1.899zm1.48-5.206c.35.456.73.95 1.07 1.406l-.12 3.04c.23.076.46.19.69.266.26-.494.57-.95.83-1.444h2.02c-.42-.57-.88-1.178-1.29-1.748-1.07-.494-2.13-.988-3.2-1.52z",
    fill: "url(#prefix__paint308_linear_6821_29592)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M188.137 189.094l35.261-71.852 48.445 109.392-83.706-37.54z",
    stroke: "url(#prefix__paint309_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M431.536 144.675L356.189 92.43l26.104 147.274 49.243-95.029z",
    stroke: "url(#prefix__paint310_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M431.541 144.674l159.585-98.639 190.743 31.347-248.422 70.332",
    stroke: "url(#prefix__paint311_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M610.234 227.204l-76.791-79.488 171.403 28.839-94.612-93.282v143.931z",
    stroke: "url(#prefix__paint312_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.37 130.312L887.88 310.568l-157.609 87.088L753.98 292.52l-143.741-65.316v116.687l-105.098-59.427-89.71 33.095-97.385 13.071-101.375-30.131-76.221-32.373 47.685-79.033 35.261-71.852 158.902 122.463-110.456-13.07-55.171 73.865-28.536-111.406L356.194 92.43 140.45 268.126",
    stroke: "url(#prefix__paint313_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M431.542 144.676l101.906 3.04-151.15 91.989 122.843 44.76-73.599-139.789zm0 0l-159.7 81.958",
    stroke: "url(#prefix__paint314_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M591.122 46.037l-57.679 101.679",
    stroke: "url(#prefix__paint315_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M696.296 4.24l-86.062 222.964",
    stroke: "url(#prefix__paint316_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M704.845 176.555L870.472 40.603l154.988 131.355-243.596-94.574 88.608-36.78 51.372 147.73-311.61-105.06",
    stroke: "url(#prefix__paint317_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M921.845 188.334l103.615-84.162 92.45 99.551-92.45-31.765 101.91-41.644 74.02 171.554-279.545-113.534z",
    stroke: "url(#prefix__paint318_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M870.475 40.603L753.978 292.52l133.9 18.049 137.582-138.612 51.41 144.729-155.023-128.352L753.978 292.52l-49.13-115.965-94.611 50.649 171.63-149.82L696.299 4.24l-88.722 81.237",
    stroke: "url(#prefix__paint319_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.46 104.172l-320.613 72.384 183.03 134.014L781.866 77.385",
    stroke: "url(#prefix__paint320_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M704.845 176.555l-94.611 167.337 143.741-51.372",
    stroke: "url(#prefix__paint321_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M730.268 397.657l-120.031-53.765-169.199 77.285 64.1-136.712",
    stroke: "url(#prefix__paint322_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M111.036 385.46l118.929 21.772 88.076-76.601 122.995 90.545-25.609-103.616-33.133-77.855-165.628 60.794-105.63 84.961zm0 0l29.409-117.334-11.779-112.888-12.387 71.396 71.852-37.541",
    stroke: "url(#prefix__paint323_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M216.662 300.5l13.298 106.732 211.071 13.945",
    stroke: "url(#prefix__paint324_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.9 203.722l127.9-27.167-44.42 125.312-124.52 14.819 103.62 56.577-62.58-169.541zm0 0L887.869 310.569l99.285 67.064 89.706-60.947-188.991-6.117",
    stroke: "url(#prefix__paint325_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M271.842 226.635L483.369 46.037 610.24 83.274l-76.792 64.442-50.079-101.679-51.827 98.639 178.698 82.529-105.099 57.261 28.307-136.75-118.017 169.845-143.589-90.926zm0 0l46.204 103.997 64.252-90.926",
    stroke: "url(#prefix__paint326_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0 272.953l116.27-46.318-103.351 132 98.107 26.825 83.896-15.198 35.033 36.971 82.377 126.756 128.694-112.812",
    stroke: "url(#prefix__paint327_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M194.923 370.262l21.734-69.762",
    stroke: "url(#prefix__paint328_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.41 395.036l117.07-21.772 74.05 62.39-63.91 140.245-113-74.207-14.21-106.656zm0 0l-76.26-17.403",
    stroke: "url(#prefix__paint329_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.37 301.867l38.83 51.486-59.73 19.91-102.85 128.428 176.91-66.038",
    stroke: "url(#prefix__paint330_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M312.335 533.989l-60.301 63.986-22.076-190.743",
    stroke: "url(#prefix__paint331_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M188.134 189.093l-59.465-33.855",
    stroke: "url(#prefix__paint332_linear_6821_29592)",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M696.338 8.479a4.24 4.24 0 100-8.48 4.24 4.24 0 000 8.48zM483.311 49.814a4.24 4.24 0 10.001-8.479 4.24 4.24 0 00-.001 8.479zM360.369 92.209a4.24 4.24 0 11-8.479 0 4.24 4.24 0 018.479 0zm-136.727 29.676a4.24 4.24 0 100-8.478 4.24 4.24 0 000 8.478zm-94.33 38.156a4.24 4.24 0 100-8.48 4.24 4.24 0 000 8.48zM594.596 45.575a4.24 4.24 0 11-8.479 0 4.24 4.24 0 018.479 0zm279.808-5.3a4.24 4.24 0 11-8.479 0 4.24 4.24 0 018.479 0zm150.506 67.832a4.24 4.24 0 000-8.48 4.24 4.24 0 000 8.48zm107.04 22.257a4.24 4.24 0 01-8.48 0 4.24 4.24 0 018.48 0zm113.41 50.874c2.34 0 4.23-1.898 4.23-4.239 0-2.342-1.89-4.24-4.23-4.24a4.234 4.234 0 00-4.24 4.24 4.234 4.234 0 004.24 4.239zm-1.98 170.66a4.24 4.24 0 01-8.48 0 4.24 4.24 0 018.48 0zm10.77 88.556a4.24 4.24 0 10-4.24-4.24 4.24 4.24 0 004.24 4.24z",
    fill: "url(#prefix__paint333_linear_6821_29592)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_6821_29592",
    x1: 349.416,
    y1: 85.098,
    x2: 682.018,
    y2: 89.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_6821_29592",
    x1: 534.99,
    y1: 238.186,
    x2: 652.525,
    y2: 239.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear_6821_29592",
    x1: 711.865,
    y1: 319.309,
    x2: 766.177,
    y2: 321.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear_6821_29592",
    x1: 754.297,
    y1: 196.01,
    x2: 1159.15,
    y2: 207.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear_6821_29592",
    x1: 418.574,
    y1: 273.674,
    x2: 637.151,
    y2: 293.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint5_linear_6821_29592",
    x1: 194.656,
    y1: 159.609,
    x2: 560.372,
    y2: 168.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint6_linear_6821_29592",
    x1: 780.411,
    y1: 218.656,
    x2: 1060.25,
    y2: 224.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint7_linear_6821_29592",
    x1: 115.287,
    y1: 268.24,
    x2: 137.123,
    y2: 268.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint8_linear_6821_29592",
    x1: 57.574,
    y1: 230.207,
    x2: 164.684,
    y2: 231.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint9_linear_6821_29592",
    x1: 101.987,
    y1: 304.641,
    x2: 122.997,
    y2: 304.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint10_linear_6821_29592",
    x1: 110.692,
    y1: 339.637,
    x2: 170.293,
    y2: 340.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint11_linear_6821_29592",
    x1: 144.238,
    y1: 323.867,
    x2: 174.756,
    y2: 324.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint12_linear_6821_29592",
    x1: 156.474,
    y1: 324.324,
    x2: 200.868,
    y2: 324.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint13_linear_6821_29592",
    x1: 194.512,
    y1: 245.139,
    x2: 247.072,
    y2: 245.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint14_linear_6821_29592",
    x1: 229.241,
    y1: 186.473,
    x2: 334.01,
    y2: 187.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint15_linear_6821_29592",
    x1: 290.687,
    y1: 157.063,
    x2: 373.551,
    y2: 158.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint16_linear_6821_29592",
    x1: 362.946,
    y1: 169.717,
    x2: 381.841,
    y2: 170.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint17_linear_6821_29592",
    x1: 162.823,
    y1: 192.666,
    x2: 238.219,
    y2: 193.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint18_linear_6821_29592",
    x1: 218.532,
    y1: 170.855,
    x2: 284.765,
    y2: 171.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint19_linear_6821_29592",
    x1: 281.523,
    y1: 147.602,
    x2: 336.414,
    y2: 148.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint20_linear_6821_29592",
    x1: 336.348,
    y1: 133.506,
    x2: 357.774,
    y2: 133.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint21_linear_6821_29592",
    x1: 356.384,
    y1: 130.504,
    x2: 382.239,
    y2: 131.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint22_linear_6821_29592",
    x1: 343.23,
    y1: 141.256,
    x2: 374.568,
    y2: 142.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint23_linear_6821_29592",
    x1: 367.558,
    y1: 101.664,
    x2: 419.678,
    y2: 102.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint24_linear_6821_29592",
    x1: 402.692,
    y1: 80.006,
    x2: 545.897,
    y2: 85.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint25_linear_6821_29592",
    x1: 423.333,
    y1: 106.566,
    x2: 455.611,
    y2: 106.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint26_linear_6821_29592",
    x1: 423.819,
    y1: 106.832,
    x2: 454.598,
    y2: 107.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint27_linear_6821_29592",
    x1: 486.023,
    y1: 97.713,
    x2: 514.425,
    y2: 98.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint28_linear_6821_29592",
    x1: 207.429,
    y1: 340.131,
    x2: 227.974,
    y2: 340.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint29_linear_6821_29592",
    x1: 239.918,
    y1: 315.053,
    x2: 264.416,
    y2: 315.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint30_linear_6821_29592",
    x1: 229.735,
    y1: 338.27,
    x2: 295.321,
    y2: 339.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint31_linear_6821_29592",
    x1: 229.735,
    y1: 351.492,
    x2: 250.553,
    y2: 351.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint32_linear_6821_29592",
    x1: 227.304,
    y1: 375.811,
    x2: 318.363,
    y2: 377.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint33_linear_6821_29592",
    x1: 281.377,
    y1: 403.129,
    x2: 300.7,
    y2: 403.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint34_linear_6821_29592",
    x1: 282.744,
    y1: 415.705,
    x2: 312.38,
    y2: 415.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint35_linear_6821_29592",
    x1: 306.027,
    y1: 482.467,
    x2: 359.382,
    y2: 483.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint36_linear_6821_29592",
    x1: 345.972,
    y1: 505.492,
    x2: 349.193,
    y2: 505.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint37_linear_6821_29592",
    x1: 314.01,
    y1: 402.33,
    x2: 367.605,
    y2: 402.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint38_linear_6821_29592",
    x1: 345.736,
    y1: 395.416,
    x2: 368.087,
    y2: 395.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint39_linear_6821_29592",
    x1: 268.417,
    y1: 294.877,
    x2: 328.629,
    y2: 295.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint40_linear_6821_29592",
    x1: 295.845,
    y1: 298.221,
    x2: 344.741,
    y2: 299.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint41_linear_6821_29592",
    x1: 358.399,
    y1: 295.066,
    x2: 418.933,
    y2: 296.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint42_linear_6821_29592",
    x1: 364.854,
    y1: 299.664,
    x2: 406.105,
    y2: 299.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint43_linear_6821_29592",
    x1: 319.101,
    y1: 339.674,
    x2: 404.398,
    y2: 340.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint44_linear_6821_29592",
    x1: 618.365,
    y1: 233.436,
    x2: 662.992,
    y2: 233.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint45_linear_6821_29592",
    x1: 640.713,
    y1: 252.701,
    x2: 759.512,
    y2: 254.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint46_linear_6821_29592",
    x1: 688.008,
    y1: 280.855,
    x2: 741.911,
    y2: 281.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint47_linear_6821_29592",
    x1: 730.751,
    y1: 218.656,
    x2: 804.718,
    y2: 220.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint48_linear_6821_29592",
    x1: 686.265,
    y1: 204.559,
    x2: 782.143,
    y2: 206.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint49_linear_6821_29592",
    x1: 506.203,
    y1: 154.328,
    x2: 708.036,
    y2: 158.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint50_linear_6821_29592",
    x1: 502.51,
    y1: 220.023,
    x2: 589.043,
    y2: 224.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint51_linear_6821_29592",
    x1: 588.546,
    y1: 215.539,
    x2: 616.481,
    y2: 216.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint52_linear_6821_29592",
    x1: 507.723,
    y1: 160.596,
    x2: 560.054,
    y2: 160.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint53_linear_6821_29592",
    x1: 760.666,
    y1: 182.711,
    x2: 831.864,
    y2: 184.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint54_linear_6821_29592",
    x1: 546.664,
    y1: 114.316,
    x2: 643.007,
    y2: 116.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint55_linear_6821_29592",
    x1: 614.073,
    y1: 85.135,
    x2: 703.276,
    y2: 88.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint56_linear_6821_29592",
    x1: 695.424,
    y1: 93.875,
    x2: 831.156,
    y2: 104.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint57_linear_6821_29592",
    x1: 839.464,
    y1: 99.574,
    x2: 998.555,
    y2: 105.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint58_linear_6821_29592",
    x1: 1097.09,
    y1: 181.494,
    x2: 1139.18,
    y2: 181.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint59_linear_6821_29592",
    x1: 827.647,
    y1: 95.66,
    x2: 1174.44,
    y2: 103.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint60_linear_6821_29592",
    x1: 1142.6,
    y1: 221.164,
    x2: 1167.44,
    y2: 221.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint61_linear_6821_29592",
    x1: 1159.74,
    y1: 240.883,
    x2: 1162.65,
    y2: 240.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint62_linear_6821_29592",
    x1: 1138.8,
    y1: 215.654,
    x2: 1171.8,
    y2: 216.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint63_linear_6821_29592",
    x1: 1024.35,
    y1: 203.344,
    x2: 1113.29,
    y2: 204.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint64_linear_6821_29592",
    x1: 1082.45,
    y1: 203.344,
    x2: 1117.15,
    y2: 203.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint65_linear_6821_29592",
    x1: 1007.61,
    y1: 210.639,
    x2: 1106.05,
    y2: 211.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint66_linear_6821_29592",
    x1: 1076.64,
    y1: 246.469,
    x2: 1092.35,
    y2: 246.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint67_linear_6821_29592",
    x1: 867.996,
    y1: 195.629,
    x2: 1078.31,
    y2: 202.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint68_linear_6821_29592",
    x1: 1133.22,
    y1: 272.611,
    x2: 1153.58,
    y2: 272.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint69_linear_6821_29592",
    x1: 795.616,
    y1: 169.348,
    x2: 952.359,
    y2: 172.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint70_linear_6821_29592",
    x1: 975.612,
    y1: 235.297,
    x2: 1092.71,
    y2: 238.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint71_linear_6821_29592",
    x1: 1003.27,
    y1: 292.445,
    x2: 1041.11,
    y2: 292.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint72_linear_6821_29592",
    x1: 1153.47,
    y1: 401.494,
    x2: 1201.08,
    y2: 401.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint73_linear_6821_29592",
    x1: 1189.35,
    y1: 446.748,
    x2: 1201.39,
    y2: 446.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint74_linear_6821_29592",
    x1: 615.817,
    y1: 85.174,
    x2: 668.087,
    y2: 86.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint75_linear_6821_29592",
    x1: 1053.62,
    y1: 412.781,
    x2: 1193.73,
    y2: 414.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint76_linear_6821_29592",
    x1: 1101.76,
    y1: 417.227,
    x2: 1186.87,
    y2: 417.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint77_linear_6821_29592",
    x1: 1180.06,
    y1: 610.135,
    x2: 1211.61,
    y2: 610.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint78_linear_6821_29592",
    x1: 1218.87,
    y1: 625.219,
    x2: 1234.85,
    y2: 625.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint79_linear_6821_29592",
    x1: 1057.57,
    y1: 330.061,
    x2: 1094.14,
    y2: 330.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint80_linear_6821_29592",
    x1: 973.977,
    y1: 138.559,
    x2: 1121.77,
    y2: 141.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint81_linear_6821_29592",
    x1: 90.287,
    y1: 219.303,
    x2: 204.456,
    y2: 220.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint82_linear_6821_29592",
    x1: 162.134,
    y1: 197.379,
    x2: 272.619,
    y2: 198.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint83_linear_6821_29592",
    x1: 202.262,
    y1: 187.271,
    x2: 251.563,
    y2: 187.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint84_linear_6821_29592",
    x1: 304.665,
    y1: 160.977,
    x2: 373.781,
    y2: 161.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint85_linear_6821_29592",
    x1: 426.064,
    y1: 97.789,
    x2: 486.55,
    y2: 98.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint86_linear_6821_29592",
    x1: 484.884,
    y1: 84.908,
    x2: 545.49,
    y2: 87.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint87_linear_6821_29592",
    x1: 143.187,
    y1: 300.805,
    x2: 163.622,
    y2: 300.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint88_linear_6821_29592",
    x1: 238.974,
    y1: 318.094,
    x2: 295.715,
    y2: 318.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint89_linear_6821_29592",
    x1: 318.267,
    y1: 294.764,
    x2: 419.465,
    y2: 296.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint90_linear_6821_29592",
    x1: 364.393,
    y1: 351.227,
    x2: 403.013,
    y2: 353.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint91_linear_6821_29592",
    x1: 279.207,
    y1: 290.963,
    x2: 366.428,
    y2: 291.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint92_linear_6821_29592",
    x1: 507.562,
    y1: 159.154,
    x2: 585.528,
    y2: 160.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint93_linear_6821_29592",
    x1: 583.667,
    y1: 162.535,
    x2: 665.157,
    y2: 165.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint94_linear_6821_29592",
    x1: 534.958,
    y1: 162.346,
    x2: 783.174,
    y2: 169.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint95_linear_6821_29592",
    x1: 705.794,
    y1: 171.996,
    x2: 727.567,
    y2: 172.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint96_linear_6821_29592",
    x1: 613.5,
    y1: 196.504,
    x2: 687.187,
    y2: 196.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint97_linear_6821_29592",
    x1: 636.64,
    y1: 242.67,
    x2: 756.46,
    y2: 246.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint98_linear_6821_29592",
    x1: 681.635,
    y1: 256.768,
    x2: 754.091,
    y2: 257.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint99_linear_6821_29592",
    x1: 586.743,
    y1: 124.615,
    x2: 678.731,
    y2: 129.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint100_linear_6821_29592",
    x1: 676.537,
    y1: 106.795,
    x2: 763.234,
    y2: 109.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint101_linear_6821_29592",
    x1: 748.076,
    y1: 93.686,
    x2: 859.547,
    y2: 96.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint102_linear_6821_29592",
    x1: 795.885,
    y1: 136.432,
    x2: 911.333,
    y2: 139.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint103_linear_6821_29592",
    x1: 733.912,
    y1: 98.055,
    x2: 1027.93,
    y2: 104.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint104_linear_6821_29592",
    x1: 906.872,
    y1: 169.488,
    x2: 1078.56,
    y2: 172.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint105_linear_6821_29592",
    x1: 972.223,
    y1: 152.352,
    x2: 1150.6,
    y2: 157.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint106_linear_6821_29592",
    x1: 974.434,
    y1: 234.082,
    x2: 1093.48,
    y2: 236.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint107_linear_6821_29592",
    x1: 1058.74,
    y1: 327.516,
    x2: 1081.74,
    y2: 327.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint108_linear_6821_29592",
    x1: 1080.59,
    y1: 342.83,
    x2: 1091.59,
    y2: 342.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint109_linear_6821_29592",
    x1: 1056.61,
    y1: 411.338,
    x2: 1143.4,
    y2: 412.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint110_linear_6821_29592",
    x1: 1094.31,
    y1: 445.801,
    x2: 1166.15,
    y2: 446.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint111_linear_6821_29592",
    x1: 1108.45,
    y1: 462.898,
    x2: 1193.7,
    y2: 464.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint112_linear_6821_29592",
    x1: 1164.57,
    y1: 518.107,
    x2: 1183.74,
    y2: 518.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint113_linear_6821_29592",
    x1: 765.789,
    y1: 292.408,
    x2: 785.418,
    y2: 292.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint114_linear_6821_29592",
    x1: 783.954,
    y1: 294.84,
    x2: 800.934,
    y2: 295.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint115_linear_6821_29592",
    x1: 1167.18,
    y1: 405.713,
    x2: 1180.18,
    y2: 405.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint116_linear_6821_29592",
    x1: 1179.42,
    y1: 429.232,
    x2: 1202.03,
    y2: 429.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint117_linear_6821_29592",
    x1: 158.519,
    y1: 297.104,
    x2: 167.239,
    y2: 297.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint118_linear_6821_29592",
    x1: 237.704,
    y1: 241.584,
    x2: 246.768,
    y2: 241.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint119_linear_6821_29592",
    x1: 190.555,
    y1: 297.408,
    x2: 199.418,
    y2: 297.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint120_linear_6821_29592",
    x1: 139.531,
    y1: 366.957,
    x2: 148.005,
    y2: 367.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint121_linear_6821_29592",
    x1: 289.841,
    y1: 334.115,
    x2: 299.042,
    y2: 334.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint122_linear_6821_29592",
    x1: 413.552,
    y1: 291.664,
    x2: 423.25,
    y2: 291.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint123_linear_6821_29592",
    x1: 314.24,
    y1: 356.582,
    x2: 323.483,
    y2: 356.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint124_linear_6821_29592",
    x1: 275.664,
    y1: 408.664,
    x2: 284.614,
    y2: 408.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint125_linear_6821_29592",
    x1: 358.607,
    y1: 352.17,
    x2: 368.004,
    y2: 352.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint126_linear_6821_29592",
    x1: 313.733,
    y1: 412.148,
    x2: 322.769,
    y2: 412.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint127_linear_6821_29592",
    x1: 339.871,
    y1: 421.35,
    x2: 348.951,
    y2: 421.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint128_linear_6821_29592",
    x1: 299.635,
    y1: 491.758,
    x2: 308.297,
    y2: 491.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint129_linear_6821_29592",
    x1: 396.955,
    y1: 348.238,
    x2: 406.466,
    y2: 348.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint130_linear_6821_29592",
    x1: 343.491,
    y1: 288.842,
    x2: 352.961,
    y2: 288.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint131_linear_6821_29592",
    x1: 578.965,
    y1: 181.283,
    x2: 588.932,
    y2: 181.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint132_linear_6821_29592",
    x1: 530.63,
    y1: 234.59,
    x2: 540.558,
    y2: 234.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint133_linear_6821_29592",
    x1: 609.921,
    y1: 194.088,
    x2: 619.925,
    y2: 194.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint134_linear_6821_29592",
    x1: 680.679,
    y1: 240.504,
    x2: 690.684,
    y2: 240.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint135_linear_6821_29592",
    x1: 677.56,
    y1: 297.232,
    x2: 687.491,
    y2: 297.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint136_linear_6821_29592",
    x1: 779.583,
    y1: 299.895,
    x2: 789.403,
    y2: 300.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint137_linear_6821_29592",
    x1: 767.725,
    y1: 289.422,
    x2: 777.58,
    y2: 289.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint138_linear_6821_29592",
    x1: 761.642,
    y1: 316.287,
    x2: 771.459,
    y2: 316.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint139_linear_6821_29592",
    x1: 795.504,
    y1: 291.998,
    x2: 805.321,
    y2: 292.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint140_linear_6821_29592",
    x1: 706.429,
    y1: 327.961,
    x2: 716.284,
    y2: 328.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint141_linear_6821_29592",
    x1: 748.076,
    y1: 254.18,
    x2: 758.006,
    y2: 254.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint142_linear_6821_29592",
    x1: 647.161,
    y1: 329.793,
    x2: 657.014,
    y2: 329.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint143_linear_6821_29592",
    x1: 631.586,
    y1: 270.287,
    x2: 641.553,
    y2: 270.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint144_linear_6821_29592",
    x1: 613.693,
    y1: 226.188,
    x2: 623.699,
    y2: 226.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint145_linear_6821_29592",
    x1: 701.381,
    y1: 183.961,
    x2: 711.348,
    y2: 184.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint146_linear_6821_29592",
    x1: 730.261,
    y1: 166.813,
    x2: 740.188,
    y2: 166.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint147_linear_6821_29592",
    x1: 802.041,
    y1: 156.771,
    x2: 811.815,
    y2: 156.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint148_linear_6821_29592",
    x1: 732.35,
    y1: 126.344,
    x2: 742.161,
    y2: 126.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint149_linear_6821_29592",
    x1: 672.349,
    y1: 123.512,
    x2: 682.2,
    y2: 123.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint150_linear_6821_29592",
    x1: 596.549,
    y1: 134.391,
    x2: 606.402,
    y2: 134.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint151_linear_6821_29592",
    x1: 675.624,
    y1: 105.463,
    x2: 685.398,
    y2: 105.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint152_linear_6821_29592",
    x1: 582.978,
    y1: 124.129,
    x2: 592.793,
    y2: 124.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint153_linear_6821_29592",
    x1: 791.217,
    y1: 134.857,
    x2: 800.952,
    y2: 135.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint154_linear_6821_29592",
    x1: 756.74,
    y1: 107.016,
    x2: 766.435,
    y2: 107.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint155_linear_6821_29592",
    x1: 852.194,
    y1: 122.221,
    x2: 861.777,
    y2: 122.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint156_linear_6821_29592",
    x1: 902.647,
    y1: 167.537,
    x2: 912.231,
    y2: 167.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint157_linear_6821_29592",
    x1: 969.337,
    y1: 150.166,
    x2: 978.655,
    y2: 150.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint158_linear_6821_29592",
    x1: 1077.54,
    y1: 199.82,
    x2: 1086.52,
    y2: 199.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint159_linear_6821_29592",
    x1: 1144.53,
    y1: 205.785,
    x2: 1153.17,
    y2: 205.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint160_linear_6821_29592",
    x1: 1019.8,
    y1: 206.857,
    x2: 1029,
    y2: 206.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint161_linear_6821_29592",
    x1: 1072.39,
    y1: 242.889,
    x2: 1081.4,
    y2: 242.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint162_linear_6821_29592",
    x1: 1048.97,
    y1: 156.322,
    x2: 1057.99,
    y2: 156.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint163_linear_6821_29592",
    x1: 1084.96,
    y1: 194.996,
    x2: 1093.9,
    y2: 195.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint164_linear_6821_29592",
    x1: 809.142,
    y1: 95.656,
    x2: 818.722,
    y2: 95.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint165_linear_6821_29592",
    x1: 920.736,
    y1: 111.396,
    x2: 930.092,
    y2: 111.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint166_linear_6821_29592",
    x1: 743.869,
    y1: 91.82,
    x2: 753.564,
    y2: 92.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint167_linear_6821_29592",
    x1: 659.703,
    y1: 136.924,
    x2: 669.593,
    y2: 137.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint168_linear_6821_29592",
    x1: 775.479,
    y1: 215.963,
    x2: 785.407,
    y2: 216.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint169_linear_6821_29592",
    x1: 862.986,
    y1: 192.49,
    x2: 872.684,
    y2: 192.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint170_linear_6821_29592",
    x1: 972.381,
    y1: 232.887,
    x2: 981.811,
    y2: 233.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint171_linear_6821_29592",
    x1: 1087.85,
    y1: 270.189,
    x2: 1096.78,
    y2: 270.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint172_linear_6821_29592",
    x1: 1051.26,
    y1: 288.947,
    x2: 1060.3,
    y2: 289.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint173_linear_6821_29592",
    x1: 1054.52,
    y1: 336.193,
    x2: 1063.5,
    y2: 336.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint174_linear_6821_29592",
    x1: 1088.18,
    y1: 349.373,
    x2: 1096.97,
    y2: 349.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint175_linear_6821_29592",
    x1: 1071.62,
    y1: 323.926,
    x2: 1080.52,
    y2: 324.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint176_linear_6821_29592",
    x1: 1075.49,
    y1: 338.32,
    x2: 1084.39,
    y2: 338.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint177_linear_6821_29592",
    x1: 1167.5,
    y1: 431.01,
    x2: 1175.68,
    y2: 431.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint178_linear_6821_29592",
    x1: 1122.67,
    y1: 420.764,
    x2: 1131.08,
    y2: 420.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint179_linear_6821_29592",
    x1: 1090.61,
    y1: 441.105,
    x2: 1099.1,
    y2: 441.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint180_linear_6821_29592",
    x1: 1104.43,
    y1: 472.938,
    x2: 1112.73,
    y2: 473.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint181_linear_6821_29592",
    x1: 1063.9,
    y1: 455.621,
    x2: 1072.41,
    y2: 455.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint182_linear_6821_29592",
    x1: 1052.57,
    y1: 406.871,
    x2: 1061.36,
    y2: 406.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint183_linear_6821_29592",
    x1: 1197.82,
    y1: 443.068,
    x2: 1205.77,
    y2: 443.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint184_linear_6821_29592",
    x1: 1159.21,
    y1: 458.834,
    x2: 1167.3,
    y2: 458.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint185_linear_6821_29592",
    x1: 1137.88,
    y1: 462.172,
    x2: 1146.03,
    y2: 462.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint186_linear_6821_29592",
    x1: 1161.05,
    y1: 512.84,
    x2: 1168.9,
    y2: 512.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint187_linear_6821_29592",
    x1: 1132.08,
    y1: 527.662,
    x2: 1140.01,
    y2: 527.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint188_linear_6821_29592",
    x1: 1179.5,
    y1: 538.715,
    x2: 1187.14,
    y2: 538.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint189_linear_6821_29592",
    x1: 1189.47,
    y1: 505.494,
    x2: 1197.2,
    y2: 505.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint190_linear_6821_29592",
    x1: 1163.6,
    y1: 401.336,
    x2: 1171.86,
    y2: 401.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint191_linear_6821_29592",
    x1: 1175.41,
    y1: 425.041,
    x2: 1183.54,
    y2: 425.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint192_linear_6821_29592",
    x1: 659.358,
    y1: 160.559,
    x2: 669.288,
    y2: 160.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint193_linear_6821_29592",
    x1: 502.856,
    y1: 204.764,
    x2: 512.711,
    y2: 204.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint194_linear_6821_29592",
    x1: 552.813,
    y1: 157.549,
    x2: 562.706,
    y2: 157.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint195_linear_6821_29592",
    x1: 262.515,
    y1: 314.727,
    x2: 271.647,
    y2: 314.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint196_linear_6821_29592",
    x1: 234.944,
    y1: 393.037,
    x2: 243.788,
    y2: 393.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint197_linear_6821_29592",
    x1: 103.925,
    y1: 349.24,
    x2: 112.29,
    y2: 349.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint198_linear_6821_29592",
    x1: 129.337,
    y1: 287.074,
    x2: 137.909,
    y2: 287.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint199_linear_6821_29592",
    x1: 198.296,
    y1: 233.551,
    x2: 207.179,
    y2: 233.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint200_linear_6821_29592",
    x1: 246.208,
    y1: 184.225,
    x2: 255.282,
    y2: 184.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint201_linear_6821_29592",
    x1: 265.583,
    y1: 194.613,
    x2: 274.767,
    y2: 194.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint202_linear_6821_29592",
    x1: 368.34,
    y1: 158.604,
    x2: 377.824,
    y2: 158.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint203_linear_6821_29592",
    x1: 435.592,
    y1: 95.805,
    x2: 445.075,
    y2: 95.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint204_linear_6821_29592",
    x1: 240.475,
    y1: 225.863,
    x2: 249.577,
    y2: 225.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint205_linear_6821_29592",
    x1: 266.088,
    y1: 235.656,
    x2: 275.301,
    y2: 235.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint206_linear_6821_29592",
    x1: 300.592,
    y1: 208.297,
    x2: 309.92,
    y2: 208.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint207_linear_6821_29592",
    x1: 312.359,
    y1: 173.736,
    x2: 321.657,
    y2: 173.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint208_linear_6821_29592",
    x1: 421.766,
    y1: 130.164,
    x2: 431.322,
    y2: 130.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint209_linear_6821_29592",
    x1: 538.759,
    y1: 83.285,
    x2: 548.346,
    y2: 83.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint210_linear_6821_29592",
    x1: 480.2,
    y1: 96.717,
    x2: 489.794,
    y2: 96.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint211_linear_6821_29592",
    x1: 112.079,
    y1: 276.256,
    x2: 120.542,
    y2: 276.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint212_linear_6821_29592",
    x1: 178.417,
    y1: 216.391,
    x2: 187.191,
    y2: 216.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint213_linear_6821_29592",
    x1: 86.522,
    y1: 280.434,
    x2: 94.884,
    y2: 280.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint214_linear_6821_29592",
    x1: 217.369,
    y1: 287.695,
    x2: 262.106,
    y2: 288.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint215_linear_6821_29592",
    x1: 243.405,
    y1: 273.979,
    x2: 256.363,
    y2: 274.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint216_linear_6821_29592",
    x1: 255.372,
    y1: 276.828,
    x2: 261.544,
    y2: 276.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint217_linear_6821_29592",
    x1: 255.481,
    y1: 279.982,
    x2: 262.535,
    y2: 280.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint218_linear_6821_29592",
    x1: 256.891,
    y1: 281.578,
    x2: 265.861,
    y2: 281.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint219_linear_6821_29592",
    x1: 238.914,
    y1: 299.096,
    x2: 251.181,
    y2: 299.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint220_linear_6821_29592",
    x1: 255.33,
    y1: 281.502,
    x2: 283.734,
    y2: 281.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint221_linear_6821_29592",
    x1: 284.635,
    y1: 277.322,
    x2: 296.939,
    y2: 277.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint222_linear_6821_29592",
    x1: 343.298,
    y1: 304.68,
    x2: 353.61,
    y2: 304.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint223_linear_6821_29592",
    x1: 352.799,
    y1: 304.676,
    x2: 362.037,
    y2: 304.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint224_linear_6821_29592",
    x1: 63.294,
    y1: 321.057,
    x2: 68.393,
    y2: 321.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint225_linear_6821_29592",
    x1: 66.976,
    y1: 317.6,
    x2: 72.037,
    y2: 317.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint226_linear_6821_29592",
    x1: 120.099,
    y1: 278.234,
    x2: 128.418,
    y2: 278.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint227_linear_6821_29592",
    x1: 119.838,
    y1: 281.654,
    x2: 127.467,
    y2: 281.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint228_linear_6821_29592",
    x1: 305.263,
    y1: 272.877,
    x2: 318.183,
    y2: 272.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint229_linear_6821_29592",
    x1: 317.533,
    y1: 276.715,
    x2: 324.741,
    y2: 276.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint230_linear_6821_29592",
    x1: 299.599,
    y1: 271.547,
    x2: 310.409,
    y2: 271.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint231_linear_6821_29592",
    x1: 309.669,
    y1: 268.355,
    x2: 316.723,
    y2: 268.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint232_linear_6821_29592",
    x1: 297.582,
    y1: 271.51,
    x2: 304.137,
    y2: 271.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint233_linear_6821_29592",
    x1: 357.014,
    y1: 166.828,
    x2: 384.458,
    y2: 167.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint234_linear_6821_29592",
    x1: 37.308,
    y1: 145.17,
    x2: 425.96,
    y2: 148.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint235_linear_6821_29592",
    x1: 222.121,
    y1: 160.9,
    x2: 286.092,
    y2: 161.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint236_linear_6821_29592",
    x1: 288.883,
    y1: 147.906,
    x2: 313.144,
    y2: 148.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint237_linear_6821_29592",
    x1: 312.061,
    y1: 142.359,
    x2: 328.467,
    y2: 142.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint238_linear_6821_29592",
    x1: 322.935,
    y1: 129.25,
    x2: 390.977,
    y2: 130.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint239_linear_6821_29592",
    x1: 332.654,
    y1: 126.287,
    x2: 370.396,
    y2: 127.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint240_linear_6821_29592",
    x1: 344.173,
    y1: 120.092,
    x2: 363.796,
    y2: 120.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint241_linear_6821_29592",
    x1: 349.967,
    y1: 96.383,
    x2: 436.782,
    y2: 98.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint242_linear_6821_29592",
    x1: 400.059,
    y1: 75.637,
    x2: 569.519,
    y2: 80.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint243_linear_6821_29592",
    x1: 512.645,
    y1: 95.129,
    x2: 521.727,
    y2: 95.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint244_linear_6821_29592",
    x1: 515.646,
    y1: 100.449,
    x2: 551.249,
    y2: 101.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint245_linear_6821_29592",
    x1: 465.144,
    y1: 216.148,
    x2: 475.454,
    y2: 216.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint246_linear_6821_29592",
    x1: 472.449,
    y1: 218.01,
    x2: 478.046,
    y2: 218.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint247_linear_6821_29592",
    x1: 478.109,
    y1: 216.719,
    x2: 483.744,
    y2: 216.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint248_linear_6821_29592",
    x1: 472.975,
    y1: 219.529,
    x2: 483.401,
    y2: 219.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint249_linear_6821_29592",
    x1: 765.02,
    y1: 282.225,
    x2: 801.977,
    y2: 282.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint250_linear_6821_29592",
    x1: 765.323,
    y1: 278.5,
    x2: 778.163,
    y2: 278.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint251_linear_6821_29592",
    x1: 825.618,
    y1: 267.064,
    x2: 832.863,
    y2: 267.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint252_linear_6821_29592",
    x1: 825.286,
    y1: 312.014,
    x2: 833.911,
    y2: 312.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint253_linear_6821_29592",
    x1: 895.758,
    y1: 254.771,
    x2: 906.039,
    y2: 254.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint254_linear_6821_29592",
    x1: 932.768,
    y1: 254.752,
    x2: 945.189,
    y2: 254.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint255_linear_6821_29592",
    x1: 605.32,
    y1: 237.807,
    x2: 613.293,
    y2: 237.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint256_linear_6821_29592",
    x1: 608.662,
    y1: 234.576,
    x2: 616.29,
    y2: 234.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint257_linear_6821_29592",
    x1: 617.971,
    y1: 140.84,
    x2: 624.987,
    y2: 140.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint258_linear_6821_29592",
    x1: 618.05,
    y1: 136.545,
    x2: 626.166,
    y2: 136.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint259_linear_6821_29592",
    x1: 678.425,
    y1: 151.289,
    x2: 698.768,
    y2: 152.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint260_linear_6821_29592",
    x1: 639.329,
    y1: 150.453,
    x2: 646.189,
    y2: 150.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint261_linear_6821_29592",
    x1: 588.485,
    y1: 144.676,
    x2: 600.212,
    y2: 144.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint262_linear_6821_29592",
    x1: 599.962,
    y1: 143.461,
    x2: 606.362,
    y2: 143.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint263_linear_6821_29592",
    x1: 567.252,
    y1: 110.859,
    x2: 597.304,
    y2: 111.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint264_linear_6821_29592",
    x1: 549.612,
    y1: 117.129,
    x2: 569.816,
    y2: 117.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint265_linear_6821_29592",
    x1: 631.233,
    y1: 91.481,
    x2: 697.557,
    y2: 93.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint266_linear_6821_29592",
    x1: 501.168,
    y1: 84.107,
    x2: 1206.26,
    y2: 100.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint267_linear_6821_29592",
    x1: 1000.71,
    y1: 289.178,
    x2: 1045.27,
    y2: 289.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint268_linear_6821_29592",
    x1: 1040.44,
    y1: 344.434,
    x2: 1080.56,
    y2: 344.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint269_linear_6821_29592",
    x1: 1055.12,
    y1: 326.148,
    x2: 1097.29,
    y2: 326.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint270_linear_6821_29592",
    x1: 1048.36,
    y1: 270.748,
    x2: 1059.25,
    y2: 270.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint271_linear_6821_29592",
    x1: 1091.41,
    y1: 279.107,
    x2: 1101.79,
    y2: 279.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint272_linear_6821_29592",
    x1: 1117.1,
    y1: 268.432,
    x2: 1128.17,
    y2: 268.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint273_linear_6821_29592",
    x1: 1119.75,
    y1: 263.871,
    x2: 1155.55,
    y2: 264.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint274_linear_6821_29592",
    x1: 1131.68,
    y1: 248.064,
    x2: 1154.11,
    y2: 248.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint275_linear_6821_29592",
    x1: 1044.67,
    y1: 409.84,
    x2: 1200.47,
    y2: 411.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint276_linear_6821_29592",
    x1: 1123.9,
    y1: 535.736,
    x2: 1140.49,
    y2: 535.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint277_linear_6821_29592",
    x1: 1174.44,
    y1: 606.904,
    x2: 1215.65,
    y2: 607.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint278_linear_6821_29592",
    x1: 1216.04,
    y1: 610.971,
    x2: 1240.38,
    y2: 611.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint279_linear_6821_29592",
    x1: 1237.16,
    y1: 538.512,
    x2: 1248.93,
    y2: 538.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint280_linear_6821_29592",
    x1: 1254.54,
    y1: 538.662,
    x2: 1263.7,
    y2: 538.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint281_linear_6821_29592",
    x1: 1283.86,
    y1: 583.232,
    x2: 1296.55,
    y2: 583.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint282_linear_6821_29592",
    x1: 1268.93,
    y1: 490.482,
    x2: 1275.1,
    y2: 490.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint283_linear_6821_29592",
    x1: 1292.03,
    y1: 508.035,
    x2: 1298.09,
    y2: 508.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint284_linear_6821_29592",
    x1: 1288.38,
    y1: 479.615,
    x2: 1294.37,
    y2: 479.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint285_linear_6821_29592",
    x1: 1239.23,
    y1: 432.273,
    x2: 1245.54,
    y2: 432.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint286_linear_6821_29592",
    x1: 1299.78,
    y1: 565.031,
    x2: 1305.87,
    y2: 565.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint287_linear_6821_29592",
    x1: 1312.09,
    y1: 612.6,
    x2: 1318.19,
    y2: 612.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint288_linear_6821_29592",
    x1: 1299.25,
    y1: 619.635,
    x2: 1305.46,
    y2: 619.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint289_linear_6821_29592",
    x1: 1306.21,
    y1: 614.049,
    x2: 1313.84,
    y2: 614.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint290_linear_6821_29592",
    x1: 1317.99,
    y1: 611.617,
    x2: 1325.16,
    y2: 611.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint291_linear_6821_29592",
    x1: 1153.31,
    y1: 364.678,
    x2: 1160.59,
    y2: 364.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint292_linear_6821_29592",
    x1: 1234.77,
    y1: 494.359,
    x2: 1245.85,
    y2: 494.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint293_linear_6821_29592",
    x1: 1143.24,
    y1: 387.361,
    x2: 1213.36,
    y2: 387.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint294_linear_6821_29592",
    x1: 1205.17,
    y1: 446.713,
    x2: 1224.83,
    y2: 446.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint295_linear_6821_29592",
    x1: 1224.02,
    y1: 464.873,
    x2: 1235.98,
    y2: 464.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint296_linear_6821_29592",
    x1: 1235.23,
    y1: 485.885,
    x2: 1241.52,
    y2: 485.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint297_linear_6821_29592",
    x1: 1082.9,
    y1: 372.428,
    x2: 1095.39,
    y2: 372.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint298_linear_6821_29592",
    x1: 1089.85,
    y1: 381.471,
    x2: 1102.12,
    y2: 381.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint299_linear_6821_29592",
    x1: 1097.33,
    y1: 382.383,
    x2: 1109.52,
    y2: 382.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint300_linear_6821_29592",
    x1: 1107.71,
    y1: 392.529,
    x2: 1126.8,
    y2: 392.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint301_linear_6821_29592",
    x1: 1092.1,
    y1: 353.164,
    x2: 1123.49,
    y2: 353.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint302_linear_6821_29592",
    x1: 1125.34,
    y1: 366.881,
    x2: 1137.36,
    y2: 366.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint303_linear_6821_29592",
    x1: 1130.13,
    y1: 383.334,
    x2: 1142.74,
    y2: 383.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint304_linear_6821_29592",
    x1: 1088.71,
    y1: 320.146,
    x2: 1099.68,
    y2: 320.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint305_linear_6821_29592",
    x1: 1096.8,
    y1: 298.943,
    x2: 1117.08,
    y2: 299.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint306_linear_6821_29592",
    x1: 1108.81,
    y1: 335.723,
    x2: 1129.17,
    y2: 335.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint307_linear_6821_29592",
    x1: 1105.84,
    y1: 323.146,
    x2: 1116.58,
    y2: 323.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint308_linear_6821_29592",
    x1: 1114.09,
    y1: 327.021,
    x2: 1126.85,
    y2: 327.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint309_linear_6821_29592",
    x1: 188.137,
    y1: 117.242,
    x2: 272.595,
    y2: 117.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint310_linear_6821_29592",
    x1: 356.189,
    y1: 92.43,
    x2: 432.215,
    y2: 92.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint311_linear_6821_29592",
    x1: 431.541,
    y1: 46.035,
    x2: 784.689,
    y2: 57.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint312_linear_6821_29592",
    x1: 533.443,
    y1: 83.273,
    x2: 706.373,
    y2: 85.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint313_linear_6821_29592",
    x1: 140.45,
    y1: 92.43,
    x2: 1135.43,
    y2: 121.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint314_linear_6821_29592",
    x1: 271.842,
    y1: 144.676,
    x2: 535.734,
    y2: 149.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint315_linear_6821_29592",
    x1: 533.443,
    y1: 46.037,
    x2: 591.641,
    y2: 46.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint316_linear_6821_29592",
    x1: 610.234,
    y1: 4.24,
    x2: 697.072,
    y2: 4.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint317_linear_6821_29592",
    x1: 610.234,
    y1: 40.603,
    x2: 1028.94,
    y2: 51.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint318_linear_6821_29592",
    x1: 921.845,
    y1: 104.172,
    x2: 1203.86,
    y2: 107.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint319_linear_6821_29592",
    x1: 607.577,
    y1: 4.24,
    x2: 1081.02,
    y2: 10.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint320_linear_6821_29592",
    x1: 704.847,
    y1: 77.385,
    x2: 1028.31,
    y2: 81.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint321_linear_6821_29592",
    x1: 610.234,
    y1: 176.555,
    x2: 755.263,
    y2: 177.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint322_linear_6821_29592",
    x1: 441.038,
    y1: 284.465,
    x2: 732.772,
    y2: 290.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint323_linear_6821_29592",
    x1: 111.036,
    y1: 155.238,
    x2: 443.973,
    y2: 158.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint324_linear_6821_29592",
    x1: 216.662,
    y1: 300.5,
    x2: 442.993,
    y2: 304.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint325_linear_6821_29592",
    x1: 887.869,
    y1: 176.555,
    x2: 1248.93,
    y2: 182.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint326_linear_6821_29592",
    x1: 271.842,
    y1: 46.037,
    x2: 613.254,
    y2: 49.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint327_linear_6821_29592",
    x1: 0,
    y1: 226.635,
    x2: 444.932,
    y2: 232.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint328_linear_6821_29592",
    x1: 194.923,
    y1: 300.5,
    x2: 216.853,
    y2: 300.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint329_linear_6821_29592",
    x1: 987.15,
    y1: 373.264,
    x2: 1256.91,
    y2: 376.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint330_linear_6821_29592",
    x1: 1077.62,
    y1: 301.867,
    x2: 1256.11,
    y2: 303.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint331_linear_6821_29592",
    x1: 229.958,
    y1: 407.232,
    x2: 313.077,
    y2: 407.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint332_linear_6821_29592",
    x1: 128.669,
    y1: 155.238,
    x2: 188.655,
    y2: 156.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint333_linear_6821_29592",
    x1: 125.073,
    y1: 0,
    x2: 1268,
    y2: 26.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldMapOutlinemin);
export default __webpack_public_path__ + "static/media/world-map-outline.min.19fe4f15d8d21ceade7ba2324791defc.svg";
export { ForwardRef as ReactComponent };